var Dd = function(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, a = e.length, s; n < a; n++)
    (s || !(n in e)) && (s || (s = Array.prototype.slice.call(e, 0, n)), s[n] = e[n]);
  return t.concat(s || Array.prototype.slice.call(e));
};
function Hd(t) {
  return t;
}
function Ie(t, e, r, n, a, s, i, o, l) {
  switch (arguments.length) {
    case 1:
      return t;
    case 2:
      return function() {
        return e(t.apply(this, arguments));
      };
    case 3:
      return function() {
        return r(e(t.apply(this, arguments)));
      };
    case 4:
      return function() {
        return n(r(e(t.apply(this, arguments))));
      };
    case 5:
      return function() {
        return a(n(r(e(t.apply(this, arguments)))));
      };
    case 6:
      return function() {
        return s(a(n(r(e(t.apply(this, arguments))))));
      };
    case 7:
      return function() {
        return i(s(a(n(r(e(t.apply(this, arguments)))))));
      };
    case 8:
      return function() {
        return o(i(s(a(n(r(e(t.apply(this, arguments))))))));
      };
    case 9:
      return function() {
        return l(o(i(s(a(n(r(e(t.apply(this, arguments)))))))));
      };
  }
}
function T(t, e, r, n, a, s, i, o, l) {
  switch (arguments.length) {
    case 1:
      return t;
    case 2:
      return e(t);
    case 3:
      return r(e(t));
    case 4:
      return n(r(e(t)));
    case 5:
      return a(n(r(e(t))));
    case 6:
      return s(a(n(r(e(t)))));
    case 7:
      return i(s(a(n(r(e(t))))));
    case 8:
      return o(i(s(a(n(r(e(t)))))));
    case 9:
      return l(o(i(s(a(n(r(e(t))))))));
    default: {
      for (var c = arguments[0], h = 1; h < arguments.length; h++)
        c = arguments[h](c);
      return c;
    }
  }
}
var Ld = function(t, e) {
  var r = function(n) {
    return n.length >= t;
  };
  return function() {
    var n = Array.from(arguments);
    return r(arguments) ? e.apply(this, n) : function(a) {
      return e.apply(void 0, Dd([a], n, !1));
    };
  };
}, Ud = function(t) {
  return {
    equals: function(e, r) {
      return e === r || t(e, r);
    }
  };
}, Bd = function(t) {
  return Ud(function(e, r) {
    for (var n in t)
      if (!t[n].equals(e[n], r[n]))
        return !1;
    return !0;
  });
}, tc = function(t) {
  return t._tag === "Some";
}, rc = { _tag: "None" }, nc = function(t) {
  return { _tag: "Some", value: t };
}, Gd = function(t) {
  return t._tag === "Left";
}, Kd = function(t) {
  return t._tag === "Right";
}, Fd = function(t) {
  return { _tag: "Left", left: t };
}, Zd = function(t) {
  return { _tag: "Right", right: t };
}, Wd = function(t) {
  return [t];
}, Jd = [], zd = Object.prototype.hasOwnProperty, Qd = function(t) {
  return function(e) {
    return function(r) {
      return r.reduce(function(n, a) {
        return t.concat(n, a);
      }, e);
    };
  };
}, Yd = function(t) {
  return {
    concat: function(e, r) {
      var n = {};
      for (var a in t)
        zd.call(t, a) && (n[a] = t[a].concat(e[a], r[a]));
      return n;
    }
  };
}, qr = function() {
  return { concat: Hd };
}, Xd = function() {
  return { concat: function(t, e) {
    return e;
  } };
}, ef = Qd, di = function(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, a = e.length, s; n < a; n++)
    (s || !(n in e)) && (s || (s = Array.prototype.slice.call(e, 0, n)), s[n] = e[n]);
  return t.concat(s || Array.prototype.slice.call(e));
}, tf = Jd, rf = function(t, e) {
  return t < 0 || t >= e.length;
}, nf = function(t) {
  return function(e) {
    return di(di([], e, !0), [t], !1);
  };
}, af = nf, sf = Wd, ve = {
  equals: function(t, e) {
    return t === e;
  }
}, of = {
  concat: function(t, e) {
    return t + e;
  }
}, uf = "", ps = {
  concat: of.concat,
  empty: uf
};
ve.equals;
var ac = function(t) {
  return t.trim();
}, sc = function(t) {
  return t.length === 0;
}, Dt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ic(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Vr, fi;
function cf() {
  if (fi) return Vr;
  fi = 1;
  function t() {
    this.__data__ = [], this.size = 0;
  }
  return Vr = t, Vr;
}
var Pr, hi;
function ys() {
  if (hi) return Pr;
  hi = 1;
  function t(e, r) {
    return e === r || e !== e && r !== r;
  }
  return Pr = t, Pr;
}
var Nr, pi;
function ir() {
  if (pi) return Nr;
  pi = 1;
  var t = ys();
  function e(r, n) {
    for (var a = r.length; a--; )
      if (t(r[a][0], n))
        return a;
    return -1;
  }
  return Nr = e, Nr;
}
var $r, yi;
function lf() {
  if (yi) return $r;
  yi = 1;
  var t = ir(), e = Array.prototype, r = e.splice;
  function n(a) {
    var s = this.__data__, i = t(s, a);
    if (i < 0)
      return !1;
    var o = s.length - 1;
    return i == o ? s.pop() : r.call(s, i, 1), --this.size, !0;
  }
  return $r = n, $r;
}
var Mr, mi;
function df() {
  if (mi) return Mr;
  mi = 1;
  var t = ir();
  function e(r) {
    var n = this.__data__, a = t(n, r);
    return a < 0 ? void 0 : n[a][1];
  }
  return Mr = e, Mr;
}
var jr, vi;
function ff() {
  if (vi) return jr;
  vi = 1;
  var t = ir();
  function e(r) {
    return t(this.__data__, r) > -1;
  }
  return jr = e, jr;
}
var Dr, gi;
function hf() {
  if (gi) return Dr;
  gi = 1;
  var t = ir();
  function e(r, n) {
    var a = this.__data__, s = t(a, r);
    return s < 0 ? (++this.size, a.push([r, n])) : a[s][1] = n, this;
  }
  return Dr = e, Dr;
}
var Hr, _i;
function or() {
  if (_i) return Hr;
  _i = 1;
  var t = cf(), e = lf(), r = df(), n = ff(), a = hf();
  function s(i) {
    var o = -1, l = i == null ? 0 : i.length;
    for (this.clear(); ++o < l; ) {
      var c = i[o];
      this.set(c[0], c[1]);
    }
  }
  return s.prototype.clear = t, s.prototype.delete = e, s.prototype.get = r, s.prototype.has = n, s.prototype.set = a, Hr = s, Hr;
}
var Lr, bi;
function pf() {
  if (bi) return Lr;
  bi = 1;
  var t = or();
  function e() {
    this.__data__ = new t(), this.size = 0;
  }
  return Lr = e, Lr;
}
var Ur, Ti;
function yf() {
  if (Ti) return Ur;
  Ti = 1;
  function t(e) {
    var r = this.__data__, n = r.delete(e);
    return this.size = r.size, n;
  }
  return Ur = t, Ur;
}
var Br, Si;
function mf() {
  if (Si) return Br;
  Si = 1;
  function t(e) {
    return this.__data__.get(e);
  }
  return Br = t, Br;
}
var Gr, Ai;
function vf() {
  if (Ai) return Gr;
  Ai = 1;
  function t(e) {
    return this.__data__.has(e);
  }
  return Gr = t, Gr;
}
var Kr, Ri;
function oc() {
  if (Ri) return Kr;
  Ri = 1;
  var t = typeof Dt == "object" && Dt && Dt.Object === Object && Dt;
  return Kr = t, Kr;
}
var Fr, Ei;
function fe() {
  if (Ei) return Fr;
  Ei = 1;
  var t = oc(), e = typeof self == "object" && self && self.Object === Object && self, r = t || e || Function("return this")();
  return Fr = r, Fr;
}
var Zr, wi;
function ur() {
  if (wi) return Zr;
  wi = 1;
  var t = fe(), e = t.Symbol;
  return Zr = e, Zr;
}
var Wr, Ci;
function gf() {
  if (Ci) return Wr;
  Ci = 1;
  var t = ur(), e = Object.prototype, r = e.hasOwnProperty, n = e.toString, a = t ? t.toStringTag : void 0;
  function s(i) {
    var o = r.call(i, a), l = i[a];
    try {
      i[a] = void 0;
      var c = !0;
    } catch {
    }
    var h = n.call(i);
    return c && (o ? i[a] = l : delete i[a]), h;
  }
  return Wr = s, Wr;
}
var Jr, Ii;
function _f() {
  if (Ii) return Jr;
  Ii = 1;
  var t = Object.prototype, e = t.toString;
  function r(n) {
    return e.call(n);
  }
  return Jr = r, Jr;
}
var zr, ki;
function cr() {
  if (ki) return zr;
  ki = 1;
  var t = ur(), e = gf(), r = _f(), n = "[object Null]", a = "[object Undefined]", s = t ? t.toStringTag : void 0;
  function i(o) {
    return o == null ? o === void 0 ? a : n : s && s in Object(o) ? e(o) : r(o);
  }
  return zr = i, zr;
}
var Qr, xi;
function Et() {
  if (xi) return Qr;
  xi = 1;
  function t(e) {
    var r = typeof e;
    return e != null && (r == "object" || r == "function");
  }
  return Qr = t, Qr;
}
var Yr, Oi;
function uc() {
  if (Oi) return Yr;
  Oi = 1;
  var t = cr(), e = Et(), r = "[object AsyncFunction]", n = "[object Function]", a = "[object GeneratorFunction]", s = "[object Proxy]";
  function i(o) {
    if (!e(o))
      return !1;
    var l = t(o);
    return l == n || l == a || l == r || l == s;
  }
  return Yr = i, Yr;
}
var Xr, qi;
function bf() {
  if (qi) return Xr;
  qi = 1;
  var t = fe(), e = t["__core-js_shared__"];
  return Xr = e, Xr;
}
var en, Vi;
function Tf() {
  if (Vi) return en;
  Vi = 1;
  var t = bf(), e = (function() {
    var n = /[^.]+$/.exec(t && t.keys && t.keys.IE_PROTO || "");
    return n ? "Symbol(src)_1." + n : "";
  })();
  function r(n) {
    return !!e && e in n;
  }
  return en = r, en;
}
var tn, Pi;
function cc() {
  if (Pi) return tn;
  Pi = 1;
  var t = Function.prototype, e = t.toString;
  function r(n) {
    if (n != null) {
      try {
        return e.call(n);
      } catch {
      }
      try {
        return n + "";
      } catch {
      }
    }
    return "";
  }
  return tn = r, tn;
}
var rn, Ni;
function Sf() {
  if (Ni) return rn;
  Ni = 1;
  var t = uc(), e = Tf(), r = Et(), n = cc(), a = /[\\^$.*+?()[\]{}|]/g, s = /^\[object .+?Constructor\]$/, i = Function.prototype, o = Object.prototype, l = i.toString, c = o.hasOwnProperty, h = RegExp(
    "^" + l.call(c).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function y(A) {
    if (!r(A) || e(A))
      return !1;
    var k = t(A) ? h : s;
    return k.test(n(A));
  }
  return rn = y, rn;
}
var nn, $i;
function Af() {
  if ($i) return nn;
  $i = 1;
  function t(e, r) {
    return e?.[r];
  }
  return nn = t, nn;
}
var an, Mi;
function Fe() {
  if (Mi) return an;
  Mi = 1;
  var t = Sf(), e = Af();
  function r(n, a) {
    var s = e(n, a);
    return t(s) ? s : void 0;
  }
  return an = r, an;
}
var sn, ji;
function ms() {
  if (ji) return sn;
  ji = 1;
  var t = Fe(), e = fe(), r = t(e, "Map");
  return sn = r, sn;
}
var on, Di;
function lr() {
  if (Di) return on;
  Di = 1;
  var t = Fe(), e = t(Object, "create");
  return on = e, on;
}
var un, Hi;
function Rf() {
  if (Hi) return un;
  Hi = 1;
  var t = lr();
  function e() {
    this.__data__ = t ? t(null) : {}, this.size = 0;
  }
  return un = e, un;
}
var cn, Li;
function Ef() {
  if (Li) return cn;
  Li = 1;
  function t(e) {
    var r = this.has(e) && delete this.__data__[e];
    return this.size -= r ? 1 : 0, r;
  }
  return cn = t, cn;
}
var ln, Ui;
function wf() {
  if (Ui) return ln;
  Ui = 1;
  var t = lr(), e = "__lodash_hash_undefined__", r = Object.prototype, n = r.hasOwnProperty;
  function a(s) {
    var i = this.__data__;
    if (t) {
      var o = i[s];
      return o === e ? void 0 : o;
    }
    return n.call(i, s) ? i[s] : void 0;
  }
  return ln = a, ln;
}
var dn, Bi;
function Cf() {
  if (Bi) return dn;
  Bi = 1;
  var t = lr(), e = Object.prototype, r = e.hasOwnProperty;
  function n(a) {
    var s = this.__data__;
    return t ? s[a] !== void 0 : r.call(s, a);
  }
  return dn = n, dn;
}
var fn, Gi;
function If() {
  if (Gi) return fn;
  Gi = 1;
  var t = lr(), e = "__lodash_hash_undefined__";
  function r(n, a) {
    var s = this.__data__;
    return this.size += this.has(n) ? 0 : 1, s[n] = t && a === void 0 ? e : a, this;
  }
  return fn = r, fn;
}
var hn, Ki;
function kf() {
  if (Ki) return hn;
  Ki = 1;
  var t = Rf(), e = Ef(), r = wf(), n = Cf(), a = If();
  function s(i) {
    var o = -1, l = i == null ? 0 : i.length;
    for (this.clear(); ++o < l; ) {
      var c = i[o];
      this.set(c[0], c[1]);
    }
  }
  return s.prototype.clear = t, s.prototype.delete = e, s.prototype.get = r, s.prototype.has = n, s.prototype.set = a, hn = s, hn;
}
var pn, Fi;
function xf() {
  if (Fi) return pn;
  Fi = 1;
  var t = kf(), e = or(), r = ms();
  function n() {
    this.size = 0, this.__data__ = {
      hash: new t(),
      map: new (r || e)(),
      string: new t()
    };
  }
  return pn = n, pn;
}
var yn, Zi;
function Of() {
  if (Zi) return yn;
  Zi = 1;
  function t(e) {
    var r = typeof e;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? e !== "__proto__" : e === null;
  }
  return yn = t, yn;
}
var mn, Wi;
function dr() {
  if (Wi) return mn;
  Wi = 1;
  var t = Of();
  function e(r, n) {
    var a = r.__data__;
    return t(n) ? a[typeof n == "string" ? "string" : "hash"] : a.map;
  }
  return mn = e, mn;
}
var vn, Ji;
function qf() {
  if (Ji) return vn;
  Ji = 1;
  var t = dr();
  function e(r) {
    var n = t(this, r).delete(r);
    return this.size -= n ? 1 : 0, n;
  }
  return vn = e, vn;
}
var gn, zi;
function Vf() {
  if (zi) return gn;
  zi = 1;
  var t = dr();
  function e(r) {
    return t(this, r).get(r);
  }
  return gn = e, gn;
}
var _n, Qi;
function Pf() {
  if (Qi) return _n;
  Qi = 1;
  var t = dr();
  function e(r) {
    return t(this, r).has(r);
  }
  return _n = e, _n;
}
var bn, Yi;
function Nf() {
  if (Yi) return bn;
  Yi = 1;
  var t = dr();
  function e(r, n) {
    var a = t(this, r), s = a.size;
    return a.set(r, n), this.size += a.size == s ? 0 : 1, this;
  }
  return bn = e, bn;
}
var Tn, Xi;
function lc() {
  if (Xi) return Tn;
  Xi = 1;
  var t = xf(), e = qf(), r = Vf(), n = Pf(), a = Nf();
  function s(i) {
    var o = -1, l = i == null ? 0 : i.length;
    for (this.clear(); ++o < l; ) {
      var c = i[o];
      this.set(c[0], c[1]);
    }
  }
  return s.prototype.clear = t, s.prototype.delete = e, s.prototype.get = r, s.prototype.has = n, s.prototype.set = a, Tn = s, Tn;
}
var Sn, eo;
function $f() {
  if (eo) return Sn;
  eo = 1;
  var t = or(), e = ms(), r = lc(), n = 200;
  function a(s, i) {
    var o = this.__data__;
    if (o instanceof t) {
      var l = o.__data__;
      if (!e || l.length < n - 1)
        return l.push([s, i]), this.size = ++o.size, this;
      o = this.__data__ = new r(l);
    }
    return o.set(s, i), this.size = o.size, this;
  }
  return Sn = a, Sn;
}
var An, to;
function dc() {
  if (to) return An;
  to = 1;
  var t = or(), e = pf(), r = yf(), n = mf(), a = vf(), s = $f();
  function i(o) {
    var l = this.__data__ = new t(o);
    this.size = l.size;
  }
  return i.prototype.clear = e, i.prototype.delete = r, i.prototype.get = n, i.prototype.has = a, i.prototype.set = s, An = i, An;
}
var Rn, ro;
function Mf() {
  if (ro) return Rn;
  ro = 1;
  function t(e, r) {
    for (var n = -1, a = e == null ? 0 : e.length; ++n < a && r(e[n], n, e) !== !1; )
      ;
    return e;
  }
  return Rn = t, Rn;
}
var En, no;
function jf() {
  if (no) return En;
  no = 1;
  var t = Fe(), e = (function() {
    try {
      var r = t(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return En = e, En;
}
var wn, ao;
function fc() {
  if (ao) return wn;
  ao = 1;
  var t = jf();
  function e(r, n, a) {
    n == "__proto__" && t ? t(r, n, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[n] = a;
  }
  return wn = e, wn;
}
var Cn, so;
function hc() {
  if (so) return Cn;
  so = 1;
  var t = fc(), e = ys(), r = Object.prototype, n = r.hasOwnProperty;
  function a(s, i, o) {
    var l = s[i];
    (!(n.call(s, i) && e(l, o)) || o === void 0 && !(i in s)) && t(s, i, o);
  }
  return Cn = a, Cn;
}
var In, io;
function fr() {
  if (io) return In;
  io = 1;
  var t = hc(), e = fc();
  function r(n, a, s, i) {
    var o = !s;
    s || (s = {});
    for (var l = -1, c = a.length; ++l < c; ) {
      var h = a[l], y = i ? i(s[h], n[h], h, s, n) : void 0;
      y === void 0 && (y = n[h]), o ? e(s, h, y) : t(s, h, y);
    }
    return s;
  }
  return In = r, In;
}
var kn, oo;
function Df() {
  if (oo) return kn;
  oo = 1;
  function t(e, r) {
    for (var n = -1, a = Array(e); ++n < e; )
      a[n] = r(n);
    return a;
  }
  return kn = t, kn;
}
var xn, uo;
function ft() {
  if (uo) return xn;
  uo = 1;
  function t(e) {
    return e != null && typeof e == "object";
  }
  return xn = t, xn;
}
var On, co;
function Hf() {
  if (co) return On;
  co = 1;
  var t = cr(), e = ft(), r = "[object Arguments]";
  function n(a) {
    return e(a) && t(a) == r;
  }
  return On = n, On;
}
var qn, lo;
function Lf() {
  if (lo) return qn;
  lo = 1;
  var t = Hf(), e = ft(), r = Object.prototype, n = r.hasOwnProperty, a = r.propertyIsEnumerable, s = t(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? t : function(i) {
    return e(i) && n.call(i, "callee") && !a.call(i, "callee");
  };
  return qn = s, qn;
}
var Vn, fo;
function hr() {
  if (fo) return Vn;
  fo = 1;
  var t = Array.isArray;
  return Vn = t, Vn;
}
var yt = { exports: {} }, Pn, ho;
function Uf() {
  if (ho) return Pn;
  ho = 1;
  function t() {
    return !1;
  }
  return Pn = t, Pn;
}
yt.exports;
var po;
function vs() {
  return po || (po = 1, (function(t, e) {
    var r = fe(), n = Uf(), a = e && !e.nodeType && e, s = a && !0 && t && !t.nodeType && t, i = s && s.exports === a, o = i ? r.Buffer : void 0, l = o ? o.isBuffer : void 0, c = l || n;
    t.exports = c;
  })(yt, yt.exports)), yt.exports;
}
var Nn, yo;
function Bf() {
  if (yo) return Nn;
  yo = 1;
  var t = 9007199254740991, e = /^(?:0|[1-9]\d*)$/;
  function r(n, a) {
    var s = typeof n;
    return a = a ?? t, !!a && (s == "number" || s != "symbol" && e.test(n)) && n > -1 && n % 1 == 0 && n < a;
  }
  return Nn = r, Nn;
}
var $n, mo;
function pc() {
  if (mo) return $n;
  mo = 1;
  var t = 9007199254740991;
  function e(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= t;
  }
  return $n = e, $n;
}
var Mn, vo;
function Gf() {
  if (vo) return Mn;
  vo = 1;
  var t = cr(), e = pc(), r = ft(), n = "[object Arguments]", a = "[object Array]", s = "[object Boolean]", i = "[object Date]", o = "[object Error]", l = "[object Function]", c = "[object Map]", h = "[object Number]", y = "[object Object]", A = "[object RegExp]", k = "[object Set]", F = "[object String]", j = "[object WeakMap]", $ = "[object ArrayBuffer]", N = "[object DataView]", C = "[object Float32Array]", B = "[object Float64Array]", q = "[object Int8Array]", G = "[object Int16Array]", V = "[object Int32Array]", x = "[object Uint8Array]", J = "[object Uint8ClampedArray]", D = "[object Uint16Array]", re = "[object Uint32Array]", I = {};
  I[C] = I[B] = I[q] = I[G] = I[V] = I[x] = I[J] = I[D] = I[re] = !0, I[n] = I[a] = I[$] = I[s] = I[N] = I[i] = I[o] = I[l] = I[c] = I[h] = I[y] = I[A] = I[k] = I[F] = I[j] = !1;
  function ee(se) {
    return r(se) && e(se.length) && !!I[t(se)];
  }
  return Mn = ee, Mn;
}
var jn, go;
function gs() {
  if (go) return jn;
  go = 1;
  function t(e) {
    return function(r) {
      return e(r);
    };
  }
  return jn = t, jn;
}
var mt = { exports: {} };
mt.exports;
var _o;
function _s() {
  return _o || (_o = 1, (function(t, e) {
    var r = oc(), n = e && !e.nodeType && e, a = n && !0 && t && !t.nodeType && t, s = a && a.exports === n, i = s && r.process, o = (function() {
      try {
        var l = a && a.require && a.require("util").types;
        return l || i && i.binding && i.binding("util");
      } catch {
      }
    })();
    t.exports = o;
  })(mt, mt.exports)), mt.exports;
}
var Dn, bo;
function yc() {
  if (bo) return Dn;
  bo = 1;
  var t = Gf(), e = gs(), r = _s(), n = r && r.isTypedArray, a = n ? e(n) : t;
  return Dn = a, Dn;
}
var Hn, To;
function mc() {
  if (To) return Hn;
  To = 1;
  var t = Df(), e = Lf(), r = hr(), n = vs(), a = Bf(), s = yc(), i = Object.prototype, o = i.hasOwnProperty;
  function l(c, h) {
    var y = r(c), A = !y && e(c), k = !y && !A && n(c), F = !y && !A && !k && s(c), j = y || A || k || F, $ = j ? t(c.length, String) : [], N = $.length;
    for (var C in c)
      (h || o.call(c, C)) && !(j && // Safari 9 has enumerable `arguments.length` in strict mode.
      (C == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      k && (C == "offset" || C == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      F && (C == "buffer" || C == "byteLength" || C == "byteOffset") || // Skip index properties.
      a(C, N))) && $.push(C);
    return $;
  }
  return Hn = l, Hn;
}
var Ln, So;
function bs() {
  if (So) return Ln;
  So = 1;
  var t = Object.prototype;
  function e(r) {
    var n = r && r.constructor, a = typeof n == "function" && n.prototype || t;
    return r === a;
  }
  return Ln = e, Ln;
}
var Un, Ao;
function vc() {
  if (Ao) return Un;
  Ao = 1;
  function t(e, r) {
    return function(n) {
      return e(r(n));
    };
  }
  return Un = t, Un;
}
var Bn, Ro;
function Kf() {
  if (Ro) return Bn;
  Ro = 1;
  var t = vc(), e = t(Object.keys, Object);
  return Bn = e, Bn;
}
var Gn, Eo;
function Ff() {
  if (Eo) return Gn;
  Eo = 1;
  var t = bs(), e = Kf(), r = Object.prototype, n = r.hasOwnProperty;
  function a(s) {
    if (!t(s))
      return e(s);
    var i = [];
    for (var o in Object(s))
      n.call(s, o) && o != "constructor" && i.push(o);
    return i;
  }
  return Gn = a, Gn;
}
var Kn, wo;
function gc() {
  if (wo) return Kn;
  wo = 1;
  var t = uc(), e = pc();
  function r(n) {
    return n != null && e(n.length) && !t(n);
  }
  return Kn = r, Kn;
}
var Fn, Co;
function Ts() {
  if (Co) return Fn;
  Co = 1;
  var t = mc(), e = Ff(), r = gc();
  function n(a) {
    return r(a) ? t(a) : e(a);
  }
  return Fn = n, Fn;
}
var Zn, Io;
function Zf() {
  if (Io) return Zn;
  Io = 1;
  var t = fr(), e = Ts();
  function r(n, a) {
    return n && t(a, e(a), n);
  }
  return Zn = r, Zn;
}
var Wn, ko;
function Wf() {
  if (ko) return Wn;
  ko = 1;
  function t(e) {
    var r = [];
    if (e != null)
      for (var n in Object(e))
        r.push(n);
    return r;
  }
  return Wn = t, Wn;
}
var Jn, xo;
function Jf() {
  if (xo) return Jn;
  xo = 1;
  var t = Et(), e = bs(), r = Wf(), n = Object.prototype, a = n.hasOwnProperty;
  function s(i) {
    if (!t(i))
      return r(i);
    var o = e(i), l = [];
    for (var c in i)
      c == "constructor" && (o || !a.call(i, c)) || l.push(c);
    return l;
  }
  return Jn = s, Jn;
}
var zn, Oo;
function Ss() {
  if (Oo) return zn;
  Oo = 1;
  var t = mc(), e = Jf(), r = gc();
  function n(a) {
    return r(a) ? t(a, !0) : e(a);
  }
  return zn = n, zn;
}
var Qn, qo;
function zf() {
  if (qo) return Qn;
  qo = 1;
  var t = fr(), e = Ss();
  function r(n, a) {
    return n && t(a, e(a), n);
  }
  return Qn = r, Qn;
}
var vt = { exports: {} };
vt.exports;
var Vo;
function Qf() {
  return Vo || (Vo = 1, (function(t, e) {
    var r = fe(), n = e && !e.nodeType && e, a = n && !0 && t && !t.nodeType && t, s = a && a.exports === n, i = s ? r.Buffer : void 0, o = i ? i.allocUnsafe : void 0;
    function l(c, h) {
      if (h)
        return c.slice();
      var y = c.length, A = o ? o(y) : new c.constructor(y);
      return c.copy(A), A;
    }
    t.exports = l;
  })(vt, vt.exports)), vt.exports;
}
var Yn, Po;
function Yf() {
  if (Po) return Yn;
  Po = 1;
  function t(e, r) {
    var n = -1, a = e.length;
    for (r || (r = Array(a)); ++n < a; )
      r[n] = e[n];
    return r;
  }
  return Yn = t, Yn;
}
var Xn, No;
function Xf() {
  if (No) return Xn;
  No = 1;
  function t(e, r) {
    for (var n = -1, a = e == null ? 0 : e.length, s = 0, i = []; ++n < a; ) {
      var o = e[n];
      r(o, n, e) && (i[s++] = o);
    }
    return i;
  }
  return Xn = t, Xn;
}
var ea, $o;
function _c() {
  if ($o) return ea;
  $o = 1;
  function t() {
    return [];
  }
  return ea = t, ea;
}
var ta, Mo;
function As() {
  if (Mo) return ta;
  Mo = 1;
  var t = Xf(), e = _c(), r = Object.prototype, n = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, s = a ? function(i) {
    return i == null ? [] : (i = Object(i), t(a(i), function(o) {
      return n.call(i, o);
    }));
  } : e;
  return ta = s, ta;
}
var ra, jo;
function eh() {
  if (jo) return ra;
  jo = 1;
  var t = fr(), e = As();
  function r(n, a) {
    return t(n, e(n), a);
  }
  return ra = r, ra;
}
var na, Do;
function bc() {
  if (Do) return na;
  Do = 1;
  function t(e, r) {
    for (var n = -1, a = r.length, s = e.length; ++n < a; )
      e[s + n] = r[n];
    return e;
  }
  return na = t, na;
}
var aa, Ho;
function Tc() {
  if (Ho) return aa;
  Ho = 1;
  var t = vc(), e = t(Object.getPrototypeOf, Object);
  return aa = e, aa;
}
var sa, Lo;
function Sc() {
  if (Lo) return sa;
  Lo = 1;
  var t = bc(), e = Tc(), r = As(), n = _c(), a = Object.getOwnPropertySymbols, s = a ? function(i) {
    for (var o = []; i; )
      t(o, r(i)), i = e(i);
    return o;
  } : n;
  return sa = s, sa;
}
var ia, Uo;
function th() {
  if (Uo) return ia;
  Uo = 1;
  var t = fr(), e = Sc();
  function r(n, a) {
    return t(n, e(n), a);
  }
  return ia = r, ia;
}
var oa, Bo;
function Ac() {
  if (Bo) return oa;
  Bo = 1;
  var t = bc(), e = hr();
  function r(n, a, s) {
    var i = a(n);
    return e(n) ? i : t(i, s(n));
  }
  return oa = r, oa;
}
var ua, Go;
function Rc() {
  if (Go) return ua;
  Go = 1;
  var t = Ac(), e = As(), r = Ts();
  function n(a) {
    return t(a, r, e);
  }
  return ua = n, ua;
}
var ca, Ko;
function rh() {
  if (Ko) return ca;
  Ko = 1;
  var t = Ac(), e = Sc(), r = Ss();
  function n(a) {
    return t(a, r, e);
  }
  return ca = n, ca;
}
var la, Fo;
function nh() {
  if (Fo) return la;
  Fo = 1;
  var t = Fe(), e = fe(), r = t(e, "DataView");
  return la = r, la;
}
var da, Zo;
function ah() {
  if (Zo) return da;
  Zo = 1;
  var t = Fe(), e = fe(), r = t(e, "Promise");
  return da = r, da;
}
var fa, Wo;
function sh() {
  if (Wo) return fa;
  Wo = 1;
  var t = Fe(), e = fe(), r = t(e, "Set");
  return fa = r, fa;
}
var ha, Jo;
function ih() {
  if (Jo) return ha;
  Jo = 1;
  var t = Fe(), e = fe(), r = t(e, "WeakMap");
  return ha = r, ha;
}
var pa, zo;
function pr() {
  if (zo) return pa;
  zo = 1;
  var t = nh(), e = ms(), r = ah(), n = sh(), a = ih(), s = cr(), i = cc(), o = "[object Map]", l = "[object Object]", c = "[object Promise]", h = "[object Set]", y = "[object WeakMap]", A = "[object DataView]", k = i(t), F = i(e), j = i(r), $ = i(n), N = i(a), C = s;
  return (t && C(new t(new ArrayBuffer(1))) != A || e && C(new e()) != o || r && C(r.resolve()) != c || n && C(new n()) != h || a && C(new a()) != y) && (C = function(B) {
    var q = s(B), G = q == l ? B.constructor : void 0, V = G ? i(G) : "";
    if (V)
      switch (V) {
        case k:
          return A;
        case F:
          return o;
        case j:
          return c;
        case $:
          return h;
        case N:
          return y;
      }
    return q;
  }), pa = C, pa;
}
var ya, Qo;
function oh() {
  if (Qo) return ya;
  Qo = 1;
  var t = Object.prototype, e = t.hasOwnProperty;
  function r(n) {
    var a = n.length, s = new n.constructor(a);
    return a && typeof n[0] == "string" && e.call(n, "index") && (s.index = n.index, s.input = n.input), s;
  }
  return ya = r, ya;
}
var ma, Yo;
function Ec() {
  if (Yo) return ma;
  Yo = 1;
  var t = fe(), e = t.Uint8Array;
  return ma = e, ma;
}
var va, Xo;
function Rs() {
  if (Xo) return va;
  Xo = 1;
  var t = Ec();
  function e(r) {
    var n = new r.constructor(r.byteLength);
    return new t(n).set(new t(r)), n;
  }
  return va = e, va;
}
var ga, eu;
function uh() {
  if (eu) return ga;
  eu = 1;
  var t = Rs();
  function e(r, n) {
    var a = n ? t(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return ga = e, ga;
}
var _a, tu;
function ch() {
  if (tu) return _a;
  tu = 1;
  var t = /\w*$/;
  function e(r) {
    var n = new r.constructor(r.source, t.exec(r));
    return n.lastIndex = r.lastIndex, n;
  }
  return _a = e, _a;
}
var ba, ru;
function lh() {
  if (ru) return ba;
  ru = 1;
  var t = ur(), e = t ? t.prototype : void 0, r = e ? e.valueOf : void 0;
  function n(a) {
    return r ? Object(r.call(a)) : {};
  }
  return ba = n, ba;
}
var Ta, nu;
function dh() {
  if (nu) return Ta;
  nu = 1;
  var t = Rs();
  function e(r, n) {
    var a = n ? t(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return Ta = e, Ta;
}
var Sa, au;
function fh() {
  if (au) return Sa;
  au = 1;
  var t = Rs(), e = uh(), r = ch(), n = lh(), a = dh(), s = "[object Boolean]", i = "[object Date]", o = "[object Map]", l = "[object Number]", c = "[object RegExp]", h = "[object Set]", y = "[object String]", A = "[object Symbol]", k = "[object ArrayBuffer]", F = "[object DataView]", j = "[object Float32Array]", $ = "[object Float64Array]", N = "[object Int8Array]", C = "[object Int16Array]", B = "[object Int32Array]", q = "[object Uint8Array]", G = "[object Uint8ClampedArray]", V = "[object Uint16Array]", x = "[object Uint32Array]";
  function J(D, re, I) {
    var ee = D.constructor;
    switch (re) {
      case k:
        return t(D);
      case s:
      case i:
        return new ee(+D);
      case F:
        return e(D, I);
      case j:
      case $:
      case N:
      case C:
      case B:
      case q:
      case G:
      case V:
      case x:
        return a(D, I);
      case o:
        return new ee();
      case l:
      case y:
        return new ee(D);
      case c:
        return r(D);
      case h:
        return new ee();
      case A:
        return n(D);
    }
  }
  return Sa = J, Sa;
}
var Aa, su;
function hh() {
  if (su) return Aa;
  su = 1;
  var t = Et(), e = Object.create, r = /* @__PURE__ */ (function() {
    function n() {
    }
    return function(a) {
      if (!t(a))
        return {};
      if (e)
        return e(a);
      n.prototype = a;
      var s = new n();
      return n.prototype = void 0, s;
    };
  })();
  return Aa = r, Aa;
}
var Ra, iu;
function ph() {
  if (iu) return Ra;
  iu = 1;
  var t = hh(), e = Tc(), r = bs();
  function n(a) {
    return typeof a.constructor == "function" && !r(a) ? t(e(a)) : {};
  }
  return Ra = n, Ra;
}
var Ea, ou;
function yh() {
  if (ou) return Ea;
  ou = 1;
  var t = pr(), e = ft(), r = "[object Map]";
  function n(a) {
    return e(a) && t(a) == r;
  }
  return Ea = n, Ea;
}
var wa, uu;
function mh() {
  if (uu) return wa;
  uu = 1;
  var t = yh(), e = gs(), r = _s(), n = r && r.isMap, a = n ? e(n) : t;
  return wa = a, wa;
}
var Ca, cu;
function vh() {
  if (cu) return Ca;
  cu = 1;
  var t = pr(), e = ft(), r = "[object Set]";
  function n(a) {
    return e(a) && t(a) == r;
  }
  return Ca = n, Ca;
}
var Ia, lu;
function gh() {
  if (lu) return Ia;
  lu = 1;
  var t = vh(), e = gs(), r = _s(), n = r && r.isSet, a = n ? e(n) : t;
  return Ia = a, Ia;
}
var ka, du;
function _h() {
  if (du) return ka;
  du = 1;
  var t = dc(), e = Mf(), r = hc(), n = Zf(), a = zf(), s = Qf(), i = Yf(), o = eh(), l = th(), c = Rc(), h = rh(), y = pr(), A = oh(), k = fh(), F = ph(), j = hr(), $ = vs(), N = mh(), C = Et(), B = gh(), q = Ts(), G = Ss(), V = 1, x = 2, J = 4, D = "[object Arguments]", re = "[object Array]", I = "[object Boolean]", ee = "[object Date]", se = "[object Error]", Qe = "[object Function]", Ye = "[object GeneratorFunction]", Or = "[object Map]", _d = "[object Number]", ii = "[object Object]", bd = "[object RegExp]", Td = "[object Set]", Sd = "[object String]", Ad = "[object Symbol]", Rd = "[object WeakMap]", Ed = "[object ArrayBuffer]", wd = "[object DataView]", Cd = "[object Float32Array]", Id = "[object Float64Array]", kd = "[object Int8Array]", xd = "[object Int16Array]", Od = "[object Int32Array]", qd = "[object Uint8Array]", Vd = "[object Uint8ClampedArray]", Pd = "[object Uint16Array]", Nd = "[object Uint32Array]", H = {};
  H[D] = H[re] = H[Ed] = H[wd] = H[I] = H[ee] = H[Cd] = H[Id] = H[kd] = H[xd] = H[Od] = H[Or] = H[_d] = H[ii] = H[bd] = H[Td] = H[Sd] = H[Ad] = H[qd] = H[Vd] = H[Pd] = H[Nd] = !0, H[se] = H[Qe] = H[Rd] = !1;
  function Nt(M, Xe, et, $d, $t, Re) {
    var ne, Mt = Xe & V, jt = Xe & x, Md = Xe & J;
    if (et && (ne = $t ? et(M, $d, $t, Re) : et(M)), ne !== void 0)
      return ne;
    if (!C(M))
      return M;
    var oi = j(M);
    if (oi) {
      if (ne = A(M), !Mt)
        return i(M, ne);
    } else {
      var tt = y(M), ui = tt == Qe || tt == Ye;
      if ($(M))
        return s(M, Mt);
      if (tt == ii || tt == D || ui && !$t) {
        if (ne = jt || ui ? {} : F(M), !Mt)
          return jt ? l(M, a(ne, M)) : o(M, n(ne, M));
      } else {
        if (!H[tt])
          return $t ? M : {};
        ne = k(M, tt, Mt);
      }
    }
    Re || (Re = new t());
    var ci = Re.get(M);
    if (ci)
      return ci;
    Re.set(M, ne), B(M) ? M.forEach(function(Ee) {
      ne.add(Nt(Ee, Xe, et, Ee, M, Re));
    }) : N(M) && M.forEach(function(Ee, He) {
      ne.set(He, Nt(Ee, Xe, et, He, M, Re));
    });
    var jd = Md ? jt ? h : c : jt ? G : q, li = oi ? void 0 : jd(M);
    return e(li || M, function(Ee, He) {
      li && (He = Ee, Ee = M[He]), r(ne, He, Nt(Ee, Xe, et, He, M, Re));
    }), ne;
  }
  return ka = Nt, ka;
}
var xa, fu;
function bh() {
  if (fu) return xa;
  fu = 1;
  var t = _h(), e = 1, r = 4;
  function n(a) {
    return t(a, e | r);
  }
  return xa = n, xa;
}
var Th = bh();
const Sh = /* @__PURE__ */ ic(Th);
var P;
(function(t) {
  t.assertEqual = (a) => {
  };
  function e(a) {
  }
  t.assertIs = e;
  function r(a) {
    throw new Error();
  }
  t.assertNever = r, t.arrayToEnum = (a) => {
    const s = {};
    for (const i of a)
      s[i] = i;
    return s;
  }, t.getValidEnumValues = (a) => {
    const s = t.objectKeys(a).filter((o) => typeof a[a[o]] != "number"), i = {};
    for (const o of s)
      i[o] = a[o];
    return t.objectValues(i);
  }, t.objectValues = (a) => t.objectKeys(a).map(function(s) {
    return a[s];
  }), t.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const s = [];
    for (const i in a)
      Object.prototype.hasOwnProperty.call(a, i) && s.push(i);
    return s;
  }, t.find = (a, s) => {
    for (const i of a)
      if (s(i))
        return i;
  }, t.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && Number.isFinite(a) && Math.floor(a) === a;
  function n(a, s = " | ") {
    return a.map((i) => typeof i == "string" ? `'${i}'` : i).join(s);
  }
  t.joinValues = n, t.jsonStringifyReplacer = (a, s) => typeof s == "bigint" ? s.toString() : s;
})(P || (P = {}));
var hu;
(function(t) {
  t.mergeShapes = (e, r) => ({
    ...e,
    ...r
    // second overwrites first
  });
})(hu || (hu = {}));
const v = P.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Ce = (t) => {
  switch (typeof t) {
    case "undefined":
      return v.undefined;
    case "string":
      return v.string;
    case "number":
      return Number.isNaN(t) ? v.nan : v.number;
    case "boolean":
      return v.boolean;
    case "function":
      return v.function;
    case "bigint":
      return v.bigint;
    case "symbol":
      return v.symbol;
    case "object":
      return Array.isArray(t) ? v.array : t === null ? v.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? v.promise : typeof Map < "u" && t instanceof Map ? v.map : typeof Set < "u" && t instanceof Set ? v.set : typeof Date < "u" && t instanceof Date ? v.date : v.object;
    default:
      return v.unknown;
  }
}, p = P.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class Te extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const r = e || function(s) {
      return s.message;
    }, n = { _errors: [] }, a = (s) => {
      for (const i of s.issues)
        if (i.code === "invalid_union")
          i.unionErrors.map(a);
        else if (i.code === "invalid_return_type")
          a(i.returnTypeError);
        else if (i.code === "invalid_arguments")
          a(i.argumentsError);
        else if (i.path.length === 0)
          n._errors.push(r(i));
        else {
          let o = n, l = 0;
          for (; l < i.path.length; ) {
            const c = i.path[l];
            l === i.path.length - 1 ? (o[c] = o[c] || { _errors: [] }, o[c]._errors.push(r(i))) : o[c] = o[c] || { _errors: [] }, o = o[c], l++;
          }
        }
    };
    return a(this), n;
  }
  static assert(e) {
    if (!(e instanceof Te))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, P.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (r) => r.message) {
    const r = {}, n = [];
    for (const a of this.issues)
      a.path.length > 0 ? (r[a.path[0]] = r[a.path[0]] || [], r[a.path[0]].push(e(a))) : n.push(e(a));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
Te.create = (t) => new Te(t);
const rs = (t, e) => {
  let r;
  switch (t.code) {
    case p.invalid_type:
      t.received === v.undefined ? r = "Required" : r = `Expected ${t.expected}, received ${t.received}`;
      break;
    case p.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(t.expected, P.jsonStringifyReplacer)}`;
      break;
    case p.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${P.joinValues(t.keys, ", ")}`;
      break;
    case p.invalid_union:
      r = "Invalid input";
      break;
    case p.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${P.joinValues(t.options)}`;
      break;
    case p.invalid_enum_value:
      r = `Invalid enum value. Expected ${P.joinValues(t.options)}, received '${t.received}'`;
      break;
    case p.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case p.invalid_return_type:
      r = "Invalid function return type";
      break;
    case p.invalid_date:
      r = "Invalid date";
      break;
    case p.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (r = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? r = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? r = `Invalid input: must end with "${t.validation.endsWith}"` : P.assertNever(t.validation) : t.validation !== "regex" ? r = `Invalid ${t.validation}` : r = "Invalid";
      break;
    case p.too_small:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : r = "Invalid input";
      break;
    case p.too_big:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? r = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : r = "Invalid input";
      break;
    case p.custom:
      r = "Invalid input";
      break;
    case p.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case p.not_multiple_of:
      r = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case p.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = e.defaultError, P.assertNever(t);
  }
  return { message: r };
};
let Ah = rs;
function Rh() {
  return Ah;
}
const Eh = (t) => {
  const { data: e, path: r, errorMaps: n, issueData: a } = t, s = [...r, ...a.path || []], i = {
    ...a,
    path: s
  };
  if (a.message !== void 0)
    return {
      ...a,
      path: s,
      message: a.message
    };
  let o = "";
  const l = n.filter((c) => !!c).slice().reverse();
  for (const c of l)
    o = c(i, { data: e, defaultError: o }).message;
  return {
    ...a,
    path: s,
    message: o
  };
};
function m(t, e) {
  const r = Rh(), n = Eh({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      // contextual error map is first priority
      t.schemaErrorMap,
      // then schema-bound map if available
      r,
      // then global override map
      r === rs ? void 0 : rs
      // then global default map
    ].filter((a) => !!a)
  });
  t.common.issues.push(n);
}
class te {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, r) {
    const n = [];
    for (const a of r) {
      if (a.status === "aborted")
        return R;
      a.status === "dirty" && e.dirty(), n.push(a.value);
    }
    return { status: e.value, value: n };
  }
  static async mergeObjectAsync(e, r) {
    const n = [];
    for (const a of r) {
      const s = await a.key, i = await a.value;
      n.push({
        key: s,
        value: i
      });
    }
    return te.mergeObjectSync(e, n);
  }
  static mergeObjectSync(e, r) {
    const n = {};
    for (const a of r) {
      const { key: s, value: i } = a;
      if (s.status === "aborted" || i.status === "aborted")
        return R;
      s.status === "dirty" && e.dirty(), i.status === "dirty" && e.dirty(), s.value !== "__proto__" && (typeof i.value < "u" || a.alwaysSet) && (n[s.value] = i.value);
    }
    return { status: e.value, value: n };
  }
}
const R = Object.freeze({
  status: "aborted"
}), gt = (t) => ({ status: "dirty", value: t }), oe = (t) => ({ status: "valid", value: t }), pu = (t) => t.status === "aborted", yu = (t) => t.status === "dirty", st = (t) => t.status === "valid", Ut = (t) => typeof Promise < "u" && t instanceof Promise;
var g;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e?.message;
})(g || (g = {}));
var Bt = function(t, e, r, n) {
  if (r === "a" && !n) throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? t !== e || !n : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? n : r === "a" ? n.call(t) : n ? n.value : e.get(t);
}, wc = function(t, e, r, n, a) {
  if (n === "m") throw new TypeError("Private method is not writable");
  if (n === "a" && !a) throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? t !== e || !a : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return n === "a" ? a.call(t, r) : a ? a.value = r : e.set(t, r), r;
}, _t, bt;
class le {
  constructor(e, r, n, a) {
    this._cachedPath = [], this.parent = e, this.data = r, this._path = n, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const mu = (t, e) => {
  if (st(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new Te(t.common.issues);
      return this._error = r, this._error;
    }
  };
};
function w(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: r, required_error: n, description: a } = t;
  if (e && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: a } : { errorMap: (i, o) => {
    const { message: l } = t;
    return i.code === "invalid_enum_value" ? { message: l ?? o.defaultError } : typeof o.data > "u" ? { message: l ?? n ?? o.defaultError } : i.code !== "invalid_type" ? { message: o.defaultError } : { message: l ?? r ?? o.defaultError };
  }, description: a };
}
class O {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return Ce(e.data);
  }
  _getOrReturnCtx(e, r) {
    return r || {
      common: e.parent.common,
      data: e.data,
      parsedType: Ce(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new te(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: Ce(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const r = this._parse(e);
    if (Ut(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(e) {
    const r = this._parse(e);
    return Promise.resolve(r);
  }
  parse(e, r) {
    const n = this.safeParse(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(e, r) {
    const n = {
      common: {
        issues: [],
        async: r?.async ?? !1,
        contextualErrorMap: r?.errorMap
      },
      path: r?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Ce(e)
    }, a = this._parseSync({ data: e, path: n.path, parent: n });
    return mu(n, a);
  }
  "~validate"(e) {
    const r = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Ce(e)
    };
    if (!this["~standard"].async)
      try {
        const n = this._parseSync({ data: e, path: [], parent: r });
        return st(n) ? {
          value: n.value
        } : {
          issues: r.common.issues
        };
      } catch (n) {
        n?.message?.toLowerCase()?.includes("encountered") && (this["~standard"].async = !0), r.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: r }).then((n) => st(n) ? {
      value: n.value
    } : {
      issues: r.common.issues
    });
  }
  async parseAsync(e, r) {
    const n = await this.safeParseAsync(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(e, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r?.errorMap,
        async: !0
      },
      path: r?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Ce(e)
    }, a = this._parse({ data: e, path: n.path, parent: n }), s = await (Ut(a) ? a : Promise.resolve(a));
    return mu(n, s);
  }
  refine(e, r) {
    const n = (a) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(a) : r;
    return this._refinement((a, s) => {
      const i = e(a), o = () => s.addIssue({
        code: p.custom,
        ...n(a)
      });
      return typeof Promise < "u" && i instanceof Promise ? i.then((l) => l ? !0 : (o(), !1)) : i ? !0 : (o(), !1);
    });
  }
  refinement(e, r) {
    return this._refinement((n, a) => e(n) ? !0 : (a.addIssue(typeof r == "function" ? r(n, a) : r), !1));
  }
  _refinement(e) {
    return new Ge({
      schema: this,
      typeName: S.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (r) => this["~validate"](r)
    };
  }
  optional() {
    return be.create(this, this._def);
  }
  nullable() {
    return Ke.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ce.create(this);
  }
  promise() {
    return zt.create(this, this._def);
  }
  or(e) {
    return Kt.create([this, e], this._def);
  }
  and(e) {
    return Ft.create(this, e, this._def);
  }
  transform(e) {
    return new Ge({
      ...w(this._def),
      schema: this,
      typeName: S.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const r = typeof e == "function" ? e : () => e;
    return new Qt({
      ...w(this._def),
      innerType: this,
      defaultValue: r,
      typeName: S.ZodDefault
    });
  }
  brand() {
    return new xc({
      typeName: S.ZodBranded,
      type: this,
      ...w(this._def)
    });
  }
  catch(e) {
    const r = typeof e == "function" ? e : () => e;
    return new Yt({
      ...w(this._def),
      innerType: this,
      catchValue: r,
      typeName: S.ZodCatch
    });
  }
  describe(e) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return ws.create(this, e);
  }
  readonly() {
    return Xt.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const wh = /^c[^\s-]{8,}$/i, Ch = /^[0-9a-z]+$/, Ih = /^[0-9A-HJKMNP-TV-Z]{26}$/i, kh = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, xh = /^[a-z0-9_-]{21}$/i, Oh = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, qh = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, Vh = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, Ph = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Oa;
const Nh = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, $h = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, Mh = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, jh = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Dh = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Hh = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Cc = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Lh = new RegExp(`^${Cc}$`);
function Ic(t) {
  let e = "[0-5]\\d";
  t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`);
  const r = t.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${e})${r}`;
}
function Uh(t) {
  return new RegExp(`^${Ic(t)}$`);
}
function Bh(t) {
  let e = `${Cc}T${Ic(t)}`;
  const r = [];
  return r.push(t.local ? "Z?" : "Z"), t.offset && r.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${r.join("|")})`, new RegExp(`^${e}$`);
}
function Gh(t, e) {
  return !!((e === "v4" || !e) && Nh.test(t) || (e === "v6" || !e) && Mh.test(t));
}
function Kh(t, e) {
  if (!Oh.test(t))
    return !1;
  try {
    const [r] = t.split("."), n = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), a = JSON.parse(atob(n));
    return !(typeof a != "object" || a === null || "typ" in a && a?.typ !== "JWT" || !a.alg || e && a.alg !== e);
  } catch {
    return !1;
  }
}
function Fh(t, e) {
  return !!((e === "v4" || !e) && $h.test(t) || (e === "v6" || !e) && jh.test(t));
}
class _e extends O {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== v.string) {
      const s = this._getOrReturnCtx(e);
      return m(s, {
        code: p.invalid_type,
        expected: v.string,
        received: s.parsedType
      }), R;
    }
    const n = new te();
    let a;
    for (const s of this._def.checks)
      if (s.kind === "min")
        e.data.length < s.value && (a = this._getOrReturnCtx(e, a), m(a, {
          code: p.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), n.dirty());
      else if (s.kind === "max")
        e.data.length > s.value && (a = this._getOrReturnCtx(e, a), m(a, {
          code: p.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), n.dirty());
      else if (s.kind === "length") {
        const i = e.data.length > s.value, o = e.data.length < s.value;
        (i || o) && (a = this._getOrReturnCtx(e, a), i ? m(a, {
          code: p.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }) : o && m(a, {
          code: p.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }), n.dirty());
      } else if (s.kind === "email")
        Vh.test(e.data) || (a = this._getOrReturnCtx(e, a), m(a, {
          validation: "email",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "emoji")
        Oa || (Oa = new RegExp(Ph, "u")), Oa.test(e.data) || (a = this._getOrReturnCtx(e, a), m(a, {
          validation: "emoji",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "uuid")
        kh.test(e.data) || (a = this._getOrReturnCtx(e, a), m(a, {
          validation: "uuid",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "nanoid")
        xh.test(e.data) || (a = this._getOrReturnCtx(e, a), m(a, {
          validation: "nanoid",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "cuid")
        wh.test(e.data) || (a = this._getOrReturnCtx(e, a), m(a, {
          validation: "cuid",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "cuid2")
        Ch.test(e.data) || (a = this._getOrReturnCtx(e, a), m(a, {
          validation: "cuid2",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "ulid")
        Ih.test(e.data) || (a = this._getOrReturnCtx(e, a), m(a, {
          validation: "ulid",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "url")
        try {
          new URL(e.data);
        } catch {
          a = this._getOrReturnCtx(e, a), m(a, {
            validation: "url",
            code: p.invalid_string,
            message: s.message
          }), n.dirty();
        }
      else s.kind === "regex" ? (s.regex.lastIndex = 0, s.regex.test(e.data) || (a = this._getOrReturnCtx(e, a), m(a, {
        validation: "regex",
        code: p.invalid_string,
        message: s.message
      }), n.dirty())) : s.kind === "trim" ? e.data = e.data.trim() : s.kind === "includes" ? e.data.includes(s.value, s.position) || (a = this._getOrReturnCtx(e, a), m(a, {
        code: p.invalid_string,
        validation: { includes: s.value, position: s.position },
        message: s.message
      }), n.dirty()) : s.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : s.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : s.kind === "startsWith" ? e.data.startsWith(s.value) || (a = this._getOrReturnCtx(e, a), m(a, {
        code: p.invalid_string,
        validation: { startsWith: s.value },
        message: s.message
      }), n.dirty()) : s.kind === "endsWith" ? e.data.endsWith(s.value) || (a = this._getOrReturnCtx(e, a), m(a, {
        code: p.invalid_string,
        validation: { endsWith: s.value },
        message: s.message
      }), n.dirty()) : s.kind === "datetime" ? Bh(s).test(e.data) || (a = this._getOrReturnCtx(e, a), m(a, {
        code: p.invalid_string,
        validation: "datetime",
        message: s.message
      }), n.dirty()) : s.kind === "date" ? Lh.test(e.data) || (a = this._getOrReturnCtx(e, a), m(a, {
        code: p.invalid_string,
        validation: "date",
        message: s.message
      }), n.dirty()) : s.kind === "time" ? Uh(s).test(e.data) || (a = this._getOrReturnCtx(e, a), m(a, {
        code: p.invalid_string,
        validation: "time",
        message: s.message
      }), n.dirty()) : s.kind === "duration" ? qh.test(e.data) || (a = this._getOrReturnCtx(e, a), m(a, {
        validation: "duration",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "ip" ? Gh(e.data, s.version) || (a = this._getOrReturnCtx(e, a), m(a, {
        validation: "ip",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "jwt" ? Kh(e.data, s.alg) || (a = this._getOrReturnCtx(e, a), m(a, {
        validation: "jwt",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "cidr" ? Fh(e.data, s.version) || (a = this._getOrReturnCtx(e, a), m(a, {
        validation: "cidr",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "base64" ? Dh.test(e.data) || (a = this._getOrReturnCtx(e, a), m(a, {
        validation: "base64",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "base64url" ? Hh.test(e.data) || (a = this._getOrReturnCtx(e, a), m(a, {
        validation: "base64url",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : P.assertNever(s);
    return { status: n.value, value: e.data };
  }
  _regex(e, r, n) {
    return this.refinement((a) => e.test(a), {
      validation: r,
      code: p.invalid_string,
      ...g.errToObj(n)
    });
  }
  _addCheck(e) {
    return new _e({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...g.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...g.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...g.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...g.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...g.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...g.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...g.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...g.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...g.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...g.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...g.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...g.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...g.errToObj(e) });
  }
  datetime(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      offset: e?.offset ?? !1,
      local: e?.local ?? !1,
      ...g.errToObj(e?.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      ...g.errToObj(e?.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...g.errToObj(e) });
  }
  regex(e, r) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...g.errToObj(r)
    });
  }
  includes(e, r) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: r?.position,
      ...g.errToObj(r?.message)
    });
  }
  startsWith(e, r) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...g.errToObj(r)
    });
  }
  endsWith(e, r) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...g.errToObj(r)
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...g.errToObj(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...g.errToObj(r)
    });
  }
  length(e, r) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...g.errToObj(r)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, g.errToObj(e));
  }
  trim() {
    return new _e({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new _e({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new _e({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
}
_e.create = (t) => new _e({
  checks: [],
  typeName: S.ZodString,
  coerce: t?.coerce ?? !1,
  ...w(t)
});
function Zh(t, e) {
  const r = (t.toString().split(".")[1] || "").length, n = (e.toString().split(".")[1] || "").length, a = r > n ? r : n, s = Number.parseInt(t.toFixed(a).replace(".", "")), i = Number.parseInt(e.toFixed(a).replace(".", ""));
  return s % i / 10 ** a;
}
class it extends O {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== v.number) {
      const s = this._getOrReturnCtx(e);
      return m(s, {
        code: p.invalid_type,
        expected: v.number,
        received: s.parsedType
      }), R;
    }
    let n;
    const a = new te();
    for (const s of this._def.checks)
      s.kind === "int" ? P.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), m(n, {
        code: p.invalid_type,
        expected: "integer",
        received: "float",
        message: s.message
      }), a.dirty()) : s.kind === "min" ? (s.inclusive ? e.data < s.value : e.data <= s.value) && (n = this._getOrReturnCtx(e, n), m(n, {
        code: p.too_small,
        minimum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), a.dirty()) : s.kind === "max" ? (s.inclusive ? e.data > s.value : e.data >= s.value) && (n = this._getOrReturnCtx(e, n), m(n, {
        code: p.too_big,
        maximum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), a.dirty()) : s.kind === "multipleOf" ? Zh(e.data, s.value) !== 0 && (n = this._getOrReturnCtx(e, n), m(n, {
        code: p.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), a.dirty()) : s.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), m(n, {
        code: p.not_finite,
        message: s.message
      }), a.dirty()) : P.assertNever(s);
    return { status: a.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, g.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, g.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, g.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, g.toString(r));
  }
  setLimit(e, r, n, a) {
    return new it({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: g.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new it({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: g.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: g.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: g.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: g.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: g.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: g.toString(r)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: g.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: g.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: g.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && P.isInteger(e.value));
  }
  get isFinite() {
    let e = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(e);
  }
}
it.create = (t) => new it({
  checks: [],
  typeName: S.ZodNumber,
  coerce: t?.coerce || !1,
  ...w(t)
});
class Tt extends O {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== v.bigint)
      return this._getInvalidInput(e);
    let n;
    const a = new te();
    for (const s of this._def.checks)
      s.kind === "min" ? (s.inclusive ? e.data < s.value : e.data <= s.value) && (n = this._getOrReturnCtx(e, n), m(n, {
        code: p.too_small,
        type: "bigint",
        minimum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), a.dirty()) : s.kind === "max" ? (s.inclusive ? e.data > s.value : e.data >= s.value) && (n = this._getOrReturnCtx(e, n), m(n, {
        code: p.too_big,
        type: "bigint",
        maximum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), a.dirty()) : s.kind === "multipleOf" ? e.data % s.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), m(n, {
        code: p.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), a.dirty()) : P.assertNever(s);
    return { status: a.value, value: e.data };
  }
  _getInvalidInput(e) {
    const r = this._getOrReturnCtx(e);
    return m(r, {
      code: p.invalid_type,
      expected: v.bigint,
      received: r.parsedType
    }), R;
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, g.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, g.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, g.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, g.toString(r));
  }
  setLimit(e, r, n, a) {
    return new Tt({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: g.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Tt({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: g.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: g.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: g.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: g.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: g.toString(r)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
}
Tt.create = (t) => new Tt({
  checks: [],
  typeName: S.ZodBigInt,
  coerce: t?.coerce ?? !1,
  ...w(t)
});
class ns extends O {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== v.boolean) {
      const n = this._getOrReturnCtx(e);
      return m(n, {
        code: p.invalid_type,
        expected: v.boolean,
        received: n.parsedType
      }), R;
    }
    return oe(e.data);
  }
}
ns.create = (t) => new ns({
  typeName: S.ZodBoolean,
  coerce: t?.coerce || !1,
  ...w(t)
});
class Gt extends O {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== v.date) {
      const s = this._getOrReturnCtx(e);
      return m(s, {
        code: p.invalid_type,
        expected: v.date,
        received: s.parsedType
      }), R;
    }
    if (Number.isNaN(e.data.getTime())) {
      const s = this._getOrReturnCtx(e);
      return m(s, {
        code: p.invalid_date
      }), R;
    }
    const n = new te();
    let a;
    for (const s of this._def.checks)
      s.kind === "min" ? e.data.getTime() < s.value && (a = this._getOrReturnCtx(e, a), m(a, {
        code: p.too_small,
        message: s.message,
        inclusive: !0,
        exact: !1,
        minimum: s.value,
        type: "date"
      }), n.dirty()) : s.kind === "max" ? e.data.getTime() > s.value && (a = this._getOrReturnCtx(e, a), m(a, {
        code: p.too_big,
        message: s.message,
        inclusive: !0,
        exact: !1,
        maximum: s.value,
        type: "date"
      }), n.dirty()) : P.assertNever(s);
    return {
      status: n.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new Gt({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: g.toString(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: g.toString(r)
    });
  }
  get minDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
}
Gt.create = (t) => new Gt({
  checks: [],
  coerce: t?.coerce || !1,
  typeName: S.ZodDate,
  ...w(t)
});
class vu extends O {
  _parse(e) {
    if (this._getType(e) !== v.symbol) {
      const n = this._getOrReturnCtx(e);
      return m(n, {
        code: p.invalid_type,
        expected: v.symbol,
        received: n.parsedType
      }), R;
    }
    return oe(e.data);
  }
}
vu.create = (t) => new vu({
  typeName: S.ZodSymbol,
  ...w(t)
});
class as extends O {
  _parse(e) {
    if (this._getType(e) !== v.undefined) {
      const n = this._getOrReturnCtx(e);
      return m(n, {
        code: p.invalid_type,
        expected: v.undefined,
        received: n.parsedType
      }), R;
    }
    return oe(e.data);
  }
}
as.create = (t) => new as({
  typeName: S.ZodUndefined,
  ...w(t)
});
class ss extends O {
  _parse(e) {
    if (this._getType(e) !== v.null) {
      const n = this._getOrReturnCtx(e);
      return m(n, {
        code: p.invalid_type,
        expected: v.null,
        received: n.parsedType
      }), R;
    }
    return oe(e.data);
  }
}
ss.create = (t) => new ss({
  typeName: S.ZodNull,
  ...w(t)
});
class St extends O {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return oe(e.data);
  }
}
St.create = (t) => new St({
  typeName: S.ZodAny,
  ...w(t)
});
class gu extends O {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return oe(e.data);
  }
}
gu.create = (t) => new gu({
  typeName: S.ZodUnknown,
  ...w(t)
});
class ke extends O {
  _parse(e) {
    const r = this._getOrReturnCtx(e);
    return m(r, {
      code: p.invalid_type,
      expected: v.never,
      received: r.parsedType
    }), R;
  }
}
ke.create = (t) => new ke({
  typeName: S.ZodNever,
  ...w(t)
});
class _u extends O {
  _parse(e) {
    if (this._getType(e) !== v.undefined) {
      const n = this._getOrReturnCtx(e);
      return m(n, {
        code: p.invalid_type,
        expected: v.void,
        received: n.parsedType
      }), R;
    }
    return oe(e.data);
  }
}
_u.create = (t) => new _u({
  typeName: S.ZodVoid,
  ...w(t)
});
class ce extends O {
  _parse(e) {
    const { ctx: r, status: n } = this._processInputParams(e), a = this._def;
    if (r.parsedType !== v.array)
      return m(r, {
        code: p.invalid_type,
        expected: v.array,
        received: r.parsedType
      }), R;
    if (a.exactLength !== null) {
      const i = r.data.length > a.exactLength.value, o = r.data.length < a.exactLength.value;
      (i || o) && (m(r, {
        code: i ? p.too_big : p.too_small,
        minimum: o ? a.exactLength.value : void 0,
        maximum: i ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), n.dirty());
    }
    if (a.minLength !== null && r.data.length < a.minLength.value && (m(r, {
      code: p.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), n.dirty()), a.maxLength !== null && r.data.length > a.maxLength.value && (m(r, {
      code: p.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((i, o) => a.type._parseAsync(new le(r, i, r.path, o)))).then((i) => te.mergeArray(n, i));
    const s = [...r.data].map((i, o) => a.type._parseSync(new le(r, i, r.path, o)));
    return te.mergeArray(n, s);
  }
  get element() {
    return this._def.type;
  }
  min(e, r) {
    return new ce({
      ...this._def,
      minLength: { value: e, message: g.toString(r) }
    });
  }
  max(e, r) {
    return new ce({
      ...this._def,
      maxLength: { value: e, message: g.toString(r) }
    });
  }
  length(e, r) {
    return new ce({
      ...this._def,
      exactLength: { value: e, message: g.toString(r) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
ce.create = (t, e) => new ce({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: S.ZodArray,
  ...w(e)
});
function at(t) {
  if (t instanceof Z) {
    const e = {};
    for (const r in t.shape) {
      const n = t.shape[r];
      e[r] = be.create(at(n));
    }
    return new Z({
      ...t._def,
      shape: () => e
    });
  } else return t instanceof ce ? new ce({
    ...t._def,
    type: at(t.element)
  }) : t instanceof be ? be.create(at(t.unwrap())) : t instanceof Ke ? Ke.create(at(t.unwrap())) : t instanceof Ue ? Ue.create(t.items.map((e) => at(e))) : t;
}
class Z extends O {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), r = P.objectKeys(e);
    return this._cached = { shape: e, keys: r }, this._cached;
  }
  _parse(e) {
    if (this._getType(e) !== v.object) {
      const c = this._getOrReturnCtx(e);
      return m(c, {
        code: p.invalid_type,
        expected: v.object,
        received: c.parsedType
      }), R;
    }
    const { status: n, ctx: a } = this._processInputParams(e), { shape: s, keys: i } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof ke && this._def.unknownKeys === "strip"))
      for (const c in a.data)
        i.includes(c) || o.push(c);
    const l = [];
    for (const c of i) {
      const h = s[c], y = a.data[c];
      l.push({
        key: { status: "valid", value: c },
        value: h._parse(new le(a, y, a.path, c)),
        alwaysSet: c in a.data
      });
    }
    if (this._def.catchall instanceof ke) {
      const c = this._def.unknownKeys;
      if (c === "passthrough")
        for (const h of o)
          l.push({
            key: { status: "valid", value: h },
            value: { status: "valid", value: a.data[h] }
          });
      else if (c === "strict")
        o.length > 0 && (m(a, {
          code: p.unrecognized_keys,
          keys: o
        }), n.dirty());
      else if (c !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const c = this._def.catchall;
      for (const h of o) {
        const y = a.data[h];
        l.push({
          key: { status: "valid", value: h },
          value: c._parse(
            new le(a, y, a.path, h)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: h in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const c = [];
      for (const h of l) {
        const y = await h.key, A = await h.value;
        c.push({
          key: y,
          value: A,
          alwaysSet: h.alwaysSet
        });
      }
      return c;
    }).then((c) => te.mergeObjectSync(n, c)) : te.mergeObjectSync(n, l);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return g.errToObj, new Z({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (r, n) => {
          const a = this._def.errorMap?.(r, n).message ?? n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: g.errToObj(e).message ?? a
          } : {
            message: a
          };
        }
      } : {}
    });
  }
  strip() {
    return new Z({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new Z({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new Z({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new Z({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: S.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, r) {
    return this.augment({ [e]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new Z({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const r = {};
    for (const n of P.objectKeys(e))
      e[n] && this.shape[n] && (r[n] = this.shape[n]);
    return new Z({
      ...this._def,
      shape: () => r
    });
  }
  omit(e) {
    const r = {};
    for (const n of P.objectKeys(this.shape))
      e[n] || (r[n] = this.shape[n]);
    return new Z({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return at(this);
  }
  partial(e) {
    const r = {};
    for (const n of P.objectKeys(this.shape)) {
      const a = this.shape[n];
      e && !e[n] ? r[n] = a : r[n] = a.optional();
    }
    return new Z({
      ...this._def,
      shape: () => r
    });
  }
  required(e) {
    const r = {};
    for (const n of P.objectKeys(this.shape))
      if (e && !e[n])
        r[n] = this.shape[n];
      else {
        let s = this.shape[n];
        for (; s instanceof be; )
          s = s._def.innerType;
        r[n] = s;
      }
    return new Z({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return kc(P.objectKeys(this.shape));
  }
}
Z.create = (t, e) => new Z({
  shape: () => t,
  unknownKeys: "strip",
  catchall: ke.create(),
  typeName: S.ZodObject,
  ...w(e)
});
Z.strictCreate = (t, e) => new Z({
  shape: () => t,
  unknownKeys: "strict",
  catchall: ke.create(),
  typeName: S.ZodObject,
  ...w(e)
});
Z.lazycreate = (t, e) => new Z({
  shape: t,
  unknownKeys: "strip",
  catchall: ke.create(),
  typeName: S.ZodObject,
  ...w(e)
});
class Kt extends O {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = this._def.options;
    function a(s) {
      for (const o of s)
        if (o.result.status === "valid")
          return o.result;
      for (const o of s)
        if (o.result.status === "dirty")
          return r.common.issues.push(...o.ctx.common.issues), o.result;
      const i = s.map((o) => new Te(o.ctx.common.issues));
      return m(r, {
        code: p.invalid_union,
        unionErrors: i
      }), R;
    }
    if (r.common.async)
      return Promise.all(n.map(async (s) => {
        const i = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await s._parseAsync({
            data: r.data,
            path: r.path,
            parent: i
          }),
          ctx: i
        };
      })).then(a);
    {
      let s;
      const i = [];
      for (const l of n) {
        const c = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, h = l._parseSync({
          data: r.data,
          path: r.path,
          parent: c
        });
        if (h.status === "valid")
          return h;
        h.status === "dirty" && !s && (s = { result: h, ctx: c }), c.common.issues.length && i.push(c.common.issues);
      }
      if (s)
        return r.common.issues.push(...s.ctx.common.issues), s.result;
      const o = i.map((l) => new Te(l));
      return m(r, {
        code: p.invalid_union,
        unionErrors: o
      }), R;
    }
  }
  get options() {
    return this._def.options;
  }
}
Kt.create = (t, e) => new Kt({
  options: t,
  typeName: S.ZodUnion,
  ...w(e)
});
const ge = (t) => t instanceof Wt ? ge(t.schema) : t instanceof Ge ? ge(t.innerType()) : t instanceof Jt ? [t.value] : t instanceof Be ? t.options : t instanceof os ? P.objectValues(t.enum) : t instanceof Qt ? ge(t._def.innerType) : t instanceof as ? [void 0] : t instanceof ss ? [null] : t instanceof be ? [void 0, ...ge(t.unwrap())] : t instanceof Ke ? [null, ...ge(t.unwrap())] : t instanceof xc || t instanceof Xt ? ge(t.unwrap()) : t instanceof Yt ? ge(t._def.innerType) : [];
class Es extends O {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== v.object)
      return m(r, {
        code: p.invalid_type,
        expected: v.object,
        received: r.parsedType
      }), R;
    const n = this.discriminator, a = r.data[n], s = this.optionsMap.get(a);
    return s ? r.common.async ? s._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : s._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (m(r, {
      code: p.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), R);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, r, n) {
    const a = /* @__PURE__ */ new Map();
    for (const s of r) {
      const i = ge(s.shape[e]);
      if (!i.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const o of i) {
        if (a.has(o))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(o)}`);
        a.set(o, s);
      }
    }
    return new Es({
      typeName: S.ZodDiscriminatedUnion,
      discriminator: e,
      options: r,
      optionsMap: a,
      ...w(n)
    });
  }
}
function is(t, e) {
  const r = Ce(t), n = Ce(e);
  if (t === e)
    return { valid: !0, data: t };
  if (r === v.object && n === v.object) {
    const a = P.objectKeys(e), s = P.objectKeys(t).filter((o) => a.indexOf(o) !== -1), i = { ...t, ...e };
    for (const o of s) {
      const l = is(t[o], e[o]);
      if (!l.valid)
        return { valid: !1 };
      i[o] = l.data;
    }
    return { valid: !0, data: i };
  } else if (r === v.array && n === v.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const a = [];
    for (let s = 0; s < t.length; s++) {
      const i = t[s], o = e[s], l = is(i, o);
      if (!l.valid)
        return { valid: !1 };
      a.push(l.data);
    }
    return { valid: !0, data: a };
  } else return r === v.date && n === v.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
class Ft extends O {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), a = (s, i) => {
      if (pu(s) || pu(i))
        return R;
      const o = is(s.value, i.value);
      return o.valid ? ((yu(s) || yu(i)) && r.dirty(), { status: r.value, value: o.data }) : (m(n, {
        code: p.invalid_intersection_types
      }), R);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([s, i]) => a(s, i)) : a(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
Ft.create = (t, e, r) => new Ft({
  left: t,
  right: e,
  typeName: S.ZodIntersection,
  ...w(r)
});
class Ue extends O {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== v.array)
      return m(n, {
        code: p.invalid_type,
        expected: v.array,
        received: n.parsedType
      }), R;
    if (n.data.length < this._def.items.length)
      return m(n, {
        code: p.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), R;
    !this._def.rest && n.data.length > this._def.items.length && (m(n, {
      code: p.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const s = [...n.data].map((i, o) => {
      const l = this._def.items[o] || this._def.rest;
      return l ? l._parse(new le(n, i, n.path, o)) : null;
    }).filter((i) => !!i);
    return n.common.async ? Promise.all(s).then((i) => te.mergeArray(r, i)) : te.mergeArray(r, s);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new Ue({
      ...this._def,
      rest: e
    });
  }
}
Ue.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Ue({
    items: t,
    typeName: S.ZodTuple,
    rest: null,
    ...w(e)
  });
};
class Zt extends O {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== v.object)
      return m(n, {
        code: p.invalid_type,
        expected: v.object,
        received: n.parsedType
      }), R;
    const a = [], s = this._def.keyType, i = this._def.valueType;
    for (const o in n.data)
      a.push({
        key: s._parse(new le(n, o, n.path, o)),
        value: i._parse(new le(n, n.data[o], n.path, o)),
        alwaysSet: o in n.data
      });
    return n.common.async ? te.mergeObjectAsync(r, a) : te.mergeObjectSync(r, a);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, r, n) {
    return r instanceof O ? new Zt({
      keyType: e,
      valueType: r,
      typeName: S.ZodRecord,
      ...w(n)
    }) : new Zt({
      keyType: _e.create(),
      valueType: e,
      typeName: S.ZodRecord,
      ...w(r)
    });
  }
}
class bu extends O {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== v.map)
      return m(n, {
        code: p.invalid_type,
        expected: v.map,
        received: n.parsedType
      }), R;
    const a = this._def.keyType, s = this._def.valueType, i = [...n.data.entries()].map(([o, l], c) => ({
      key: a._parse(new le(n, o, n.path, [c, "key"])),
      value: s._parse(new le(n, l, n.path, [c, "value"]))
    }));
    if (n.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of i) {
          const c = await l.key, h = await l.value;
          if (c.status === "aborted" || h.status === "aborted")
            return R;
          (c.status === "dirty" || h.status === "dirty") && r.dirty(), o.set(c.value, h.value);
        }
        return { status: r.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const l of i) {
        const c = l.key, h = l.value;
        if (c.status === "aborted" || h.status === "aborted")
          return R;
        (c.status === "dirty" || h.status === "dirty") && r.dirty(), o.set(c.value, h.value);
      }
      return { status: r.value, value: o };
    }
  }
}
bu.create = (t, e, r) => new bu({
  valueType: e,
  keyType: t,
  typeName: S.ZodMap,
  ...w(r)
});
class At extends O {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== v.set)
      return m(n, {
        code: p.invalid_type,
        expected: v.set,
        received: n.parsedType
      }), R;
    const a = this._def;
    a.minSize !== null && n.data.size < a.minSize.value && (m(n, {
      code: p.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), r.dirty()), a.maxSize !== null && n.data.size > a.maxSize.value && (m(n, {
      code: p.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), r.dirty());
    const s = this._def.valueType;
    function i(l) {
      const c = /* @__PURE__ */ new Set();
      for (const h of l) {
        if (h.status === "aborted")
          return R;
        h.status === "dirty" && r.dirty(), c.add(h.value);
      }
      return { status: r.value, value: c };
    }
    const o = [...n.data.values()].map((l, c) => s._parse(new le(n, l, n.path, c)));
    return n.common.async ? Promise.all(o).then((l) => i(l)) : i(o);
  }
  min(e, r) {
    return new At({
      ...this._def,
      minSize: { value: e, message: g.toString(r) }
    });
  }
  max(e, r) {
    return new At({
      ...this._def,
      maxSize: { value: e, message: g.toString(r) }
    });
  }
  size(e, r) {
    return this.min(e, r).max(e, r);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
At.create = (t, e) => new At({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: S.ZodSet,
  ...w(e)
});
class Wt extends O {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
Wt.create = (t, e) => new Wt({
  getter: t,
  typeName: S.ZodLazy,
  ...w(e)
});
class Jt extends O {
  _parse(e) {
    if (e.data !== this._def.value) {
      const r = this._getOrReturnCtx(e);
      return m(r, {
        received: r.data,
        code: p.invalid_literal,
        expected: this._def.value
      }), R;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
Jt.create = (t, e) => new Jt({
  value: t,
  typeName: S.ZodLiteral,
  ...w(e)
});
function kc(t, e) {
  return new Be({
    values: t,
    typeName: S.ZodEnum,
    ...w(e)
  });
}
class Be extends O {
  constructor() {
    super(...arguments), _t.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return m(r, {
        expected: P.joinValues(n),
        received: r.parsedType,
        code: p.invalid_type
      }), R;
    }
    if (Bt(this, _t, "f") || wc(this, _t, new Set(this._def.values), "f"), !Bt(this, _t, "f").has(e.data)) {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return m(r, {
        received: r.data,
        code: p.invalid_enum_value,
        options: n
      }), R;
    }
    return oe(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Values() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  extract(e, r = this._def) {
    return Be.create(e, {
      ...this._def,
      ...r
    });
  }
  exclude(e, r = this._def) {
    return Be.create(this.options.filter((n) => !e.includes(n)), {
      ...this._def,
      ...r
    });
  }
}
_t = /* @__PURE__ */ new WeakMap();
Be.create = kc;
class os extends O {
  constructor() {
    super(...arguments), bt.set(this, void 0);
  }
  _parse(e) {
    const r = P.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
    if (n.parsedType !== v.string && n.parsedType !== v.number) {
      const a = P.objectValues(r);
      return m(n, {
        expected: P.joinValues(a),
        received: n.parsedType,
        code: p.invalid_type
      }), R;
    }
    if (Bt(this, bt, "f") || wc(this, bt, new Set(P.getValidEnumValues(this._def.values)), "f"), !Bt(this, bt, "f").has(e.data)) {
      const a = P.objectValues(r);
      return m(n, {
        received: n.data,
        code: p.invalid_enum_value,
        options: a
      }), R;
    }
    return oe(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
bt = /* @__PURE__ */ new WeakMap();
os.create = (t, e) => new os({
  values: t,
  typeName: S.ZodNativeEnum,
  ...w(e)
});
class zt extends O {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== v.promise && r.common.async === !1)
      return m(r, {
        code: p.invalid_type,
        expected: v.promise,
        received: r.parsedType
      }), R;
    const n = r.parsedType === v.promise ? r.data : Promise.resolve(r.data);
    return oe(n.then((a) => this._def.type.parseAsync(a, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
zt.create = (t, e) => new zt({
  type: t,
  typeName: S.ZodPromise,
  ...w(e)
});
class Ge extends O {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === S.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), a = this._def.effect || null, s = {
      addIssue: (i) => {
        m(n, i), i.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (s.addIssue = s.addIssue.bind(s), a.type === "preprocess") {
      const i = a.transform(n.data, s);
      if (n.common.async)
        return Promise.resolve(i).then(async (o) => {
          if (r.value === "aborted")
            return R;
          const l = await this._def.schema._parseAsync({
            data: o,
            path: n.path,
            parent: n
          });
          return l.status === "aborted" ? R : l.status === "dirty" || r.value === "dirty" ? gt(l.value) : l;
        });
      {
        if (r.value === "aborted")
          return R;
        const o = this._def.schema._parseSync({
          data: i,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? R : o.status === "dirty" || r.value === "dirty" ? gt(o.value) : o;
      }
    }
    if (a.type === "refinement") {
      const i = (o) => {
        const l = a.refinement(o, s);
        if (n.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? R : (o.status === "dirty" && r.dirty(), i(o.value), { status: r.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => o.status === "aborted" ? R : (o.status === "dirty" && r.dirty(), i(o.value).then(() => ({ status: r.value, value: o.value }))));
    }
    if (a.type === "transform")
      if (n.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!st(i))
          return i;
        const o = a.transform(i.value, s);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((i) => st(i) ? Promise.resolve(a.transform(i.value, s)).then((o) => ({
          status: r.value,
          value: o
        })) : i);
    P.assertNever(a);
  }
}
Ge.create = (t, e, r) => new Ge({
  schema: t,
  typeName: S.ZodEffects,
  effect: e,
  ...w(r)
});
Ge.createWithPreprocess = (t, e, r) => new Ge({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: S.ZodEffects,
  ...w(r)
});
class be extends O {
  _parse(e) {
    return this._getType(e) === v.undefined ? oe(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
be.create = (t, e) => new be({
  innerType: t,
  typeName: S.ZodOptional,
  ...w(e)
});
class Ke extends O {
  _parse(e) {
    return this._getType(e) === v.null ? oe(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ke.create = (t, e) => new Ke({
  innerType: t,
  typeName: S.ZodNullable,
  ...w(e)
});
class Qt extends O {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    let n = r.data;
    return r.parsedType === v.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Qt.create = (t, e) => new Qt({
  innerType: t,
  typeName: S.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...w(e)
});
class Yt extends O {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return Ut(a) ? a.then((s) => ({
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new Te(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new Te(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Yt.create = (t, e) => new Yt({
  innerType: t,
  typeName: S.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...w(e)
});
class Tu extends O {
  _parse(e) {
    if (this._getType(e) !== v.nan) {
      const n = this._getOrReturnCtx(e);
      return m(n, {
        code: p.invalid_type,
        expected: v.nan,
        received: n.parsedType
      }), R;
    }
    return { status: "valid", value: e.data };
  }
}
Tu.create = (t) => new Tu({
  typeName: S.ZodNaN,
  ...w(t)
});
class xc extends O {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class ws extends O {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.common.async)
      return (async () => {
        const s = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? R : s.status === "dirty" ? (r.dirty(), gt(s.value)) : this._def.out._parseAsync({
          data: s.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return a.status === "aborted" ? R : a.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(e, r) {
    return new ws({
      in: e,
      out: r,
      typeName: S.ZodPipeline
    });
  }
}
class Xt extends O {
  _parse(e) {
    const r = this._def.innerType._parse(e), n = (a) => (st(a) && (a.value = Object.freeze(a.value)), a);
    return Ut(r) ? r.then((a) => n(a)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Xt.create = (t, e) => new Xt({
  innerType: t,
  typeName: S.ZodReadonly,
  ...w(e)
});
function Su(t, e) {
  const r = typeof t == "function" ? t(e) : typeof t == "string" ? { message: t } : t;
  return typeof r == "string" ? { message: r } : r;
}
function Cs(t, e = {}, r) {
  return t ? St.create().superRefine((n, a) => {
    const s = t(n);
    if (s instanceof Promise)
      return s.then((i) => {
        if (!i) {
          const o = Su(e, n), l = o.fatal ?? r ?? !0;
          a.addIssue({ code: "custom", ...o, fatal: l });
        }
      });
    if (!s) {
      const i = Su(e, n), o = i.fatal ?? r ?? !0;
      a.addIssue({ code: "custom", ...i, fatal: o });
    }
  }) : St.create();
}
var S;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(S || (S = {}));
const yr = (t, e = {
  message: `Input not instance of ${t.name}`
}) => Cs((r) => r instanceof t, e), u = _e.create, Se = it.create, E = ns.create;
St.create;
ke.create;
const b = ce.create, f = Z.create, L = Kt.create, U = Es.create;
Ft.create;
Ue.create;
const Oc = Zt.create, ae = Wt.create, d = Jt.create, W = Be.create;
zt.create;
const ie = be.create;
Ke.create;
var _ = (t) => t, Wh = class {
  /**
   * @package
   */
  constructor(t, e, r) {
    this.versionMap = t, this.latestVersion = e, this.getVersion = r;
  }
  /**
   * Returns whether the given data is a valid entity of any version of the entity.
   * @param data The data to check
   * @returns Whether the given data is a valid entity of any version of the entity.
   */
  is(t) {
    let e = this.getVersion(t);
    if (e === null) return !1;
    const r = this.versionMap[e];
    return r ? r.schema.safeParse(t).success : !1;
  }
  /**
   * Returns whether the given data is a valid entity of the latest version of the entity.
   * @param data The data to check
   * @returns Whether the given data is a valid entity of the latest version of the entity.
   */
  isLatest(t) {
    return this.versionMap[this.latestVersion].schema.safeParse(t).success;
  }
  /**
   * Type guard that checks if data is valid for any version up to and including the specified version.
   * 
   * @param data The data to check
   * @param upToVersion The maximum version to check against (inclusive)
   * @returns true if the data is valid for any version from 1 to upToVersion,
   *          false if the data's version is higher than upToVersion or invalid
   * 
   * @example
   * ```ts
   * const entity = createVersionedEntity({ ... })
   * 
   * if (entity.isUpToVersion(data, 2)) {
   *   // data is guaranteed to be v1 or v2 (but not v3 or higher)
   * }
   * 
   * // Returns false for v3 data when checking up to v2
   * entity.isUpToVersion(v3Data, 2) // false
   * ```
   * 
   * Note: This is particularly useful for recursive entity definitions where you want to ensure
   * nested entities are at a specific version or lower.
   */
  isUpToVersion(t, e) {
    let r = this.getVersion(t);
    if (r === null || r > e) return !1;
    const n = this.versionMap[r];
    return n ? n.schema.safeParse(t).success : !1;
  }
  /**
   * Similar to Zod's `safeParse` method, but also migrates the data to the latest version.
   * @param data The data to parse
   * @returns The result from parsing data, if successful, older versions are migrated to the latest version
   */
  safeParse(t) {
    const e = this.getVersion(t);
    if (e === null)
      return { type: "err", error: { type: "VER_CHECK_FAIL" } };
    const r = this.versionMap[e];
    if (!r)
      return { type: "err", error: { type: "INVALID_VER" } };
    const n = r.schema.safeParse(t);
    if (!n.success)
      return {
        type: "err",
        error: {
          type: "GIVEN_VER_VALIDATION_FAIL",
          version: e,
          versionDef: r,
          error: n.error
        }
      };
    let a = n.data;
    for (let s = e + 1; s <= this.latestVersion; s++) {
      const i = this.versionMap[s];
      if (!i)
        return {
          type: "err",
          error: { type: "BUG_NO_INTERMEDIATE_FOUND", missingVer: s }
        };
      if (i.initial)
        return {
          type: "err",
          error: { type: "BUG_INTERMEDIATE_MARKED_INITIAL", ver: s }
        };
      a = i.up(a);
    }
    return { type: "ok", value: a };
  }
  /**
   * Returns the Zod schema for the latest version of the entity.
   * 
   * @example
   * ```ts
   * const UserEntity = createVersionedEntity({ ... })
   * const latestSchema = UserEntity.latestSchema
   * ```
   */
  get latestSchema() {
    return this.versionMap[this.latestVersion].schema;
  }
  /**
   * Parses data and migrates it up to a specific version (not beyond).
   * 
   * @param data The data to parse and potentially migrate
   * @param version The target version to migrate to (will not migrate beyond this)
   * @returns A ParseResult containing either the migrated data or an error.
   *          Returns { type: "err", error: { type: "INVALID_VER" } } if data version is higher than requested.
   * 
   * @example
   * ```ts
   * // If you have v1 data and versions up to v4 exist:
   * const result = entity.safeParseUpToVersion(v1Data, 2)
   * // result will contain v2 data (not v3 or v4)
   * 
   * // Trying to parse v3 data up to v2 returns an error
   * const result = entity.safeParseUpToVersion(v3Data, 2)
   * // result: { type: "err", error: { type: "INVALID_VER" } }
   * ```
   * 
   * Note: This is particularly useful for recursive entity definitions to prevent migration
   * functions from receiving future versions they weren't designed to handle.
   */
  safeParseUpToVersion(t, e) {
    const r = this.getVersion(t);
    if (r === null)
      return { type: "err", error: { type: "VER_CHECK_FAIL" } };
    if (r > e)
      return { type: "err", error: { type: "INVALID_VER" } };
    const n = this.versionMap[r];
    if (!n)
      return { type: "err", error: { type: "INVALID_VER" } };
    const a = n.schema.safeParse(t);
    if (!a.success)
      return {
        type: "err",
        error: {
          type: "GIVEN_VER_VALIDATION_FAIL",
          version: r,
          versionDef: n,
          error: a.error
        }
      };
    let s = a.data;
    for (let i = r + 1; i <= e; i++) {
      const o = this.versionMap[i];
      if (!o)
        return {
          type: "err",
          error: { type: "BUG_NO_INTERMEDIATE_FOUND", missingVer: i }
        };
      if (o.initial)
        return {
          type: "err",
          error: { type: "BUG_INTERMEDIATE_MARKED_INITIAL", ver: i }
        };
      s = o.up(s);
    }
    return { type: "ok", value: s };
  }
};
function Ae(t) {
  return new Wh(t.versionMap, t.latestVersion, t.getVersion);
}
function xe(t) {
  return Cs((e) => t.is(e)).transform((e) => {
    const r = t.safeParse(e);
    if (r.type !== "ok")
      throw new Error(
        "Invalid entity definition. `entity.is` returned success, safeParse failed."
      );
    return r.value;
  });
}
function ue(t, e) {
  return Cs((r) => t.isUpToVersion(r, e)).transform((r) => {
    const n = t.safeParseUpToVersion(r, e);
    if (n.type !== "ok")
      throw new Error(
        "Invalid entity definition. `entity.isUpToVersion` returned success, safeParse failed."
      );
    return n.value;
  });
}
var qa, Au;
function Jh() {
  if (Au) return qa;
  Au = 1;
  var t = "__lodash_hash_undefined__";
  function e(r) {
    return this.__data__.set(r, t), this;
  }
  return qa = e, qa;
}
var Va, Ru;
function zh() {
  if (Ru) return Va;
  Ru = 1;
  function t(e) {
    return this.__data__.has(e);
  }
  return Va = t, Va;
}
var Pa, Eu;
function Qh() {
  if (Eu) return Pa;
  Eu = 1;
  var t = lc(), e = Jh(), r = zh();
  function n(a) {
    var s = -1, i = a == null ? 0 : a.length;
    for (this.__data__ = new t(); ++s < i; )
      this.add(a[s]);
  }
  return n.prototype.add = n.prototype.push = e, n.prototype.has = r, Pa = n, Pa;
}
var Na, wu;
function Yh() {
  if (wu) return Na;
  wu = 1;
  function t(e, r) {
    for (var n = -1, a = e == null ? 0 : e.length; ++n < a; )
      if (r(e[n], n, e))
        return !0;
    return !1;
  }
  return Na = t, Na;
}
var $a, Cu;
function Xh() {
  if (Cu) return $a;
  Cu = 1;
  function t(e, r) {
    return e.has(r);
  }
  return $a = t, $a;
}
var Ma, Iu;
function qc() {
  if (Iu) return Ma;
  Iu = 1;
  var t = Qh(), e = Yh(), r = Xh(), n = 1, a = 2;
  function s(i, o, l, c, h, y) {
    var A = l & n, k = i.length, F = o.length;
    if (k != F && !(A && F > k))
      return !1;
    var j = y.get(i), $ = y.get(o);
    if (j && $)
      return j == o && $ == i;
    var N = -1, C = !0, B = l & a ? new t() : void 0;
    for (y.set(i, o), y.set(o, i); ++N < k; ) {
      var q = i[N], G = o[N];
      if (c)
        var V = A ? c(G, q, N, o, i, y) : c(q, G, N, i, o, y);
      if (V !== void 0) {
        if (V)
          continue;
        C = !1;
        break;
      }
      if (B) {
        if (!e(o, function(x, J) {
          if (!r(B, J) && (q === x || h(q, x, l, c, y)))
            return B.push(J);
        })) {
          C = !1;
          break;
        }
      } else if (!(q === G || h(q, G, l, c, y))) {
        C = !1;
        break;
      }
    }
    return y.delete(i), y.delete(o), C;
  }
  return Ma = s, Ma;
}
var ja, ku;
function ep() {
  if (ku) return ja;
  ku = 1;
  function t(e) {
    var r = -1, n = Array(e.size);
    return e.forEach(function(a, s) {
      n[++r] = [s, a];
    }), n;
  }
  return ja = t, ja;
}
var Da, xu;
function tp() {
  if (xu) return Da;
  xu = 1;
  function t(e) {
    var r = -1, n = Array(e.size);
    return e.forEach(function(a) {
      n[++r] = a;
    }), n;
  }
  return Da = t, Da;
}
var Ha, Ou;
function rp() {
  if (Ou) return Ha;
  Ou = 1;
  var t = ur(), e = Ec(), r = ys(), n = qc(), a = ep(), s = tp(), i = 1, o = 2, l = "[object Boolean]", c = "[object Date]", h = "[object Error]", y = "[object Map]", A = "[object Number]", k = "[object RegExp]", F = "[object Set]", j = "[object String]", $ = "[object Symbol]", N = "[object ArrayBuffer]", C = "[object DataView]", B = t ? t.prototype : void 0, q = B ? B.valueOf : void 0;
  function G(V, x, J, D, re, I, ee) {
    switch (J) {
      case C:
        if (V.byteLength != x.byteLength || V.byteOffset != x.byteOffset)
          return !1;
        V = V.buffer, x = x.buffer;
      case N:
        return !(V.byteLength != x.byteLength || !I(new e(V), new e(x)));
      case l:
      case c:
      case A:
        return r(+V, +x);
      case h:
        return V.name == x.name && V.message == x.message;
      case k:
      case j:
        return V == x + "";
      case y:
        var se = a;
      case F:
        var Qe = D & i;
        if (se || (se = s), V.size != x.size && !Qe)
          return !1;
        var Ye = ee.get(V);
        if (Ye)
          return Ye == x;
        D |= o, ee.set(V, x);
        var Or = n(se(V), se(x), D, re, I, ee);
        return ee.delete(V), Or;
      case $:
        if (q)
          return q.call(V) == q.call(x);
    }
    return !1;
  }
  return Ha = G, Ha;
}
var La, qu;
function np() {
  if (qu) return La;
  qu = 1;
  var t = Rc(), e = 1, r = Object.prototype, n = r.hasOwnProperty;
  function a(s, i, o, l, c, h) {
    var y = o & e, A = t(s), k = A.length, F = t(i), j = F.length;
    if (k != j && !y)
      return !1;
    for (var $ = k; $--; ) {
      var N = A[$];
      if (!(y ? N in i : n.call(i, N)))
        return !1;
    }
    var C = h.get(s), B = h.get(i);
    if (C && B)
      return C == i && B == s;
    var q = !0;
    h.set(s, i), h.set(i, s);
    for (var G = y; ++$ < k; ) {
      N = A[$];
      var V = s[N], x = i[N];
      if (l)
        var J = y ? l(x, V, N, i, s, h) : l(V, x, N, s, i, h);
      if (!(J === void 0 ? V === x || c(V, x, o, l, h) : J)) {
        q = !1;
        break;
      }
      G || (G = N == "constructor");
    }
    if (q && !G) {
      var D = s.constructor, re = i.constructor;
      D != re && "constructor" in s && "constructor" in i && !(typeof D == "function" && D instanceof D && typeof re == "function" && re instanceof re) && (q = !1);
    }
    return h.delete(s), h.delete(i), q;
  }
  return La = a, La;
}
var Ua, Vu;
function ap() {
  if (Vu) return Ua;
  Vu = 1;
  var t = dc(), e = qc(), r = rp(), n = np(), a = pr(), s = hr(), i = vs(), o = yc(), l = 1, c = "[object Arguments]", h = "[object Array]", y = "[object Object]", A = Object.prototype, k = A.hasOwnProperty;
  function F(j, $, N, C, B, q) {
    var G = s(j), V = s($), x = G ? h : a(j), J = V ? h : a($);
    x = x == c ? y : x, J = J == c ? y : J;
    var D = x == y, re = J == y, I = x == J;
    if (I && i(j)) {
      if (!i($))
        return !1;
      G = !0, D = !1;
    }
    if (I && !D)
      return q || (q = new t()), G || o(j) ? e(j, $, N, C, B, q) : r(j, $, x, N, C, B, q);
    if (!(N & l)) {
      var ee = D && k.call(j, "__wrapped__"), se = re && k.call($, "__wrapped__");
      if (ee || se) {
        var Qe = ee ? j.value() : j, Ye = se ? $.value() : $;
        return q || (q = new t()), B(Qe, Ye, N, C, q);
      }
    }
    return I ? (q || (q = new t()), n(j, $, N, C, B, q)) : !1;
  }
  return Ua = F, Ua;
}
var Ba, Pu;
function sp() {
  if (Pu) return Ba;
  Pu = 1;
  var t = ap(), e = ft();
  function r(n, a, s, i, o) {
    return n === a ? !0 : n == null || a == null || !e(n) && !e(a) ? n !== n && a !== a : t(n, a, s, i, r, o);
  }
  return Ba = r, Ba;
}
var Ga, Nu;
function ip() {
  if (Nu) return Ga;
  Nu = 1;
  var t = sp();
  function e(r, n) {
    return t(r, n);
  }
  return Ga = e, Ga;
}
var op = ip();
const up = /* @__PURE__ */ ic(op), $u = (t) => ({
  equals(e, r) {
    return e !== void 0 && r !== void 0 ? t.equals(e, r) : e === void 0 && r === void 0;
  }
}), Ka = (t, e) => ({
  equals(r, n) {
    return e.equals(t(r), t(n));
  }
}), Le = {
  equals(t, e) {
    return up(t, e);
  }
}, cp = f({
  id: ie(u()),
  // Firebase Firestore ID
  url: u(),
  path: u(),
  headers: b(
    f({
      key: u(),
      value: u(),
      active: E()
    })
  ),
  params: b(
    f({
      key: u(),
      value: u(),
      active: E()
    })
  ),
  name: u(),
  method: u(),
  preRequestScript: u(),
  testScript: u(),
  contentType: u(),
  body: u(),
  rawParams: ie(u()),
  auth: ie(u()),
  httpUser: ie(u()),
  httpPassword: ie(u()),
  bearerToken: ie(u())
}), Mu = _({
  initial: !0,
  schema: cp
}), Is = f({
  key: u(),
  active: E()
}).and(
  L([
    f({
      isFile: d(!0),
      value: b(yr(Blob).nullable())
    }),
    f({
      isFile: d(!1),
      value: u()
    })
  ])
);
f({
  contentType: d("multipart/form-data"),
  body: b(Is)
});
const lp = L([
  f({
    contentType: d(null),
    body: d(null).catch(null)
  }),
  f({
    contentType: d("multipart/form-data"),
    body: b(Is).catch([])
  }),
  f({
    contentType: L([
      d("application/json"),
      d("application/ld+json"),
      d("application/hal+json"),
      d("application/vnd.api+json"),
      d("application/xml"),
      d("application/x-www-form-urlencoded"),
      d("text/html"),
      d("text/plain")
    ]),
    body: u().catch("")
  })
]), he = f({
  authType: d("none")
}), pe = f({
  authType: d("basic"),
  username: u().catch(""),
  password: u().catch("")
}), ye = f({
  authType: d("bearer"),
  token: u().catch("")
}), dp = f({
  authType: d("oauth-2"),
  token: u().catch(""),
  oidcDiscoveryURL: u().catch(""),
  authURL: u().catch(""),
  accessTokenURL: u().catch(""),
  clientID: u().catch(""),
  scope: u().catch("")
}), ks = f({
  authType: d("api-key"),
  key: u().catch(""),
  value: u().catch(""),
  addTo: u().catch("Headers")
}), me = f({
  authType: d("inherit")
}), fp = U("authType", [
  he,
  me,
  pe,
  ye,
  dp,
  ks
]).and(
  f({
    authActive: E()
  })
), hp = b(
  f({
    key: u().catch(""),
    value: u().catch(""),
    active: E().catch(!0)
  })
), Vc = b(
  f({
    key: u().catch(""),
    value: u().catch(""),
    active: E().catch(!0)
  })
), Pc = f({
  v: d("1"),
  id: ie(u()),
  // Firebase Firestore ID
  name: u(),
  method: u(),
  endpoint: u(),
  params: hp,
  headers: Vc,
  preRequestScript: u().catch(""),
  testScript: u().catch(""),
  auth: fp,
  body: lp
});
function pp(t) {
  return {
    contentType: "application/json",
    body: t.contentType === "application/json" ? t.rawParams ?? "" : ""
  };
}
function yp(t) {
  return !t.auth || t.auth === "None" ? {
    authType: "none",
    authActive: !0
  } : t.auth === "Basic Auth" ? {
    authType: "basic",
    authActive: !0,
    username: t.httpUser ?? "",
    password: t.httpPassword ?? ""
  } : t.auth === "Bearer Token" ? {
    authType: "bearer",
    authActive: !0,
    token: t.bearerToken ?? ""
  } : { authType: "none", authActive: !0 };
}
const mp = _({
  initial: !1,
  schema: Pc,
  up(t) {
    const {
      url: e,
      path: r,
      headers: n,
      params: a,
      name: s,
      method: i,
      preRequestScript: o,
      testScript: l
    } = t, c = `${e}${r}`, h = pp(t), y = yp(t), A = {
      v: "1",
      endpoint: c,
      headers: n,
      params: a,
      name: s,
      method: i,
      preRequestScript: o,
      testScript: l,
      body: h,
      auth: y
    };
    return t.id && (A.id = t.id), A;
  }
}), xs = b(
  f({
    key: u().catch(""),
    value: u().catch(""),
    active: E().catch(!0)
  })
), Nc = Pc.extend({
  v: d("2"),
  requestVariables: xs
}), vp = _({
  initial: !1,
  schema: Nc,
  up(t) {
    return {
      ...t,
      v: "2",
      requestVariables: []
    };
  }
}), $c = f({
  grantType: d("AUTHORIZATION_CODE"),
  authEndpoint: u().trim(),
  tokenEndpoint: u().trim(),
  clientID: u().trim(),
  clientSecret: u().trim(),
  scopes: u().trim().optional(),
  token: u().catch(""),
  isPKCE: E(),
  codeVerifierMethod: L([d("plain"), d("S256")]).optional()
}), mr = f({
  grantType: d("CLIENT_CREDENTIALS"),
  authEndpoint: u().trim(),
  clientID: u().trim(),
  clientSecret: u().trim(),
  scopes: u().trim().optional(),
  token: u().catch("")
}), vr = f({
  grantType: d("PASSWORD"),
  authEndpoint: u().trim(),
  clientID: u().trim(),
  clientSecret: u().trim(),
  scopes: u().trim().optional(),
  username: u().trim(),
  password: u().trim(),
  token: u().catch("")
}), ht = f({
  grantType: d("IMPLICIT"),
  authEndpoint: u().trim(),
  clientID: u().trim(),
  scopes: u().trim().optional(),
  token: u().catch("")
}), gr = f({
  authType: d("oauth-2"),
  grantTypeInfo: U("grantType", [
    $c,
    mr,
    vr,
    ht
  ]),
  addTo: W(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), gp = U("authType", [
  he,
  me,
  pe,
  ye,
  gr,
  ks
]).and(
  f({
    authActive: E()
  })
), Mc = Nc.extend({
  v: d("3"),
  auth: gp
}), _p = _({
  initial: !1,
  schema: Mc,
  up(t) {
    if (t.auth.authType === "oauth-2") {
      const { token: e, accessTokenURL: r, scope: n, clientID: a, authURL: s } = t.auth;
      return {
        ...t,
        v: "3",
        auth: {
          ...t.auth,
          authType: "oauth-2",
          grantTypeInfo: {
            grantType: "AUTHORIZATION_CODE",
            authEndpoint: s,
            tokenEndpoint: r,
            clientID: a,
            clientSecret: "",
            scopes: n,
            isPKCE: !1,
            token: e
          },
          addTo: "HEADERS"
        }
      };
    }
    return {
      ...t,
      v: "3",
      auth: {
        ...t.auth
      }
    };
  }
}), Ve = ks.extend({
  addTo: W(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), bp = U("authType", [
  he,
  me,
  pe,
  ye,
  gr,
  Ve
]).and(
  f({
    authActive: E()
  })
), jc = Mc.extend({
  v: d("4"),
  auth: bp
}), Tp = _({
  schema: jc,
  initial: !1,
  up(t) {
    return t.auth.authType === "api-key" ? {
      ...t,
      v: "4",
      auth: {
        ...t.auth,
        addTo: t.auth.addTo === "Query params" ? "QUERY_PARAMS" : "HEADERS"
      }
    } : {
      ...t,
      auth: {
        ...t.auth
      },
      v: "4"
    };
  }
}), Dc = $c.extend({
  clientSecret: u().optional()
}), _r = gr.extend({
  grantTypeInfo: U("grantType", [
    Dc,
    mr,
    vr,
    ht
  ])
}), Hc = U("authType", [
  he,
  me,
  pe,
  ye,
  _r,
  Ve
]).and(
  f({
    authActive: E()
  })
), Lc = jc.extend({
  v: d("5"),
  auth: Hc
}), Sp = _({
  schema: Lc,
  initial: !1,
  up(t) {
    return {
      ...t,
      v: "5"
    };
  }
}), Uc = L([
  f({
    contentType: d(null),
    body: d(null).catch(null)
  }),
  f({
    contentType: d("multipart/form-data"),
    body: b(Is).catch([])
  }),
  f({
    contentType: L([
      d("application/json"),
      d("application/ld+json"),
      d("application/hal+json"),
      d("application/vnd.api+json"),
      d("application/xml"),
      d("text/xml"),
      d("application/x-www-form-urlencoded"),
      d("text/html"),
      d("text/plain")
    ]),
    body: u().catch("")
  })
]), Bc = Lc.extend({
  v: d("6"),
  body: Uc
}), Ap = _({
  schema: Bc,
  initial: !1,
  up(t) {
    return {
      ...t,
      v: "6"
    };
  }
}), br = Dc.extend({
  refreshToken: u().optional()
}), Gc = f({
  authType: d("oauth-2"),
  grantTypeInfo: U("grantType", [
    br,
    mr,
    vr,
    ht
  ]),
  addTo: W(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Os = b(
  f({
    key: u().catch(""),
    value: u().catch(""),
    active: E().catch(!0),
    description: u().catch("")
  })
), Tr = b(
  f({
    key: u().catch(""),
    value: u().catch(""),
    active: E().catch(!0),
    description: u().catch("")
  })
), Ze = f({
  authType: d("aws-signature"),
  accessKey: u().catch(""),
  secretKey: u().catch(""),
  region: u().catch(""),
  serviceName: u().catch(""),
  serviceToken: u().optional(),
  signature: f({}).optional(),
  addTo: W(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Kc = U("authType", [
  he,
  me,
  pe,
  ye,
  Gc,
  Ve,
  Ze
]).and(
  f({
    authActive: E()
  })
), Fc = Bc.extend({
  v: d("7"),
  params: Os,
  headers: Tr,
  auth: Kc
}), Rp = _({
  schema: Fc,
  initial: !1,
  up(t) {
    const e = t.params.map((n) => ({
      ...n,
      description: ""
    })), r = t.headers.map((n) => ({
      ...n,
      description: ""
    }));
    return {
      ...t,
      v: "7",
      params: e,
      headers: r
      // no need to update anything for HoppRESTAuth, because the newly added refreshToken is optional
    };
  }
}), Zc = mr.extend({
  clientSecret: u().optional()
}), qs = vr.extend({
  clientSecret: u().optional()
}), Ep = f({
  authType: d("oauth-2"),
  grantTypeInfo: U("grantType", [
    br,
    Zc,
    qs,
    ht
  ]),
  addTo: W(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), wt = f({
  authType: d("digest"),
  username: u().catch(""),
  password: u().catch(""),
  realm: u().catch(""),
  nonce: u().catch(""),
  algorithm: W(["MD5", "MD5-sess"]).catch("MD5"),
  qop: W(["auth", "auth-int"]).catch("auth"),
  nc: u().catch(""),
  cnonce: u().catch(""),
  opaque: u().catch(""),
  disableRetry: E().catch(!1)
}), Vs = U("authType", [
  he,
  me,
  pe,
  ye,
  Ep,
  Ve,
  Ze,
  wt
]).and(
  f({
    authActive: E()
  })
), Wc = f({
  v: d("1"),
  name: u(),
  method: u(),
  endpoint: u(),
  headers: Tr,
  params: Os,
  body: Uc,
  auth: Vs,
  requestVariables: xs
}), ju = _({
  initial: !0,
  schema: Wc
}), Jc = f({
  key: u(),
  active: E(),
  contentType: u().optional().catch(void 0)
}).and(
  L([
    f({
      isFile: d(!0),
      value: b(yr(Blob).nullable()).catch([])
    }),
    f({
      isFile: d(!1),
      value: u()
    })
  ])
).transform((t) => t.isFile && Array.isArray(t.value) && t.value.length === 0 ? {
  ...t,
  isFile: !1,
  value: ""
} : t), zc = L([
  f({
    contentType: d(null),
    body: d(null).catch(null)
  }),
  f({
    contentType: d("multipart/form-data"),
    body: b(Jc).catch([]),
    showIndividualContentType: E().optional().catch(!1)
  }),
  f({
    contentType: d("application/octet-stream"),
    body: yr(File).nullable().catch(null)
  }),
  f({
    contentType: L([
      d("application/json"),
      d("application/ld+json"),
      d("application/hal+json"),
      d("application/vnd.api+json"),
      d("application/xml"),
      d("text/xml"),
      d("application/x-www-form-urlencoded"),
      d("binary"),
      d("text/html"),
      d("text/plain")
    ]),
    body: u().catch("")
  })
]), Qc = Wc.extend({
  v: d("2"),
  body: zc
}), wp = _({
  initial: !1,
  schema: Qc,
  up(t) {
    return {
      ...t,
      v: "2"
    };
  }
}), Yc = Zc.extend({
  clientAuthentication: W(["AS_BASIC_AUTH_HEADERS", "IN_BODY"])
}), Sr = f({
  authType: d("oauth-2"),
  grantTypeInfo: U("grantType", [
    br,
    Yc,
    qs,
    ht
  ]),
  addTo: W(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Ps = U("authType", [
  he,
  me,
  pe,
  ye,
  Sr,
  Ve,
  Ze,
  wt
]).and(
  f({
    authActive: E()
  })
), Ns = L([
  f({
    contentType: d(null),
    body: d(null).catch(null)
  }),
  f({
    contentType: d("multipart/form-data"),
    body: b(Jc).catch([]),
    showIndividualContentType: E().optional().catch(!1),
    isBulkEditing: E().optional().catch(!1)
  }),
  f({
    contentType: d("application/octet-stream"),
    body: yr(File).nullable().catch(null)
  }),
  f({
    contentType: d("application/x-www-form-urlencoded"),
    body: u().catch(""),
    isBulkEditing: E().optional().catch(!1)
  }),
  f({
    contentType: L([
      d("application/json"),
      d("application/ld+json"),
      d("application/hal+json"),
      d("application/vnd.api+json"),
      d("application/xml"),
      d("text/xml"),
      d("binary"),
      d("text/html"),
      d("text/plain")
    ]),
    body: u().catch("")
  })
]), Xc = Qc.extend({
  v: d("3"),
  auth: Ps,
  body: Ns
}), Cp = _({
  initial: !1,
  schema: Xc,
  up(t) {
    const e = t.auth;
    return {
      ...t,
      v: "3",
      auth: e.authType === "oauth-2" ? {
        ...e,
        grantTypeInfo: e.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
          ...e.grantTypeInfo,
          clientAuthentication: "IN_BODY"
        } : e.grantTypeInfo
      } : e
    };
  }
}), $s = f({
  authType: d("hawk"),
  authId: u().catch(""),
  authKey: u().catch(""),
  algorithm: W(["sha256", "sha1"]).catch("sha256"),
  includePayloadHash: E().catch(!1),
  // Optional fields
  user: u().optional(),
  nonce: u().optional(),
  ext: u().optional(),
  app: u().optional(),
  dlg: u().optional(),
  timestamp: u().optional()
}), Ms = f({
  authType: d("akamai-eg"),
  accessToken: u().catch(""),
  clientToken: u().catch(""),
  clientSecret: u().catch(""),
  // Optional fields
  nonce: u().optional(),
  timestamp: u().optional(),
  host: u().optional(),
  headersToSign: u().optional(),
  maxBodySize: u().optional()
}), js = U("authType", [
  he,
  me,
  pe,
  ye,
  Sr,
  Ve,
  Ze,
  wt,
  $s,
  Ms
]).and(
  f({
    authActive: E()
  })
), el = Xc.extend({
  v: d("4"),
  auth: js
}), Ip = _({
  initial: !1,
  schema: el,
  up(t) {
    return {
      ...t,
      v: "4"
    };
  }
}), tl = f({
  authType: d("jwt"),
  secret: u().catch(""),
  privateKey: u().catch(""),
  // For RSA/ECDSA algorithms
  algorithm: W([
    "HS256",
    "HS384",
    "HS512",
    "RS256",
    "RS384",
    "RS512",
    "PS256",
    "PS384",
    "PS512",
    "ES256",
    "ES384",
    "ES512"
  ]).catch("HS256"),
  payload: u().catch("{}"),
  addTo: W(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS"),
  isSecretBase64Encoded: E().catch(!1),
  headerPrefix: u().catch("Bearer "),
  paramName: u().catch("token"),
  jwtHeaders: u().catch("{}")
}), Ds = U("authType", [
  he,
  me,
  pe,
  ye,
  Sr,
  Ve,
  Ze,
  wt,
  $s,
  Ms,
  tl
]).and(
  f({
    authActive: E()
  })
), rl = el.extend({
  v: d("5"),
  auth: Ds
}), kp = _({
  initial: !1,
  schema: rl,
  up(t) {
    return {
      ...t,
      v: "5"
    };
  }
}), Oe = f({
  id: Se(),
  key: u(),
  value: u(),
  active: E(),
  sendIn: W(["headers", "url", "body"]).catch("headers")
}), nl = Oe.omit({ sendIn: !0 }), xp = br.extend({
  authRequestParams: b(nl).optional().default([]),
  tokenRequestParams: b(Oe).optional().default([]),
  refreshRequestParams: b(Oe).optional().default([]),
  tokenType: W(["access_token", "id_token"]).optional().catch("access_token")
}), Op = Yc.extend({
  tokenRequestParams: b(Oe).optional().default([]),
  refreshRequestParams: b(Oe).optional().default([]),
  tokenType: W(["access_token", "id_token"]).optional().catch("access_token")
}), qp = qs.extend({
  tokenRequestParams: b(Oe).optional().default([]),
  refreshRequestParams: b(Oe).optional().default([]),
  tokenType: W(["access_token", "id_token"]).optional().catch("access_token")
}), Vp = ht.extend({
  authRequestParams: b(nl).optional().default([]),
  refreshRequestParams: b(Oe).optional().default([]),
  tokenType: W(["access_token", "id_token"]).optional().catch("access_token")
}), al = f({
  authType: d("oauth-2"),
  grantTypeInfo: U("grantType", [
    xp,
    Op,
    qp,
    Vp
  ]),
  addTo: W(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Ar = U("authType", [
  he,
  me,
  pe,
  ye,
  al,
  Ve,
  Ze,
  wt,
  $s,
  Ms,
  tl
]).and(
  f({
    authActive: E()
  })
), Pp = rl.extend({
  v: d("6"),
  auth: Ar
}), Np = _({
  initial: !1,
  schema: Pp,
  up(t) {
    let e;
    if (t.auth.authType === "oauth-2") {
      const r = t.auth.grantTypeInfo;
      let n;
      r.grantType === "AUTHORIZATION_CODE" ? n = {
        ...r,
        authRequestParams: [],
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "CLIENT_CREDENTIALS" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "PASSWORD" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "IMPLICIT" ? n = {
        ...r,
        authRequestParams: [],
        refreshRequestParams: []
      } : n = r, e = {
        ...t.auth,
        grantTypeInfo: n
      };
    } else
      e = t.auth;
    return {
      ...t,
      v: "6",
      auth: e
    };
  }
}), $p = f({
  // v is a stringified number
  v: u().regex(/^\d+$/).transform(Number)
}), Mp = Ae({
  latestVersion: 6,
  versionMap: {
    1: ju,
    2: wp,
    3: Cp,
    4: Ip,
    5: kp,
    6: Np
  },
  getVersion(t) {
    const e = $p.safeParse(t);
    return e.success ? e.data.v : ju.schema.safeParse(t).success ? 1 : null;
  }
}), jp = "6", Dp = {
  // 1xx Informational
  // Request received, continuing process.[2]
  // This class of status code indicates a provisional response, consisting only of the Status-Line and optional headers, and is terminated by an empty line. Since HTTP/1.0 did not define any 1xx status codes, servers must not send a 1xx response to an HTTP/1.0 client except under experimental conditions.
  100: "Continue",
  // This means that the server has received the request headers, and that the client should proceed to send the request body (in the case of a request for which a body needs to be sent; for example, a POST request). If the request body is large, sending it to a server when a request has already been rejected based upon inappropriate headers is inefficient. To have a server check if the request could be accepted based on the request's headers alone, a client must send Expect: 100-continue as a header in its initial request[2] and check if a 100 Continue status code is received in response before continuing (or receive 417 Expectation Failed and not continue).[2]
  101: "Switching Protocols",
  // This means the requester has asked the server to switch protocols and the server is acknowledging that it will do so.[2]
  102: "Processing",
  // (WebDAV; RFC 2518) As a WebDAV request may contain many sub-requests involving file operations, it may take a long time to complete the request. This code indicates that the server has received and is processing the request, but no response is available yet.[3] This prevents the client from timing out and assuming the request was lost.
  // 2xx Success
  // This class of status codes indicates the action requested by the client was received, understood, accepted and processed successfully.
  200: "OK",
  // Standard response for successful HTTP requests. The actual response will depend on the request method used. In a GET request, the response will contain an entity corresponding to the requested resource. In a POST request the response will contain an entity describing or containing the result of the action.[2]
  201: "Created",
  // The request has been fulfilled and resulted in a new resource being created.[2]
  202: "Accepted",
  // The request has been accepted for processing, but the processing has not been completed. The request might or might not eventually be acted upon, as it might be disallowed when processing actually takes place.[2]
  203: "Non-Authoritative Information",
  // (since HTTP/1.1) The server successfully processed the request, but is returning information that may be from another source.[2]
  204: "No Content",
  // The server successfully processed the request, but is not returning any content.[2]
  205: "Reset Content",
  // The server successfully processed the request, but is not returning any content. Unlike a 204 response, this response requires that the requester reset the document view.[2]
  206: "Partial Content",
  // The server is delivering only part of the resource due to a range header sent by the client. The range header is used by tools like wget to enable resuming of interrupted downloads, or split a download into multiple simultaneous streams.[2]
  207: "Multi-Status",
  // (WebDAV; RFC 4918) The message body that follows is an XML message and can contain a number of separate response codes, depending on how many sub-requests were made.[4]
  208: "Already Reported",
  // (WebDAV; RFC 5842) The members of a DAV binding have already been enumerated in a previous reply to this request, and are not being included again.
  226: "IM Used",
  // (RFC 3229) The server has fulfilled a GET request for the resource, and the response is a representation of the result of one or more instance-manipulations applied to the current instance. [5]
  // 3xx Redirection
  // The client must take additional action to complete the request.[2]
  // This class of status code indicates that further action needs to be taken by the user agent in order to fulfil the request. The action required may be carried out by the user agent without interaction with the user if and only if the method used in the second request is GET or HEAD. A user agent should not automatically redirect a request more than five times, since such redirections usually indicate an infinite loop.
  300: "Multiple Choices",
  // Indicates multiple options for the resource that the client may follow. It, for instance, could be used to present different format options for video, list files with different extensions, or word sense disambiguation.[2]
  301: "Moved Permanently",
  // This and all future requests should be directed to the given URI.[2]
  302: "Found",
  // This is an example of industry practice contradicting the standard.[2] The HTTP/1.0 specification (RFC 1945) required the client to perform a temporary redirect (the original describing phrase was "Moved Temporarily"),[6] but popular browsers implemented 302 with the functionality of a 303 See Other. Therefore, HTTP/1.1 added status codes 303 and 307 to distinguish between the two behaviours.[7] However, some Web applications and frameworks use the 302 status code as if it were the 303.[citation needed]
  303: "See Other",
  // (since HTTP/1.1) The response to the request can be found under another URI using a GET method. When received in response to a POST (or PUT/DELETE), it should be assumed that the server has received the data and the redirect should be issued with a separate GET message.[2]
  304: "Not Modified",
  // Indicates the resource has not been modified since last requested.[2] Typically, the HTTP client provides a header like the If-Modified-Since header to provide a time against which to compare. Using this saves bandwidth and reprocessing on both the server and client, as only the header data must be sent and received in comparison to the entirety of the page being re-processed by the server, then sent again using more bandwidth of the server and client.
  305: "Use Proxy",
  // (since HTTP/1.1) Many HTTP clients (such as Mozilla[8] and Internet Explorer) do not correctly handle responses with this status code, primarily for security reasons.[2]
  306: "Switch Proxy",
  // No longer used.[2] Originally meant "Subsequent requests should use the specified proxy."[9]
  307: "Temporary Redirect",
  // (since HTTP/1.1) In this case, the request should be repeated with another URI; however, future requests can still use the original URI.[2] In contrast to 302, the request method should not be changed when reissuing the original request. For instance, a POST request must be repeated using another POST request.
  308: "Permanent Redirect",
  // (experimental Internet-Draft)[10] The request, and all future requests should be repeated using another URI. 307 and 308 (as proposed) parallel the behaviours of 302 and 301, but do not require the HTTP method to change. So, for example, submitting a form to a permanently redirected resource may continue smoothly.
  // 4xx Client Error
  // The 4xx class of status code is intended for cases in which the client seems to have erred. Except when responding to a HEAD request, the server should include an entity containing an explanation of the error situation, and whether it is a temporary or permanent condition. These status codes are applicable to any request method. User agents should display any included entity to the user.
  400: "Bad Request",
  // The request cannot be fulfilled due to bad syntax.[2]
  401: "Unauthorized",
  // Similar to 403 Forbidden, but specifically for use when authentication is possible but has failed or not yet been provided.[2] The response must include a WWW-Authenticate header field containing a challenge applicable to the requested resource. See Basic access authentication and Digest access authentication.
  402: "Payment Required",
  // Reserved for future use.[2] The original intention was that this code might be used as part of some form of digital cash or micropayment scheme, but that has not happened, and this code is not usually used. As an example of its use, however, Apple's MobileMe service generates a 402 error ("httpStatusCode:402" in the Mac OS X Console log) if the MobileMe account is delinquent.[citation needed]
  403: "Forbidden",
  // The request was a legal request, but the server is refusing to respond to it.[2] Unlike a 401 Unauthorized response, authenticating will make no difference.[2]
  404: "Not Found",
  // The requested resource could not be found but may be available again in the future.[2] Subsequent requests by the client are permissible.
  405: "Method Not Allowed",
  // A request was made of a resource using a request method not supported by that resource;[2] for example, using GET on a form which requires data to be presented via POST, or using PUT on a read-only resource.
  406: "Not Acceptable",
  // The requested resource is only capable of generating content not acceptable according to the Accept headers sent in the request.[2]
  407: "Proxy Authentication Required",
  // The client must first authenticate itself with the proxy.[2]
  408: "Request Timeout",
  // The server timed out waiting for the request.[2] According to W3 HTTP specifications: "The client did not produce a request within the time that the server was prepared to wait. The client MAY repeat the request without modifications at any later time."
  409: "Conflict",
  // Indicates that the request could not be processed because of conflict in the request, such as an edit conflict.[2]
  410: "Gone",
  // Indicates that the resource requested is no longer available and will not be available again.[2] This should be used when a resource has been intentionally removed and the resource should be purged. Upon receiving a 410 status code, the client should not request the resource again in the future. Clients such as search engines should remove the resource from their indices. Most use cases do not require clients and search engines to purge the resource, and a "404 Not Found" may be used instead.
  411: "Length Required",
  // The request did not specify the length of its content, which is required by the requested resource.[2]
  412: "Precondition Failed",
  // The server does not meet one of the preconditions that the requester put on the request.[2]
  413: "Request Entity Too Large",
  // The request is larger than the server is willing or able to process.[2]
  414: "Request-URI Too Long",
  // The URI provided was too long for the server to process.[2]
  415: "Unsupported Media Type",
  // The request entity has a media type which the server or resource does not support.[2] For example, the client uploads an image as image/svg+xml, but the server requires that images use a different format.
  416: "Requested Range Not Satisfiable",
  // The client has asked for a portion of the file, but the server cannot supply that portion.[2] For example, if the client asked for a part of the file that lies beyond the end of the file.[2]
  417: "Expectation Failed",
  // The server cannot meet the requirements of the Expect request-header field.[2]
  418: "I'm a teapot",
  // (RFC 2324) This code was defined in 1998 as one of the traditional IETF April Fools' jokes, in RFC 2324, Hyper Text Coffee Pot Control Protocol, and is not expected to be implemented by actual HTTP servers. However, known implementations do exist.[11]
  420: "Enhance Your Calm",
  // (Twitter) Returned by the Twitter Search and Trends API when the client is being rate limited.[12] Likely a reference to this number's association with marijuana. Other services may wish to implement the 429 Too Many Requests response code instead. The phrase "Enhance Your Calm" is a reference to Demolition Man (film). In the film, Sylvester Stallone's character John Spartan is a hot-head in a generally more subdued future, and is regularly told to "Enhance your calm" rather than a more common phrase like "calm down".
  422: "Unprocessable Entity",
  // (WebDAV; RFC 4918) The request was well-formed but was unable to be followed due to semantic errors.[4]
  423: "Locked",
  // (WebDAV; RFC 4918) The resource that is being accessed is locked.[4]
  424: "Failed Dependency",
  // (WebDAV; RFC 4918) The request failed due to failure of a previous request (e.g. a PROPPATCH).[4]
  425: "Unordered Collection",
  // (Internet draft) Defined in drafts of "WebDAV Advanced Collections Protocol",[14] but not present in "Web Distributed Authoring and Versioning (WebDAV) Ordered Collections Protocol".[15]
  426: "Upgrade Required",
  // (RFC 2817) The client should switch to a different protocol such as TLS/1.0.[16]
  428: "Precondition Required",
  // (RFC 6585) The origin server requires the request to be conditional. Intended to prevent "the 'lost update' problem, where a client GETs a resource's state, modifies it, and PUTs it back to the server, when meanwhile a third party has modified the state on the server, leading to a conflict."[17]
  429: "Too Many Requests",
  // (RFC 6585) The user has sent too many requests in a given amount of time. Intended for use with rate limiting schemes.[17]
  431: "Request Header Fields Too Large",
  // (RFC 6585) The server is unwilling to process the request because either an individual header field, or all the header fields collectively, are too large.[17]
  444: "No Response",
  // (Nginx) Used in Nginx logs to indicate that the server has returned no information to the client and closed the connection (useful as a deterrent for malware).
  449: "Retry With",
  // (Microsoft) A Microsoft extension. The request should be retried after performing the appropriate action.[18] Often search-engines or custom applications will ignore required parameters. Where no default action is appropriate, the Aviongoo website sends a "HTTP/1.1 449 Retry with valid parameters: param1, param2, . . ." response. The applications may choose to learn, or not.
  450: "Blocked by Windows Parental Controls",
  // (Microsoft) A Microsoft extension. This error is given when Windows Parental Controls are turned on and are blocking access to the given webpage.[19]
  451: "Unavailable For Legal Reasons",
  // (Internet draft) Defined in the internet draft "A New HTTP Status Code for Legally-restricted Resources",[20]. Intended to be used when resource access is denied for legal reasons, e.g. censorship or government-mandated blocked access. Likely a reference to the 1953 dystopian novel Fahrenheit 451, where books are outlawed.
  499: "Client Closed Request",
  // (Nginx) Used in Nginx logs to indicate when the connection has been closed by client while the server is still processing its request, making server unable to send a status code back.[21]
  // 5xx Server Error
  // The server failed to fulfill an apparently valid request.[2]
  // Response status codes beginning with the digit "5" indicate cases in which the server is aware that it has encountered an error or is otherwise incapable of performing the request. Except when responding to a HEAD request, the server should include an entity containing an explanation of the error situation, and indicate whether it is a temporary or permanent condition. Likewise, user agents should display any included entity to the user. These response codes are applicable to any request method.
  500: "Internal Server Error",
  // A generic error message, given when no more specific message is suitable.[2]
  501: "Not Implemented",
  // The server either does not recognise the request method, or it lacks the ability to fulfill the request.[2]
  502: "Bad Gateway",
  // The server was acting as a gateway or proxy and received an invalid response from the upstream server.[2]
  503: "Service Unavailable",
  // The server is currently unavailable (because it is overloaded or down for maintenance).[2] Generally, this is a temporary state.
  504: "Gateway Timeout",
  // The server was acting as a gateway or proxy and did not receive a timely response from the upstream server.[2]
  505: "HTTP Version Not Supported",
  // The server does not support the HTTP protocol version used in the request.[2]
  506: "Variant Also Negotiates",
  // (RFC 2295) Transparent content negotiation for the request results in a circular reference.[22]
  507: "Insufficient Storage",
  // (WebDAV; RFC 4918) The server is unable to store the representation needed to complete the request.[4]
  508: "Loop Detected",
  // (WebDAV; RFC 5842) The server detected an infinite loop while processing the request (sent in lieu of 208).
  509: "Bandwidth Limit Exceeded",
  // (Apache bw/limited extension) This status code, while used by many servers, is not specified in any RFCs.
  510: "Not Extended",
  // (RFC 2774) Further extensions to the request are required for the server to fulfill it.[23]
  511: "Network Authentication Required",
  // (RFC 6585) The client needs to authenticate to gain network access. Intended for use by intercepting proxies used to control access to the network (e.g. "captive portals" used to require agreement to Terms of Service before granting full Internet access via a Wi-Fi hotspot).[17]
  598: "Network read timeout error",
  // (Unknown) This status code is not specified in any RFCs, but is used by Microsoft Corp. HTTP proxies to signal a network read timeout behind the proxy to a client in front of the proxy.
  599: "Network connect timeout error"
  // (Unknown) This status code is not specified in any RFCs, but is used by Microsoft Corp. HTTP proxies to signal a network connect timeout behind the proxy to a client in front of the proxy.
}, Hp = L(
  Object.keys(Dp).map((t) => d(parseInt(t)))
), Lp = b(
  f({
    key: u(),
    value: u()
  })
), Up = f({
  name: u(),
  originalRequest: xe(Mp),
  status: u(),
  code: ie(Hp).nullable().catch(null),
  headers: Lp,
  body: u()
}), Du = _({
  initial: !0,
  schema: Up
}), Bp = f({
  v: Se()
}), Gp = Ae({
  latestVersion: 0,
  versionMap: {
    0: Du
  },
  getVersion(t) {
    const e = Bp.safeParse(t);
    return e.success ? e.data.v : Du.schema.safeParse(t).success ? 0 : null;
  }
}), sl = Oc(
  u(),
  xe(Gp)
);
function Pg(t) {
  return {
    v: jp,
    ...t
  };
}
const il = Fc.extend({
  v: d("8"),
  auth: Vs,
  responses: sl
}), Kp = _({
  schema: il,
  initial: !1,
  up(t) {
    return {
      ...t,
      v: "8",
      // no need to update anything for HoppRESTAuth, because we loosened the previous schema by making `clientSecret` optional
      responses: {}
    };
  }
}), ol = il.extend({
  v: d("9"),
  body: zc
}), Fp = _({
  schema: ol,
  initial: !1,
  up(t) {
    return {
      ...t,
      v: "9"
    };
  }
}), ul = ol.extend({
  v: d("10"),
  body: Ns
}), Zp = _({
  schema: ul,
  initial: !1,
  up(t) {
    return {
      ...t,
      v: "10"
    };
  }
}), cl = ul.extend({
  v: d("11"),
  auth: Ps
}), Wp = _({
  schema: cl,
  initial: !1,
  up(t) {
    const e = t.auth;
    return {
      ...t,
      v: "11",
      auth: e.authType === "oauth-2" ? {
        ...e,
        grantTypeInfo: e.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
          ...e.grantTypeInfo,
          clientAuthentication: "IN_BODY"
        } : e.grantTypeInfo
      } : e
    };
  }
}), ll = cl.extend({
  v: d("12"),
  auth: js
}), Jp = _({
  schema: ll,
  initial: !1,
  up(t) {
    return {
      ...t,
      v: "12"
    };
  }
}), dl = ll.extend({
  v: d("13"),
  auth: Ds
}), zp = _({
  schema: dl,
  initial: !1,
  up(t) {
    return {
      ...t,
      v: "13"
    };
  }
}), fl = dl.extend({
  v: d("14")
}), Qp = _({
  schema: fl,
  initial: !1,
  up(t) {
    return {
      ...t,
      v: "14"
    };
  }
}), hl = fl.extend({
  v: d("15"),
  auth: Ar
}), Yp = _({
  schema: hl,
  initial: !1,
  up(t) {
    let e;
    if (t.auth.authType === "oauth-2") {
      const r = t.auth.grantTypeInfo;
      let n;
      r.grantType === "AUTHORIZATION_CODE" ? n = {
        ...r,
        authRequestParams: [],
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "CLIENT_CREDENTIALS" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "PASSWORD" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "IMPLICIT" ? n = {
        ...r,
        authRequestParams: [],
        refreshRequestParams: []
      } : n = r, e = {
        ...t.auth,
        grantTypeInfo: n
      };
    } else
      e = t.auth;
    return {
      ...t,
      v: "15",
      auth: e
    };
  }
}), X = [];
for (let t = 0; t < 256; ++t)
  X.push((t + 256).toString(16).slice(1));
function Xp(t, e = 0) {
  return (X[t[e + 0]] + X[t[e + 1]] + X[t[e + 2]] + X[t[e + 3]] + "-" + X[t[e + 4]] + X[t[e + 5]] + "-" + X[t[e + 6]] + X[t[e + 7]] + "-" + X[t[e + 8]] + X[t[e + 9]] + "-" + X[t[e + 10]] + X[t[e + 11]] + X[t[e + 12]] + X[t[e + 13]] + X[t[e + 14]] + X[t[e + 15]]).toLowerCase();
}
let Fa;
const ey = new Uint8Array(16);
function ty() {
  if (!Fa) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    Fa = crypto.getRandomValues.bind(crypto);
  }
  return Fa(ey);
}
const ry = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Hu = { randomUUID: ry };
function ny(t, e, r) {
  t = t || {};
  const n = t.random ?? t.rng?.() ?? ty();
  if (n.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, Xp(n);
}
function ay(t, e, r) {
  return Hu.randomUUID && !t ? Hu.randomUUID() : ny(t);
}
const We = (t = "") => {
  const e = Date.now().toString(36), r = ay();
  return `${t}_${e}_${r}`;
}, pl = hl.extend({
  v: d("16"),
  _ref_id: u().optional()
}), sy = _({
  schema: pl,
  initial: !1,
  up(t) {
    return {
      ...t,
      v: "16",
      _ref_id: We("req")
    };
  }
}), iy = pl.extend({
  v: d("17"),
  description: u().nullable().catch(null)
}), oy = _({
  schema: iy,
  initial: !1,
  up(t) {
    return {
      ...t,
      v: "17",
      description: null
    };
  }
}), uy = {
  "application/json": "json",
  "application/ld+json": "json",
  "application/hal+json": "json",
  "application/vnd.api+json": "json",
  "application/xml": "xml",
  "text/xml": "xml",
  "application/x-www-form-urlencoded": "multipart",
  "multipart/form-data": "multipart",
  "application/octet-stream": "binary",
  "text/html": "html",
  "text/plain": "plain"
}, Ng = Object.keys(
  uy
), cy = f({
  // v is a stringified number
  v: u().regex(/^\d+$/).transform(Number)
}), Rr = Ae({
  latestVersion: 17,
  versionMap: {
    0: Mu,
    1: mp,
    2: vp,
    3: _p,
    4: Tp,
    5: Sp,
    6: Ap,
    7: Rp,
    8: Kp,
    9: Fp,
    10: Zp,
    11: Wp,
    12: Jp,
    13: zp,
    14: Qp,
    15: Yp,
    16: sy,
    17: oy
  },
  getVersion(t) {
    const e = cy.safeParse(t);
    return e.success ? e.data.v : Mu.schema.safeParse(t).success ? 0 : null;
  }
}), ly = Bd({
  id: $u(ve),
  v: ve,
  auth: Le,
  body: Le,
  endpoint: ve,
  headers: Ka(
    (t) => t.filter((e) => e.key !== "" && e.value !== ""),
    Le
  ),
  params: Ka(
    (t) => t.filter((e) => e.key !== "" && e.value !== ""),
    Le
  ),
  method: ve,
  name: ve,
  preRequestScript: ve,
  testScript: ve,
  requestVariables: Ka(
    (t) => t.filter((e) => e.key !== "" && e.value !== ""),
    Le
  ),
  responses: Le,
  _ref_id: $u(ve),
  description: Le
}), yl = "17", $g = ly.equals;
function Mg(t, e) {
  const r = Sh(e);
  if (t && typeof t == "object") {
    if ("id" in t && typeof t.id == "string" && (r.id = t.id), "_ref_id" in t && typeof t._ref_id == "string" && (r._ref_id = t._ref_id), "name" in t && typeof t.name == "string" && (r.name = t.name), "method" in t && typeof t.method == "string" && (r.method = t.method), "endpoint" in t && typeof t.endpoint == "string" && (r.endpoint = t.endpoint), "preRequestScript" in t && typeof t.preRequestScript == "string" && (r.preRequestScript = t.preRequestScript), "testScript" in t && typeof t.testScript == "string" && (r.testScript = t.testScript), "body" in t) {
      const n = Ns.safeParse(t.body);
      n.success && (r.body = n.data);
    }
    if ("auth" in t) {
      const n = Ar.safeParse(t.auth);
      n.success && (r.auth = n.data);
    }
    if ("params" in t) {
      const n = Os.safeParse(t.params);
      n.success && (r.params = n.data);
    }
    if ("headers" in t) {
      const n = Tr.safeParse(t.headers);
      n.success && (r.headers = n.data);
    }
    if ("requestVariables" in t) {
      const n = xs.safeParse(t.requestVariables);
      n.success && (r.requestVariables = n.data);
    }
    if ("responses" in t) {
      const n = sl.safeParse(t.responses);
      n.success && (r.responses = n.data);
    }
    "description" in t && typeof t.description == "string" && (r.description = t.description);
  }
  return r;
}
function jg(t) {
  return {
    v: yl,
    _ref_id: t._ref_id ?? We("req"),
    ...t
  };
}
function dy() {
  const t = We("req");
  return {
    v: yl,
    endpoint: "https://echo.hoppscotch.io",
    name: "Untitled",
    params: [],
    headers: [],
    method: "GET",
    auth: {
      authType: "inherit",
      authActive: !0
    },
    preRequestScript: "",
    testScript: "",
    body: {
      contentType: null,
      body: null
    },
    requestVariables: [],
    responses: {},
    _ref_id: t,
    description: null
  };
}
function Dg(t) {
  return Rr.isLatest(t);
}
function fy(t) {
  const e = Rr.safeParse(t);
  return e.type === "ok" ? e.value : dy();
}
const Hs = f({
  key: u().catch(""),
  value: u().catch(""),
  active: E().catch(!0)
}), hy = f({
  v: d(1),
  name: u(),
  url: u(),
  headers: b(Hs).catch([]),
  query: u(),
  variables: u()
}), py = _({
  initial: !0,
  schema: hy
}), Pe = f({
  authType: d("none")
}), Ne = f({
  authType: d("basic"),
  username: u().catch(""),
  password: u().catch("")
}), $e = f({
  authType: d("bearer"),
  token: u().catch("")
}), yy = f({
  authType: d("oauth-2"),
  token: u().catch(""),
  oidcDiscoveryURL: u().catch(""),
  authURL: u().catch(""),
  accessTokenURL: u().catch(""),
  clientID: u().catch(""),
  scope: u().catch("")
}), Ls = f({
  authType: d("api-key"),
  key: u().catch(""),
  value: u().catch(""),
  addTo: u().catch("Headers")
}), Me = f({
  authType: d("inherit")
}), my = U("authType", [
  Pe,
  Ne,
  $e,
  yy,
  Ls,
  Me
]).and(
  f({
    authActive: E()
  })
), ml = f({
  id: ie(u()),
  v: d(2),
  name: u(),
  url: u(),
  headers: b(Hs).catch([]),
  query: u(),
  variables: u(),
  auth: my
}), vy = _({
  initial: !1,
  schema: ml,
  up(t) {
    return {
      ...t,
      v: 2,
      auth: {
        authActive: !0,
        authType: "none"
      }
    };
  }
}), gy = U("authType", [
  Pe,
  Me,
  Ne,
  $e,
  Ls,
  gr
  // both rest and gql have the same auth type for oauth2
]).and(
  f({
    authActive: E()
  })
), vl = ml.extend({
  v: d(3),
  auth: gy
}), _y = _({
  initial: !1,
  schema: vl,
  up(t) {
    if (t.auth.authType === "oauth-2") {
      const { token: e, accessTokenURL: r, scope: n, clientID: a, authURL: s } = t.auth;
      return {
        ...t,
        v: 3,
        auth: {
          ...t.auth,
          authType: "oauth-2",
          grantTypeInfo: {
            grantType: "AUTHORIZATION_CODE",
            authEndpoint: s,
            tokenEndpoint: r,
            clientID: a,
            clientSecret: "",
            scopes: n,
            isPKCE: !1,
            token: e
          },
          addTo: "HEADERS"
        }
      };
    }
    return {
      ...t,
      v: 3,
      auth: {
        ...t.auth
      }
    };
  }
}), pt = Ls.extend({
  addTo: W(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), by = U("authType", [
  Pe,
  Me,
  Ne,
  $e,
  pt,
  _r
  // both rest and gql have the same auth type for oauth2
]).and(
  f({
    authActive: E()
  })
), gl = vl.extend({
  v: d(4),
  auth: by
}), Ty = _({
  initial: !1,
  schema: gl,
  up(t) {
    return t.auth.authType === "api-key" ? {
      ...t,
      v: 4,
      auth: {
        ...t.auth,
        addTo: t.auth.addTo === "Query params" ? "QUERY_PARAMS" : "HEADERS"
      }
    } : {
      ...t,
      v: 4,
      auth: {
        ...t.auth
      }
    };
  }
}), _l = U("authType", [
  Pe,
  Me,
  Ne,
  $e,
  pt,
  _r
  // both rest and gql have the same auth type for oauth2
]).and(
  f({
    authActive: E()
  })
), bl = gl.extend({
  v: d(5),
  auth: _l
}), Sy = _({
  initial: !1,
  schema: bl,
  up(t) {
    return {
      ...t,
      v: 5
    };
  }
}), Er = Ze, Us = f({
  key: u().catch(""),
  value: u().catch(""),
  active: E().catch(!0),
  description: u().catch("")
}), Tl = U("authType", [
  Pe,
  Me,
  Ne,
  $e,
  _r,
  pt,
  Er
]).and(
  f({
    authActive: E()
  })
), Sl = bl.extend({
  v: d(6),
  auth: Tl,
  headers: b(Us).catch([])
}), Ay = _({
  schema: Sl,
  initial: !1,
  up(t) {
    const e = t.headers.map((r) => ({
      ...r,
      description: ""
    }));
    return {
      ...t,
      v: 6,
      headers: e
    };
  }
}), Al = U("authType", [
  Pe,
  Me,
  Ne,
  $e,
  Gc,
  pt,
  Er
]).and(
  f({
    authActive: E()
  })
), Rl = Sl.extend({
  v: d(7),
  auth: Al
}), Ry = _({
  schema: Rl,
  initial: !1,
  up(t) {
    return {
      ...t,
      v: 7
      // no need to update anything for HoppGQLAuth, because we loosened the previous schema by making `clientSecret` optional
    };
  }
}), wr = U("authType", [
  Pe,
  Me,
  Ne,
  $e,
  Sr,
  pt,
  Er
]).and(
  f({
    authActive: E()
  })
), El = Rl.extend({
  v: d(8),
  auth: wr
}), Ey = _({
  schema: El,
  initial: !1,
  up(t) {
    const e = t.auth;
    return {
      ...t,
      v: 8,
      auth: e.authType === "oauth-2" ? {
        ...e,
        grantTypeInfo: e.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
          ...e.grantTypeInfo,
          clientAuthentication: "IN_BODY"
        } : e.grantTypeInfo
      } : e
    };
  }
}), Bs = U("authType", [
  Pe,
  Me,
  Ne,
  $e,
  al,
  pt,
  Er
]).and(
  f({
    authActive: E()
  })
), wl = El.extend({
  v: d(9),
  auth: Bs
}), wy = _({
  schema: wl,
  initial: !1,
  up(t) {
    let e;
    if (t.auth.authType === "oauth-2") {
      const r = t.auth.grantTypeInfo;
      let n;
      r.grantType === "AUTHORIZATION_CODE" ? n = {
        ...r,
        authRequestParams: [],
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "CLIENT_CREDENTIALS" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "PASSWORD" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "IMPLICIT" ? n = {
        ...r,
        authRequestParams: [],
        refreshRequestParams: []
      } : n = r, e = {
        ...t.auth,
        grantTypeInfo: n
      };
    } else
      e = t.auth;
    return {
      ...t,
      v: 9,
      auth: e
    };
  }
}), Cy = f({
  v: d("1"),
  name: u(),
  url: u(),
  query: u(),
  variables: u(),
  headers: b(Us).catch([]),
  auth: Bs
}), Lu = _({
  initial: !0,
  schema: Cy
}), Iy = f({
  // v is a stringified number — same convention as the REST counterpart.
  v: u().regex(/^\d+$/).transform(Number)
}), ky = Ae({
  latestVersion: 1,
  versionMap: {
    1: Lu
  },
  getVersion(t) {
    const e = Iy.safeParse(t);
    return e.success ? e.data.v : Lu.schema.safeParse(t).success ? 1 : null;
  }
}), xy = "1", Oy = b(
  f({
    key: u(),
    value: u()
  })
), qy = f({
  name: u(),
  originalRequest: xe(ky),
  // Transport-level status. GQL responses are usually HTTP 200, but transport
  // failures can surface non-200s; keep these for parity with the REST shape.
  status: u(),
  code: ie(Se()).nullable().catch(null),
  headers: Oy,
  body: u(),
  // Operation identity of the run this example was saved from — the mock
  // server matches GraphQL requests by these (name + query/mutation), the
  // way REST examples match by method + path. Optional: examples saved
  // before the stamping existed simply never match by name. Nullable: the
  // mock server canonicalizes the wildcard stamp as null, and JSON writers
  // have no way to express undefined — a null stamp must not fail the parse
  // (the whole `responses` record would be silently reset by its .catch).
  operationName: u().nullable().optional(),
  operationType: u().nullable().optional()
}), Uu = _({
  initial: !0,
  schema: qy
}), Vy = f({
  v: Se()
}), Py = Ae({
  latestVersion: 0,
  versionMap: {
    0: Uu
  },
  getVersion(t) {
    const e = Vy.safeParse(t);
    return e.success ? e.data.v : Uu.schema.safeParse(t).success ? 0 : null;
  }
}), Ny = Oc(
  u(),
  xe(Py)
);
function Hg(t) {
  return {
    v: xy,
    ...t
  };
}
const $y = wl.extend({
  v: d(10),
  _ref_id: u().optional(),
  description: u().nullable().catch(null),
  responses: Ny.catch({}),
  preRequestScript: u().catch(""),
  testScript: u().catch("")
}), My = _({
  schema: $y,
  initial: !1,
  up(t) {
    return {
      ...t,
      v: 10,
      _ref_id: We("req"),
      description: null,
      responses: {},
      preRequestScript: "",
      testScript: ""
    };
  }
}), Cl = 10, jy = f({
  v: Se()
}), Gs = Ae({
  latestVersion: 10,
  versionMap: {
    1: py,
    2: vy,
    3: _y,
    4: Ty,
    5: Sy,
    6: Ay,
    7: Ry,
    8: Ey,
    9: wy,
    10: My
  },
  getVersion(t) {
    const e = jy.safeParse(t);
    return e.success ? e.data.v : null;
  }
}), Dy = `
query Request {
  method
  url
  headers {
    key
    value
  }
}`.trim();
function Hy() {
  return {
    v: Cl,
    name: "Untitled",
    url: "https://echo.hoppscotch.io/graphql",
    headers: [],
    variables: `
{
  "id": "1"
}`.trim(),
    query: Dy,
    auth: {
      authType: "inherit",
      authActive: !0
    },
    _ref_id: We("req"),
    description: null,
    responses: {},
    preRequestScript: "",
    testScript: ""
  };
}
function Ly(t) {
  const e = Gs.safeParse(t);
  return e.type === "ok" ? e.value : Hy();
}
function Lg(t) {
  return {
    v: Cl,
    ...t
  };
}
const Uy = f({
  v: d(1),
  id: ie(u()),
  // For Firestore ID data
  name: u(),
  requests: b(
    ae(
      () => L([
        xe(Rr),
        xe(Gs)
      ])
    )
  )
}), By = Uy.extend({
  folders: ae(() => b(ue(K, 1)))
}), Bu = _({
  initial: !0,
  schema: By
}), Il = f({
  v: d(2),
  id: ie(u()),
  // For Firestore ID data
  name: u(),
  requests: b(
    ae(
      () => L([
        xe(Rr),
        xe(Gs)
      ])
    )
  ),
  auth: L([Hc, _l]),
  headers: L([Vc, b(Hs)])
}), Gy = Il.extend({
  folders: ae(() => b(ue(K, 2)))
}), Ky = _({
  initial: !1,
  schema: Gy,
  up(t) {
    const e = {
      ...t,
      v: 2,
      auth: {
        authActive: !0,
        authType: "inherit"
      },
      headers: [],
      folders: t.folders.map((r) => {
        const n = K.safeParseUpToVersion(r, 2);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
    return t.id && (e.id = t.id), e;
  }
}), kl = Il.extend({
  v: d(3),
  // AWS Signature Authorization type addition
  auth: L([Kc, Tl]),
  // `description` field addition under `headers`
  headers: L([Tr, b(Us)])
}), Fy = kl.extend({
  folders: ae(() => b(ue(K, 3)))
}), Zy = _({
  initial: !1,
  schema: Fy,
  up(t) {
    const e = t.headers.map(
      (n) => ({
        ...n,
        description: ""
      })
    );
    return {
      ...t,
      v: 3,
      headers: e,
      folders: t.folders.map((n) => {
        const a = K.safeParseUpToVersion(n, 3);
        if (a.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return a.value;
      })
    };
  }
}), xl = kl.extend({
  v: d(4),
  auth: L([Vs, Al])
}), Wy = xl.extend({
  folders: ae(() => b(ue(K, 4)))
}), Jy = _({
  initial: !1,
  schema: Wy,
  up(t) {
    return {
      ...t,
      v: 4,
      folders: t.folders.map((r) => {
        const n = K.safeParseUpToVersion(r, 4);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), Ol = xl.extend({
  v: d(5),
  _ref_id: u().optional()
}), zy = Ol.extend({
  folders: ae(() => b(ue(K, 5)))
}), Qy = _({
  initial: !1,
  schema: zy,
  up(t) {
    return {
      ...t,
      v: 5,
      _ref_id: We("coll"),
      folders: t.folders.map((r) => {
        const n = K.safeParseUpToVersion(r, 5);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), ql = Ol.extend({
  v: d(6),
  auth: L([Ps, wr])
}), Yy = ql.extend({
  folders: ae(() => b(ue(K, 6)))
}), Xy = _({
  initial: !1,
  schema: Yy,
  up(t) {
    const e = t.auth, r = e.authType === "oauth-2" ? {
      ...e,
      grantTypeInfo: e.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
        ...e.grantTypeInfo,
        clientAuthentication: "IN_BODY"
      } : e.grantTypeInfo
    } : e;
    return {
      ...t,
      auth: r,
      v: 6,
      folders: t.folders.map((a) => {
        const s = K.safeParseUpToVersion(a, 6);
        if (s.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return s.value;
      })
    };
  }
}), Vl = ql.extend({
  v: d(7),
  auth: L([js, wr])
}), em = Vl.extend({
  folders: ae(() => b(ue(K, 7)))
}), tm = _({
  initial: !1,
  schema: em,
  up(t) {
    return {
      ...t,
      v: 7,
      folders: t.folders.map((r) => {
        const n = K.safeParseUpToVersion(r, 7);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), Pl = Vl.extend({
  v: d(8),
  auth: L([Ds, wr])
}), rm = Pl.extend({
  folders: ae(() => b(ue(K, 8)))
}), nm = _({
  initial: !1,
  schema: rm,
  up(t) {
    return {
      ...t,
      v: 8,
      folders: t.folders.map((r) => {
        const n = K.safeParseUpToVersion(r, 8);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), Nl = Pl.extend({
  v: d(9),
  auth: L([Ar, Bs])
}), am = Nl.extend({
  folders: ae(() => b(ue(K, 9)))
}), sm = _({
  initial: !1,
  schema: am,
  up(t) {
    let e;
    if (t.auth.authType === "oauth-2") {
      const n = t.auth.grantTypeInfo;
      let a;
      n.grantType === "AUTHORIZATION_CODE" ? a = {
        ...n,
        authRequestParams: [],
        tokenRequestParams: [],
        refreshRequestParams: []
      } : n.grantType === "CLIENT_CREDENTIALS" ? a = {
        ...n,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : n.grantType === "PASSWORD" ? a = {
        ...n,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : n.grantType === "IMPLICIT" ? a = {
        ...n,
        authRequestParams: [],
        refreshRequestParams: []
      } : a = n, e = {
        ...t.auth,
        grantTypeInfo: a
      };
    } else
      e = t.auth;
    return {
      ...t,
      v: 9,
      auth: e,
      folders: t.folders.map((n) => {
        const a = K.safeParseUpToVersion(n, 9);
        if (a.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return a.value;
      })
    };
  }
}), im = f({
  key: u(),
  initialValue: u(),
  currentValue: u(),
  secret: E()
}), $l = Nl.extend({
  v: d(10),
  variables: b(im)
}), om = $l.extend({
  folders: ae(() => b(ue(K, 10)))
}), um = _({
  initial: !1,
  schema: om,
  up(t) {
    return {
      ...t,
      v: 10,
      variables: [],
      folders: t.folders.map((r) => {
        const n = K.safeParseUpToVersion(r, 10);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), Ml = $l.extend({
  v: d(11),
  description: u().nullable().catch(null)
}), cm = Ml.extend({
  folders: ae(() => b(ue(K, 11)))
}), lm = _({
  initial: !1,
  schema: cm,
  up(t) {
    return {
      ...t,
      v: 11,
      description: null,
      folders: t.folders.map((r) => {
        const n = K.safeParseUpToVersion(r, 11);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), dm = Ml.extend({
  v: d(12),
  preRequestScript: u().catch(""),
  testScript: u().catch("")
}), fm = dm.extend({
  folders: ae(() => b(ue(K, 12)))
}), hm = _({
  initial: !1,
  schema: fm,
  up(t) {
    return {
      ...t,
      v: 12,
      preRequestScript: "",
      testScript: "",
      folders: t.folders.map((r) => {
        const n = K.safeParseUpToVersion(r, 12);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), pm = f({
  v: Se()
}), K = Ae({
  latestVersion: 12,
  versionMap: {
    1: Bu,
    2: Ky,
    3: Zy,
    4: Jy,
    5: Qy,
    6: Xy,
    7: tm,
    8: nm,
    9: sm,
    10: um,
    11: lm,
    12: hm
  },
  getVersion(t) {
    const e = pm.safeParse(t);
    return e.success ? e.data.v : Bu.schema.safeParse(t).success ? 1 : null;
  }
}), ym = 12;
function mm(t) {
  return {
    v: ym,
    ...t,
    _ref_id: t._ref_id ? t._ref_id : We("coll")
  };
}
function vm(t) {
  const e = t.name ?? "Untitled", r = (t.folders ?? []).map(vm), n = (t.requests ?? []).map(
    (y) => y && typeof y == "object" && "query" in y && "url" in y && !("endpoint" in y) ? Ly(y) : fy(y)
  ), a = t.auth ?? { authType: "inherit", authActive: !0 }, s = t.headers ?? [], i = t.variables ?? [], o = t.description ?? null, l = t.preRequestScript ?? "", c = t.testScript ?? "", h = mm({
    name: e,
    folders: r,
    requests: n,
    auth: a,
    headers: s,
    variables: i,
    description: o,
    preRequestScript: l,
    testScript: c
  });
  return t.id && (h.id = t.id), t._ref_id && (h._ref_id = t._ref_id), h;
}
function Ug(t) {
  return !!t && typeof t == "object" && "query" in t && "url" in t && !("endpoint" in t);
}
function Bg(t) {
  return !!t && typeof t == "object" && "endpoint" in t && "method" in t;
}
var je = function(t) {
  return function(e) {
    return !t(e);
  };
}, gm = af, _m = rf;
function jl(t, e) {
  return e === void 0 ? function(r) {
    return jl(t, r);
  } : _m(t, e) ? rc : nc(e[t]);
}
var Dl = function(t) {
  return function(e) {
    return e.map(function(r) {
      return t(r);
    });
  };
}, bm = function(t) {
  return function(e) {
    for (var r = [], n = 0; n < e.length; n++) {
      var a = t(n, e[n]);
      tc(a) && r.push(a.value);
    }
    return r;
  };
}, Tm = function(t) {
  return bm(function(e, r) {
    return t(r);
  });
}, Hl = function(t) {
  return t.slice();
}, Sm = tf, Gu = function(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, a = e.length, s; n < a; n++)
    (s || !(n in e)) && (s || (s = Array.prototype.slice.call(e, 0, n)), s[n] = e[n]);
  return t.concat(s || Array.prototype.slice.call(e));
}, Am = function(t) {
  return function(e) {
    return Gu(Gu([], e, !0), [t], !1);
  };
}, Rm = Am, Em = function(t) {
  return [t];
}, wm = Rm, Cm = jl, Im = function(t) {
  return function(e) {
    return e.map(function(r) {
      return t(r);
    });
  };
}, km = function() {
  return {
    concat: function(t, e) {
      return t.concat(e);
    }
  };
}, xm = function() {
  return {
    concat: km().concat,
    empty: []
  };
}, Cr = rc, Ct = nc;
function Ll(t) {
  return function(e) {
    return t(e) ? Ct(e) : Cr;
  };
}
var us = function(t) {
  return function(e) {
    return Ul(e) ? Cr : Ct(t(e.value));
  };
}, Om = tc, Ul = function(t) {
  return t._tag === "None";
}, qm = function(t, e) {
  return function(r) {
    return Ul(r) ? t() : e(r.value);
  };
}, Vm = qm, Ks = Vm, Pm = function(t, e) {
  for (var r = e(t); r._tag === "Left"; )
    r = e(r.left);
  return r.right;
}, De = Fd, de = Zd, Nm = /* @__PURE__ */ Ld(2, function(t, e) {
  return ot(t) ? t : e(t.right);
}), It = function(t) {
  return function(e) {
    return ot(e) ? e : de(t(e.right));
  };
}, Ir = function(t) {
  return function(e) {
    return ot(e) ? De(t(e.left)) : e;
  };
}, ot = Gd, $m = Kd, Mm = function(t) {
  return function(e) {
    return ot(e) ? t(e.left) : e.right;
  };
}, Fs = Mm, Ku = Nm, er = function() {
  return er = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t;
  }, er.apply(this, arguments);
}, kt = function(t, e, r) {
  return de({
    value: t,
    next: e,
    start: r
  });
}, xt = function(t, e, r) {
  return e === void 0 && (e = []), r === void 0 && (r = !1), De({
    input: t,
    expected: e,
    fatal: r
  });
}, jm = function(t, e) {
  return er(er({}, t), { expected: e });
}, Dm = function(t, e) {
  return Hm().concat(t, e);
}, Hm = function() {
  return {
    concat: function(t, e) {
      return t.input.cursor < e.input.cursor ? Xd().concat(t, e) : t.input.cursor > e.input.cursor ? qr().concat(t, e) : Yd({
        input: qr(),
        fatal: qr(),
        expected: xm()
      }).concat(t, e);
    }
  };
}, Lm = function(t, e) {
  return e === void 0 && (e = 0), {
    buffer: t,
    cursor: e
  };
}, Um = function(t) {
  return Cm(t.cursor, t.buffer);
}, Bm = function(t) {
  return t.cursor >= t.buffer.length;
}, Gm = function(t) {
  return T(Um(t), us(function(e) {
    return { value: e, next: { buffer: t.buffer, cursor: t.cursor + 1 } };
  }));
}, qe = function() {
  return qe = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t;
  }, qe.apply(this, arguments);
}, Zs = function(t) {
  return function(e) {
    return kt(t, e, e);
  };
}, Km = function() {
  return function(t) {
    return xt(t);
  };
}, Fm = function(t) {
  return function() {
    return xt(t);
  };
}, Y = function(t) {
  return T(Jm(Zm()), Je(function(e) {
    var r = e[0], n = e[1];
    return t(r) ? ut(r) : Fm(n);
  }));
}, Q = function(t, e) {
  return function(r) {
    return T(t(r), Ir(function(n) {
      return jm(n, [e]);
    }));
  };
}, Zm = function() {
  return function(t) {
    return T(Gm(t), Ks(function() {
      return xt(t);
    }, function(e) {
      var r = e.value, n = e.next;
      return kt(r, n, t);
    }));
  };
}, Wm = function(t, e) {
  return function(r) {
    return T(t(r), Ku(function(n) {
      return T(e(n.value)(n.next), Ku(function(a) {
        return kt(a.value, a.next, r);
      }));
    }));
  };
}, kr = function(t, e) {
  return function(r) {
    var n = t(r);
    return $m(n) || n.left.fatal ? n : T(e()(r), Ir(function(a) {
      return Dm(n.left, a);
    }));
  };
}, Jm = function(t) {
  return function(e) {
    return T(t(e), It(function(r) {
      return qe(qe({}, r), { value: [r.value, e] });
    }));
  };
}, Bl = function(t) {
  return ze(function() {
    return ut(t.empty);
  });
}, Ws = function() {
  return Q(function(t) {
    return Bm(t) ? kt(void 0, t, t) : xt(t);
  }, "end of file");
}, zm = function(t) {
  return T(Js(t), ze(function() {
    return ut([]);
  }));
}, Js = function(t) {
  return T(t, Je(function(e) {
    return Qs(Em(e), function(r) {
      return T(t, z(function(n) {
        return De(wm(n)(r));
      }), ze(function() {
        return ut(de(r));
      }));
    });
  }));
}, Qm = function(t, e) {
  return function(r) {
    return T(t, Je(function() {
      return r;
    }), Ys(function() {
      return e;
    }));
  };
}, Gl = function(t) {
  return Qm(t, t);
}, Ym = function(t) {
  return zm(Y(je(t)));
}, zs = function(t, e) {
  return T(e, z(function() {
    return Sm;
  }), ze(function() {
    return Xm(t, e);
  }));
}, Xm = function(t, e) {
  return T(t, Je(function(r) {
    return Qs(sf(r), function(n) {
      return T(e, z(function() {
        return de(n);
      }), ze(function() {
        return T(t, z(function(a) {
          return De(gm(a)(n));
        }));
      }));
    });
  }));
}, Ot = function(t, e) {
  return function(r) {
    return T(t(r), It(function(n) {
      return qe(qe({}, n), { value: e(n.value) });
    }));
  };
}, Kl = function(t, e) {
  return xr(t, function(r) {
    return Ot(e, r);
  });
}, xr = function(t, e) {
  return Wm(t, e);
}, Qs = function(t, e) {
  var r = function(n) {
    return function(a) {
      return ot(a.value) ? De({ value: a.value.left, stream: a.next }) : de(kt(a.value.right, a.next, n));
    };
  };
  return function(n) {
    return Pm({ value: t, stream: n }, function(a) {
      var s = e(a.value)(a.stream);
      return ot(s) ? de(xt(a.stream, s.left.expected, s.left.fatal)) : r(n)(s.right);
    });
  };
}, ev = function(t, e) {
  return kr(t, e);
}, z = function(t) {
  return function(e) {
    return Ot(e, t);
  };
}, ut = Zs, Je = function(t) {
  return function(e) {
    return xr(e, t);
  };
}, Ys = function(t) {
  return function(e) {
    return xr(e, function(r) {
      return Ot(t(r), function() {
        return r;
      });
    });
  };
}, ze = function(t) {
  return function(e) {
    return ev(e, t);
  };
}, tv = "Parser", rv = function(t) {
  return {
    concat: function(e, r) {
      return Kl(Ot(e, function(n) {
        return function(a) {
          return t.concat(n, a);
        };
      }), r);
    }
  };
}, nv = function(t) {
  return qe(qe({}, rv(t)), { empty: Zs(t.empty) });
}, av = {
  URI: tv,
  map: Ot,
  ap: Kl,
  chain: xr,
  chainRec: Qs
}, Fl = function(t, e, r) {
  var n;
  return Object.assign({}, t, (n = {}, n[e] = r, n));
}, Zl = function(t) {
  return function(e) {
    return T(e, z(function(r) {
      return Fl({}, t, r);
    }));
  };
}, cs = function(t, e) {
  return function(r) {
    return T(r, Je(function(n) {
      return T(e(n), z(function(a) {
        return Fl(n, t, a);
      }));
    }));
  };
}, sv = function(t) {
  return ef(t)(t.empty);
}, iv = Bl(ps), ct = function(t) {
  return Q(Y(function(e) {
    return e === t;
  }), '"'.concat(t, '"'));
}, ov = function(t) {
  return Q(Y(function(e) {
    return e !== t;
  }), 'anything but "'.concat(t, '"'));
}, Xs = function(t) {
  return iv(qt(t));
}, qt = function(t) {
  return T(Js(t), z(function(e) {
    return e.join("");
  }));
}, ei = function(t) {
  return "0123456789".indexOf(t) !== -1;
}, ls = Q(Y(ei), "a digit"), uv = /^\s$/, Wl = function(t) {
  return uv.test(t);
}, Jl = Q(Y(Wl), "a whitespace"), cv = function(t) {
  return t === "_";
}, Vt = function(t) {
  return /[a-z]/.test(t.toLowerCase());
}, zl = function(t) {
  return Vt(t) || ei(t) || cv(t);
};
Q(Y(zl), "a word character");
Q(Y(Vt), "a letter");
var lv = function(t) {
  return t.toLowerCase() !== t.toUpperCase();
};
Q(Y(lv), "an unicode letter");
var Ql = function(t) {
  return Vt(t) && t === t.toUpperCase();
};
Q(Y(Ql), "an upper case letter");
var Yl = function(t) {
  return Vt(t) && t === t.toLowerCase();
};
Q(Y(Yl), "a lower case letter");
Q(Y(je(ei)), "a non-digit");
var Xl = Q(Y(je(Wl)), "a non-whitespace character");
Q(Y(je(zl)), "a non-word character");
Q(Y(je(Vt)), "a non-letter character");
Q(Y(je(Ql)), "anything but an upper case letter");
Q(Y(je(Yl)), "anything but a lower case letter");
var ed = function(t) {
  return Q(av.chainRec(t, function(e) {
    return T(hv(0, e), Ks(function() {
      return ut(de(t));
    }, function(r) {
      return T(ct(r), Je(function() {
        return ut(De(e.slice(1)));
      }));
    }));
  }), JSON.stringify(t));
}, ds = sv(nv(ps)), Rt = Bl(ps), dv = function(t) {
  return Rt(fv(t));
}, fv = function(t) {
  return T(Js(t), z(function(e) {
    return e.join("");
  }));
}, hv = function(t, e) {
  return t >= 0 && t < e.length ? Ct(e.charAt(t)) : Cr;
}, pv = Xs(Jl);
qt(Jl);
Xs(Xl);
qt(Xl);
var yv = function(t) {
  var e = +t;
  return isNaN(e) || t === "" ? Cr : Ct(e);
};
Q(T(ds([Rt(ct("-")), qt(ls)]), z(function(t) {
  return +t;
})), "an integer");
Q(T(ds([Rt(ct("-")), Xs(ls), Rt(ds([ct("."), qt(ls)]))]), Je(function(t) {
  return T(yv(t), Ks(function() {
    return Km();
  }, Zs));
})), "a float");
var mv = Gl(ct('"'))(dv(kr(ed('\\"'), function() {
  return ov('"');
})));
function td(t) {
  return function(e) {
    return e(Lm(t.split("")));
  };
}
const Fu = (t, e) => (r) => ({
  ...r,
  [t]: e(r[t])
}), vv = ["#", ":"], lt = Gl(pv), ti = (t) => (e) => e.join(t), ri = (t) => T(
  Ym((e) => t.includes(e)),
  z(ti(""))
), gv = Ie(
  ri,
  Ys(() => Y(() => !0))
), rd = T(
  mv,
  z((t) => JSON.parse(`"${t}"`))
), _v = T(
  lt(rd),
  ze(
    () => T(
      ri([":", `
`]),
      z(ac)
    )
  )
), bv = T(
  lt(rd),
  ze(
    () => T(
      ri([`
`]),
      z(ac)
    )
  )
), nd = T(
  Rt(ed("#")),
  z(je(sc))
), ad = T(
  lt(nd),
  Zl("commented"),
  cs("key", () => lt(_v)),
  Ys(() => ct(":")),
  cs("value", () => bv)
), Tv = T(
  lt(nd),
  Zl("commented"),
  cs("key", () => kr(
    gv([`
`]),
    () => T(
      zs(Y((t) => !0), Ws()),
      z(Ie(
        Hl,
        ti("")
      ))
    )
  )),
  z(Ie(
    Ll(({ key: t }) => !sc(t))
  ))
), Sv = T(
  zs(lt(ad), Ws())
), Av = T(
  zs(
    kr(
      T(ad, z(Ct)),
      () => T(
        Tv,
        z(Ie(
          us((t) => ({ ...t, value: "" }))
        ))
      )
    ),
    Ws()
  ),
  z(Ie(
    Tm(Ie(
      Ll(Om),
      us((t) => t.value)
    ))
  ))
), Rv = (t) => {
  if (vv.some((n) => t.includes(n)))
    return !0;
  const e = JSON.stringify(t);
  return e.substring(1, e.length - 1).trim() !== t;
}, Zu = (t) => Rv(t) ? JSON.stringify(t) : t, Gg = (t) => T(
  t,
  Im(
    Ie(
      Fu("key", Zu),
      Fu("value", Zu),
      ({ key: e, value: r, active: n }) => n ? `${e}: ${r}` : `# ${e}: ${r}`
    )
  ),
  ti(`
`)
), Ev = (t) => T(
  Av,
  td(t),
  Ir((e) => ({
    message: `Expected ${e.expected.map((r) => `'${r}'`).join(", ")}`,
    expected: e.expected,
    pos: e.input.cursor
  })),
  It(
    ({ value: e }) => T(
      e,
      Dl(
        ({ key: r, value: n, commented: a }) => ({
          active: !a,
          key: r,
          value: n
        })
      )
    )
  )
), Kg = (t) => T(
  Sv,
  td(t),
  Ir((e) => ({
    message: `Expected ${e.expected.map((r) => `'${r}'`).join(", ")}`,
    expected: e.expected,
    pos: e.input.cursor
  })),
  It(
    ({ value: e }) => T(
      e,
      Dl(
        ({ key: r, value: n, commented: a }) => ({
          active: !a,
          key: r,
          value: n
        })
      )
    )
  )
), Fg = Ie(
  Ev,
  It(Hl),
  Fs(() => [])
), wv = f({
  id: ie(u()),
  name: u(),
  variables: b(
    f({
      key: u(),
      value: u()
    })
  )
}), Wu = _({
  initial: !0,
  schema: wv
}), sd = () => Math.random().toString(36).substring(2, 16), id = f({
  v: d(1),
  id: u(),
  name: u(),
  variables: b(
    L([
      f({
        key: u(),
        secret: d(!0)
      }),
      f({
        key: u(),
        value: u(),
        secret: d(!1).catch(!1)
      })
    ])
  )
}), Cv = _({
  initial: !1,
  schema: id,
  up(t) {
    return {
      ...t,
      v: 1,
      id: t.id || sd(),
      variables: t.variables.map((r) => ({
        ...r,
        secret: !1
      }))
    };
  }
}), Iv = id.extend({
  v: d(2),
  variables: b(
    f({
      key: u(),
      initialValue: u(),
      currentValue: u(),
      secret: E()
    })
  )
}), kv = _({
  initial: !1,
  schema: Iv,
  up(t) {
    return {
      ...t,
      v: 2,
      variables: t.variables.map((r) => {
        const { key: n, secret: a } = r;
        return {
          key: n,
          secret: a,
          initialValue: a ? "" : r.value,
          currentValue: a ? "" : r.value
        };
      })
    };
  }
}), Ju = () => {
  const t = "0123456789abcdef";
  let e = "";
  for (let r = 0; r < 36; r++)
    r === 8 || r === 13 || r === 18 || r === 23 ? e += "-" : r === 14 ? e += "4" : r === 19 ? e += t.charAt(8 + Math.floor(Math.random() * 4)) : e += t.charAt(Math.floor(Math.random() * t.length));
  return e;
}, od = [
  // Common
  {
    key: "$guid",
    description: "A v4 style GUID.",
    getValue: Ju
  },
  {
    key: "$timestamp",
    description: "The current UNIX timestamp in seconds.",
    getValue: () => Math.floor(Date.now() / 1e3).toString()
  },
  {
    key: "$isoTimestamp",
    description: "The current ISO timestamp at zero UTC.",
    getValue: () => (/* @__PURE__ */ new Date()).toISOString()
  },
  {
    key: "$randomUUID",
    description: "A random 36-character UUID.",
    getValue: Ju
  },
  // Text, numbers, and colors
  {
    key: "$randomAlphaNumeric",
    description: "A random alphanumeric character.",
    getValue: () => {
      const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      return t.charAt(Math.floor(Math.random() * t.length));
    }
  },
  {
    key: "$randomBoolean",
    description: "A random boolean value.",
    getValue: () => Math.random() < 0.5 ? "true" : "false"
  },
  {
    key: "$randomInt",
    description: "A random integer between 0 and 1000.",
    getValue: () => Math.floor(Math.random() * 1e3).toString()
  },
  {
    key: "$randomColor",
    description: "A random color.",
    getValue: () => {
      const t = ["red", "green", "blue", "yellow", "purple", "orange"];
      return t[Math.floor(Math.random() * t.length)];
    }
  },
  {
    key: "$randomHexColor",
    description: "A random hex value.",
    getValue: () => {
      const t = "0123456789abcdef";
      let e = "#";
      for (let r = 0; r < 6; r++)
        e += t.charAt(
          Math.floor(Math.random() * t.length)
        );
      return e;
    }
  },
  {
    key: "$randomAbbreviation",
    description: "A random abbreviation.",
    getValue: () => {
      const t = [
        "SQL",
        "PCI",
        "JSON",
        "HTML",
        "CSS",
        "JS",
        "TS",
        "API"
      ];
      return t[Math.floor(Math.random() * t.length)];
    }
  },
  // Internet and IP addresses
  {
    key: "$randomIP",
    description: "A random IPv4 address.",
    getValue: () => Array.from(
      { length: 4 },
      () => Math.floor(Math.random() * 256)
    ).join(".")
  },
  {
    key: "$randomIPV6",
    description: "A random IPv6 address.",
    getValue: () => Array.from(
      { length: 8 },
      () => Math.floor(Math.random() * 65536).toString(16).padStart(4, "0")
    ).join(":")
  },
  {
    key: "$randomMACAddress",
    description: "A random MAC address.",
    getValue: () => Array.from(
      { length: 6 },
      () => Math.floor(Math.random() * 256).toString(16).padStart(2, "0")
    ).join(":")
  },
  {
    key: "$randomPassword",
    description: "A random 15-character alphanumeric password.",
    getValue: () => {
      const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let e = "";
      for (let r = 0; r < 15; r++)
        e += t.charAt(
          Math.floor(Math.random() * t.length)
        );
      return e;
    }
  },
  {
    key: "$randomLocale",
    description: "A random two-letter language code (ISO 639-1).",
    getValue: () => {
      const t = ["ny", "sr", "si"];
      return t[Math.floor(Math.random() * t.length)];
    }
  },
  {
    key: "$randomUserAgent",
    description: "A random user agent.",
    getValue: () => {
      const t = [
        "Mozilla/5.0 (Macintosh; U; Intel Mac OS X 10.9.8; rv:15.6) Gecko/20100101 Firefox/15.6.6",
        "Mozilla/5.0 (Windows NT 6.1; WOW64; rv:15.6) Gecko/20100101 Firefox/15.6.6",
        "Mozilla/5.0 (Windows NT 6.1; WOW64; rv:15.6) Gecko/20100101 Firefox/15.6.6"
      ];
      return t[Math.floor(Math.random() * t.length)];
    }
  },
  {
    key: "$randomProtocol",
    description: "A random internet protocol.",
    getValue: () => {
      const t = ["http", "https"];
      return t[Math.floor(Math.random() * t.length)];
    }
  },
  {
    key: "$randomSemver",
    description: "A random semantic version number.",
    getValue: () => Array.from(
      { length: 3 },
      () => Math.floor(Math.random() * 10)
    ).join(".")
  },
  // Names
  {
    key: "$randomFirstName",
    description: "A random first name.",
    getValue: () => {
      const t = [
        "Ethan",
        "Chandler",
        "Megane",
        "John",
        "Jane",
        "Alice",
        "Bob"
      ];
      return t[Math.floor(Math.random() * t.length)];
    }
  },
  {
    key: "$randomLastName",
    description: "A random last name.",
    getValue: () => {
      const t = [
        "Schaden",
        "Schneider",
        "Willms",
        "Doe",
        "Smith",
        "Johnson"
      ];
      return t[Math.floor(Math.random() * t.length)];
    }
  },
  {
    key: "$randomFullName",
    description: "A random first and last name.",
    getValue: () => {
      const t = [
        "Ethan",
        "Chandler",
        "Megane",
        "John",
        "Jane",
        "Alice",
        "Bob"
      ], e = [
        "Schaden",
        "Schneider",
        "Willms",
        "Doe",
        "Smith",
        "Johnson"
      ];
      return `${t[Math.floor(Math.random() * t.length)]} ${e[Math.floor(Math.random() * e.length)]}`;
    }
  },
  {
    key: "$randomNamePrefix",
    description: "A random name prefix.",
    getValue: () => {
      const t = ["Dr.", "Ms.", "Mr.", "Mrs.", "Miss", "Prof."];
      return t[Math.floor(Math.random() * t.length)];
    }
  },
  {
    key: "$randomNameSuffix",
    description: "A random name suffix.",
    getValue: () => {
      const t = ["I", "MD", "DDS", "PhD", "Esq.", "Jr."];
      return t[Math.floor(Math.random() * t.length)];
    }
  },
  // Company names
  {
    key: "$randomCompanyName",
    description: "A random company name.",
    getValue: () => {
      const t = [
        "Nexora",
        "CodeLoom",
        "BitHaven",
        "SynapseWorks",
        "VoltEdge",
        "Elevoria",
        "Bridgent",
        "Verniq",
        "Corevia",
        "Stratigen",
        "Lunova Studio",
        "Pixelora",
        "MuseMind",
        "BrightNest",
        "Auralis",
        "VerdaFlow",
        "BloomShift",
        "PureTrek",
        "EcoVerse",
        "ReLeaf Labs"
      ];
      return t[Math.floor(Math.random() * t.length)];
    }
  },
  // Addresses
  {
    key: "$randomCity",
    description: "A random city name.",
    getValue: () => {
      const t = [
        "New York",
        "Los Angeles",
        "Chicago",
        "Houston",
        "Phoenix",
        "Philadelphia"
      ];
      return t[Math.floor(Math.random() * t.length)];
    }
  },
  // profession
  {
    key: "$randomJobArea",
    description: "A random job area.",
    getValue: () => {
      const t = [
        "Mobility",
        "Intranet",
        "Configuration",
        "Development",
        "Design",
        "Testing"
      ];
      return t[Math.floor(Math.random() * t.length)];
    }
  },
  {
    key: "$randomJobDescriptor",
    description: "A random job descriptor.",
    getValue: () => {
      const t = [
        "Forward",
        "Corporate",
        "Senior",
        "Junior",
        "Lead",
        "Principal"
      ];
      return t[Math.floor(Math.random() * t.length)];
    }
  },
  {
    key: "$randomJobTitle",
    description: "A random job title.",
    getValue: () => {
      const t = [
        "International Creative Liaison",
        "Global Branding Officer",
        "Dynamic Data Specialist",
        "Internal Communications Consultant",
        "Productivity Analyst",
        "Regional Applications Developer"
      ];
      return t[Math.floor(Math.random() * t.length)];
    }
  },
  {
    key: "$randomJobType",
    description: "A random job type.",
    getValue: () => {
      const t = ["Supervisor", "Manager", "Coordinator", "Director"];
      return t[Math.floor(Math.random() * t.length)];
    }
  }
  // TODO: Support various other predefined variables
], xv = f({
  v: Se()
}), Zg = Ae({
  latestVersion: 2,
  versionMap: {
    0: Wu,
    1: Cv,
    2: kv
  },
  getVersion(t) {
    const e = xv.safeParse(t);
    return e.success ? e.data.v : Wu.schema.safeParse(t).success ? 0 : null;
  }
}), tr = /<<([^>]*)>>/g, rr = 10, ud = "ENV_EXPAND_LOOP", zu = 2, cd = (t) => t.currentValue || t.initialValue || "";
function Ov(t, e, r = !0) {
  let n = t, a = 0;
  for (; n.match(tr) != null && a <= rr; )
    n = n.replace(tr, (s) => {
      const i = s.replace(/[<>]/g, ""), o = od.find(
        (c) => c.key === i
      );
      if (o)
        return o.getValue();
      const l = e.find((c) => c.key === i);
      return l && "currentValue" in l ? cd(l) : r ? s : "";
    }), a++;
  return a > rr ? De(ud) : de(n);
}
const Wg = (t, e, r = !0) => T(
  Ov(t, e, r),
  Fs(() => t)
);
function qv(t, e, r = !1, n = !1, a = !1) {
  if (!e || !t)
    return de(t);
  let s = t, i = 0, o = !1;
  for (; s.match(tr) != null && i <= rr && !o; ) {
    const l = decodeURI(encodeURI(s)).replace(
      tr,
      (c, h) => {
        const y = od.find(
          (k) => k.key === h
        );
        if (y)
          return y.getValue();
        const A = e.find((k) => k && k.key === h);
        if (A && "currentValue" in A) {
          const k = cd(A);
          return A.secret && n ? (o = !0, `<<${h}>>`) : A.secret && r ? "*".repeat(k.length) : k;
        }
        return a ? `<<${h}>>` : "";
      }
    );
    if (l === s)
      break;
    s = l, i++;
  }
  return i > rr ? De(ud) : de(s);
}
const Jg = (t, e, r = !1, n = !1, a = !1) => T(
  qv(
    t,
    e,
    r,
    n,
    a
  ),
  Fs(() => t)
), Vv = (t) => ({
  key: t.key,
  initialValue: t.initialValue ?? t.value ?? "",
  currentValue: t.currentValue ?? t.value ?? "",
  secret: t.secret ?? !1
}), zg = (t) => {
  if (t.v && t.v === zu) return t;
  const e = t.id || sd(), r = t.name ?? "Untitled", n = (t.variables ?? []).map(Vv);
  return {
    v: zu,
    id: e,
    name: r,
    variables: n
  };
}, Pv = b(
  L([
    f({
      key: u(),
      value: u(),
      secret: d(!1)
    }),
    f({
      key: u(),
      secret: d(!0)
    }),
    f({
      key: u(),
      value: u()
    })
  ])
), Qu = _({
  initial: !0,
  schema: Pv
}), ld = f({
  v: d(1),
  variables: b(
    L([
      f({
        key: u(),
        secret: d(!0)
      }),
      f({
        key: u(),
        value: u(),
        secret: d(!1)
      })
    ])
  )
}), Nv = _({
  initial: !1,
  schema: ld,
  up(t) {
    return {
      v: 1,
      variables: t.map((r) => "value" in r ? {
        key: r.key,
        value: r.value,
        secret: !1
      } : {
        key: r.key,
        secret: !0
      })
    };
  }
}), $v = ld.extend({
  v: d(2),
  variables: b(
    f({
      key: u(),
      initialValue: u(),
      currentValue: u(),
      secret: E()
    })
  )
}), Mv = _({
  initial: !1,
  schema: $v,
  up(t) {
    return {
      ...t,
      v: 2,
      variables: t.variables.map((r) => {
        const { key: n, secret: a } = r;
        return {
          key: n,
          secret: a ?? !1,
          initialValue: r.secret ? "" : r.value,
          currentValue: r.secret ? "" : r.value
        };
      })
    };
  }
}), jv = f({
  v: Se()
}), Dv = 2, Qg = Ae({
  latestVersion: Dv,
  versionMap: {
    0: Qu,
    1: Nv,
    2: Mv
  },
  getVersion(t) {
    const e = jv.safeParse(t);
    return e.success ? e.data.v : Qu.schema.safeParse(t).success ? 0 : null;
  }
}), Yg = 2;
async function Hv(t = 6) {
  const e = new Uint8Array(t);
  return crypto.getRandomValues(e), Array.from(e).map((r) => r.toString(16).padStart(2, "0")).join("").substring(0, t);
}
function Lv(t) {
  const r = new TextEncoder().encode(t);
  return crypto.subtle.digest("SHA-256", r);
}
function Uv(t) {
  const r = new TextEncoder().encode(t);
  return crypto.subtle.digest("SHA-1", r);
}
async function Bv(t, e) {
  return e === "sha256" ? Lv(t) : Uv(t);
}
async function Gv(t, e, r) {
  const n = new TextEncoder(), a = n.encode(t), s = n.encode(e), i = r === "sha256" ? "SHA-256" : "SHA-1", o = await crypto.subtle.importKey(
    "raw",
    a,
    {
      name: "HMAC",
      hash: { name: i }
    },
    !1,
    ["sign"]
  ), l = await crypto.subtle.sign("HMAC", o, s);
  return btoa(String.fromCharCode.apply(null, [...new Uint8Array(l)]));
}
function rt(t) {
  return t.replace(/\r\n/g, `
`).replace(/\r/g, `
`);
}
async function Kv(t, e) {
  if (!t) return "";
  if (t instanceof FormData)
    if (e === "multipart/form-data") {
      const r = [];
      return t.forEach((n, a) => {
        typeof n == "string" ? r.push(`${a}=${n}`) : r.push(`${a}=${n instanceof File ? n.name : "blob"}`);
      }), rt(r.join("&"));
    } else {
      const r = [];
      return t.forEach((n, a) => {
        typeof n == "string" && r.push(`${a}=${encodeURIComponent(n)}`);
      }), rt(r.join("&"));
    }
  if (t instanceof Blob)
    try {
      const r = await t.text();
      return rt(r);
    } catch (r) {
      return console.error("Failed to read blob content", r), "";
    }
  if (e.includes("application/json") && typeof t == "string")
    try {
      const r = JSON.parse(t);
      return rt(JSON.stringify(r));
    } catch {
      return rt(t.toString());
    }
  return rt(t.toString());
}
async function Xg(t) {
  const e = t.timestamp !== void 0 && t.timestamp !== null ? t.timestamp : Math.floor(Date.now() / 1e3), r = t.nonce && t.nonce !== "" ? t.nonce : await Hv(), n = new URL(t.url), a = n.hostname, s = n.port || (n.protocol === "https:" ? "443" : "80"), i = n.pathname + n.search, o = {
    ts: e,
    nonce: r,
    method: t.method.toUpperCase(),
    resource: i,
    host: a,
    port: s,
    hash: "",
    ext: t.ext || ""
  };
  if (t.includePayloadHash && t.payload)
    try {
      const y = t.contentType || "text/plain", A = await Kv(t.payload, y), k = `hawk.1.payload
${y}
${A}
`, F = await Bv(k, t.algorithm);
      o.hash = btoa(
        String.fromCharCode.apply(null, [...new Uint8Array(F)])
      );
    } catch (y) {
      console.error("Error calculating payload hash:", y);
    }
  const l = `hawk.1.header
${o.ts}
${o.nonce}
${o.method}
${o.resource}
${o.host}
${o.port}
${o.hash}
${o.ext}
`, c = await Gv(t.key, l, t.algorithm), h = [
    `Hawk id="${t.id}"`,
    `ts="${o.ts}"`,
    `nonce="${o.nonce}"`,
    `mac="${c}"`
  ];
  return t.ext && t.ext !== "" && h.push(`ext="${t.ext}"`), t.app && t.app !== "" && h.push(`app="${t.app}"`), t.dlg && t.dlg !== "" && h.push(`dlg="${t.dlg}"`), o.hash !== "" && h.push(`hash="${o.hash}"`), h.join(", ");
}
async function e_(t) {
  const e = new TextEncoder();
  new TextDecoder();
  const r = t.timestamp || Math.floor(Date.now() / 1e3).toString(), n = t.nonce || crypto.randomUUID(), a = t.host || new URL(t.url).host, s = await crypto.subtle.importKey(
    "raw",
    e.encode(t.clientSecret),
    { name: "HMAC", hash: "SHA-256" },
    !1,
    ["sign"]
  );
  await crypto.subtle.sign(
    "HMAC",
    s,
    e.encode(r)
  );
  let i = "";
  if (t.body) {
    const y = await crypto.subtle.digest(
      "SHA-256",
      e.encode(t.body)
    );
    i = Array.from(new Uint8Array(y)).map((A) => A.toString(16).padStart(2, "0")).join("");
  }
  const o = `${t.method} ${t.url} ${a} ${r} ${n} ${i}`, l = await crypto.subtle.sign(
    "HMAC",
    s,
    e.encode(o)
  ), c = btoa(
    String.fromCharCode(...new Uint8Array(l))
  );
  return `EG1-HMAC-SHA256 client_token=${t.clientToken};access_token=${t.accessToken};timestamp=${r};nonce=${n};signature=${c}`;
}
const dd = new TextEncoder(), Yu = new TextDecoder();
new TextDecoder("utf-8", { fatal: !0 });
function Fv(...t) {
  const e = t.reduce((a, { length: s }) => a + s, 0), r = new Uint8Array(e);
  let n = 0;
  for (const a of t)
    r.set(a, n), n += a.length;
  return r;
}
function fs(t) {
  const e = new Uint8Array(t.length);
  for (let r = 0; r < t.length; r++) {
    const n = t.charCodeAt(r);
    if (n > 127)
      throw new TypeError("non-ASCII string encountered in encode()");
    e[r] = n;
  }
  return e;
}
const Ht = (t, e = "algorithm.name") => new TypeError(`CryptoKey does not support this operation, its ${e} must be ${t}`);
function Zv(t, e) {
  if (!t.usages.includes(e))
    throw new TypeError(`CryptoKey does not support this operation, its usages must include ${e}.`);
}
function Wv(t, e) {
  const { modulusLength: r } = e.algorithm;
  if (typeof r != "number" || r < 2048)
    throw new TypeError(`${t} requires key modulusLength to be 2048 bits or larger`);
}
function Jv(t, e, r) {
  const n = t.algorithm;
  if (n.name !== e.name)
    throw Ht(e.name);
  if (e.hash && n.hash?.name !== e.hash)
    throw Ht(e.hash, "algorithm.hash");
  if (e.namedCurve && n.namedCurve !== e.namedCurve)
    throw Ht(e.namedCurve, "algorithm.namedCurve");
  if (e.length !== void 0 && n.length !== e.length)
    throw Ht(e.length, "algorithm.length");
  Zv(t, r);
}
function zv(t, e, ...r) {
  if (r.length > 2) {
    const n = r.pop();
    t += `one of type ${r.join(", ")}, or ${n}.`;
  } else r.length === 2 ? t += `one of type ${r[0]} or ${r[1]}.` : t += `of type ${r[0]}.`;
  return e == null ? t += ` Received ${e}` : typeof e == "function" && e.name ? t += ` Received function ${e.name}` : typeof e == "object" && e != null && e.constructor?.name && (t += ` Received an instance of ${e.constructor.name}`), t;
}
const Lt = (t, e, ...r) => zv(`Key for the ${t} algorithm must be `, e, ...r);
class ni extends Error {
  static code = "ERR_JOSE_GENERIC";
  code = "ERR_JOSE_GENERIC";
  constructor(e, r) {
    super(e, r), this.name = this.constructor.name, Error.captureStackTrace?.(this, this.constructor);
  }
}
class nr extends ni {
  static code = "ERR_JOSE_NOT_SUPPORTED";
  code = "ERR_JOSE_NOT_SUPPORTED";
}
class dt extends ni {
  static code = "ERR_JWS_INVALID";
  code = "ERR_JWS_INVALID";
}
class Qv extends ni {
  static code = "ERR_JWT_INVALID";
  code = "ERR_JWT_INVALID";
}
const fd = (t) => {
  if (t?.[Symbol.toStringTag] === "CryptoKey")
    return !0;
  try {
    return t instanceof CryptoKey;
  } catch {
    return !1;
  }
}, Yv = (t) => t?.[Symbol.toStringTag] === "KeyObject", Xv = (t) => fd(t) || Yv(t);
function eg(t) {
  if (Uint8Array.prototype.toBase64)
    return t.toBase64();
  const e = 32768, r = [];
  for (let n = 0; n < t.length; n += e)
    r.push(String.fromCharCode.apply(null, t.subarray(n, n + e)));
  return btoa(r.join(""));
}
function tg(t) {
  if (Uint8Array.fromBase64)
    return Uint8Array.fromBase64(t);
  const e = atob(t), r = new Uint8Array(e.length);
  for (let n = 0; n < e.length; n++)
    r[n] = e.charCodeAt(n);
  return r;
}
const Za = "The input to be decoded is not correctly encoded.";
function rg(t) {
  if (Uint8Array.fromBase64)
    try {
      return Uint8Array.fromBase64(typeof t == "string" ? t : Yu.decode(t), {
        alphabet: "base64url"
      });
    } catch (r) {
      throw new TypeError(Za, { cause: r });
    }
  let e = t;
  if (e instanceof Uint8Array && (e = Yu.decode(e)), e.includes("+") || e.includes("/"))
    throw new TypeError(Za);
  e = e.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return tg(e);
  } catch {
    throw new TypeError(Za);
  }
}
function ai(t) {
  let e = t;
  return typeof e == "string" && (e = dd.encode(e)), Uint8Array.prototype.toBase64 ? e.toBase64({ alphabet: "base64url", omitPadding: !0 }) : eg(e).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
function si(t) {
  if (typeof t != "object" || t === null || Object.prototype.toString.call(t) !== "[object Object]")
    return !1;
  const e = Object.getPrototypeOf(t);
  return e === null || Object.getPrototypeOf(e) === null;
}
function ng(t, e) {
  if (t !== void 0)
    throw new TypeError(`${e} can only be called once`);
}
async function ag(t, e) {
  if (e.kty === "RSA" && "oth" in e && e.oth !== void 0)
    throw new nr('RSA JWK "oth" (Other Primes Info) Parameter value is not supported');
  if (!t.kty.includes(e.kty))
    throw new nr('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
  const r = t.resolve?.({ kty: e.kty, crv: e.crv }) ?? t.subtle, n = !!(e.d || e.priv), a = { ...e };
  return a.kty !== "AKP" && delete a.alg, delete a.use, crypto.subtle.importKey("jwk", a, r, e.ext ?? !n, e.key_ops ?? t.usages[n ? 1 : 0]);
}
function sg(t) {
  return { __proto__: null, ...t };
}
function ig(t) {
  const e = sg(t);
  if (e.ext !== void 0 && typeof e.ext != "boolean")
    throw new TypeError('"ext" (Extractable) Parameter must be a boolean');
  if (e.key_ops !== void 0) {
    const r = e.key_ops, n = Array.isArray(r) ? [...r] : void 0;
    if (!n || n.some((a) => typeof a != "string") || new Set(n).size !== n.length)
      throw new TypeError('"key_ops" (Key Operations) Parameter must be an array of unique strings');
    e.key_ops = n;
  }
  return e;
}
const Wa = (t) => t[Symbol.toStringTag], og = (t, e, r) => {
  const { alg: n } = t;
  if (e.use !== void 0 && e.use !== "sig")
    throw new TypeError('Invalid key for this operation, its "use" must be "sig" when present');
  if (e.alg !== void 0 && e.alg !== n)
    throw new TypeError(`Invalid key for this operation, its "alg" must be "${n}" when present`);
  if (Array.isArray(e.key_ops)) {
    const a = r;
    if (!e.key_ops.includes(a))
      throw new TypeError(`Invalid key for this operation, its "key_ops" must include "${a}" when present`);
  }
};
function ug(t, e, r) {
  const { alg: n, secret: a } = t;
  if (a && e instanceof Uint8Array)
    return [hd, e];
  if (si(e)) {
    const s = ig(e);
    if (typeof s.kty != "string")
      throw new TypeError(a ? Lt(n, e, "CryptoKey", "KeyObject", "JSON Web Key", "Uint8Array") : Lt(n, e, "CryptoKey", "KeyObject", "JSON Web Key"));
    if (!(a ? s.kty === "oct" && typeof s.k == "string" : s.kty !== "oct" && (s.kty === "AKP" && typeof s.priv == "string" || typeof s.d == "string")))
      throw new TypeError(a ? 'JSON Web Key for symmetric algorithms must have JWK "kty" (Key Type) equal to "oct" and the JWK "k" (Key Value) present' : "JSON Web Key for this operation must be a private JWK");
    return og(t, s, r), [md, e, s];
  }
  if (!Xv(e))
    throw new TypeError(a ? Lt(n, e, "CryptoKey", "KeyObject", "JSON Web Key", "Uint8Array") : Lt(n, e, "CryptoKey", "KeyObject", "JSON Web Key"));
  if (a) {
    if (e.type !== "secret")
      throw new TypeError(`${Wa(e)} instances for symmetric algorithms must be of type "secret"`);
  } else {
    if (e.type === "secret")
      throw new TypeError(`${Wa(e)} instances for asymmetric algorithms must not be of type "secret"`);
    const s = "private";
    if ((e.type === "public" || e.type === "private") && e.type !== s) {
      const i = "signing";
      throw new TypeError(`${Wa(e)} instances for asymmetric algorithm ${i} must be of type "${s}"`);
    }
  }
  return fd(e) ? [pd, e] : [yd, e];
}
const hd = 0, pd = 1, yd = 2, md = 3;
let Ja;
const cg = {
  __proto__: null,
  prime256v1: "P-256",
  secp384r1: "P-384",
  secp521r1: "P-521"
};
function ar(t, e, r) {
  Ja ||= /* @__PURE__ */ new WeakMap();
  const n = Ja.get(t);
  return r && (n ? n[e] = r : Ja.set(t, { [e]: r })), r ?? n?.[e];
}
const Xu = async (t, e, r) => ar(t, r.alg) ?? ar(t, r.alg, await ag(r, { ...e, alg: r.alg })), lg = (t, e) => {
  const r = ar(t, e.alg);
  if (r)
    return r;
  const n = t.type === "public", a = e.usages[n ? 0 : 1], { asymmetricKeyType: s } = t, i = cg[t.asymmetricKeyDetails?.namedCurve], o = e.resolve?.({ crv: i, asymmetricKeyType: s }) ?? e.subtle;
  return ar(t, e.alg, t.toCryptoKey(o, n, a));
};
async function dg(t, e, r) {
  const n = ug(t, e, r);
  switch (n[0]) {
    case hd:
    case pd:
      return n[1];
    case md: {
      const a = n[1], s = n[2];
      if (s.kty === "oct")
        return rg(s.k);
      if (!Object.isFrozen(a)) {
        const { key_ops: i } = a;
        Array.isArray(i) && Object.freeze(i), Object.freeze(a);
      }
      return Xu(a, s, t);
    }
    case yd: {
      const a = n[1];
      return a.type === "secret" ? a.export() : "toCryptoKey" in a && typeof a.toCryptoKey == "function" ? lg(a, t) : Xu(a, a.export({ format: "jwk" }), t);
    }
  }
}
function fg(t) {
  const e = { __proto__: null };
  for (const r in t)
    e[r] = { ...t[r], alg: r };
  return e;
}
const hg = { __proto__: null, b64: !0 };
function pg(t, e) {
  const { crit: r } = e ?? {};
  if (Array.isArray(r) && new Set(r).size !== r.length)
    throw new t('"crit" (Critical) Header Parameter MUST NOT contain duplicate values');
}
function yg(t, e, r, n, a) {
  if (a.crit !== void 0 && n?.crit === void 0)
    throw new t('"crit" (Critical) Header Parameter MUST be integrity protected');
  if (!n || n.crit === void 0)
    return [];
  if (!Array.isArray(n.crit) || n.crit.length === 0 || n.crit.some((i) => typeof i != "string" || i.length === 0))
    throw new t('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
  const s = r === void 0 ? e : { __proto__: null, ...r, ...e };
  for (const i of n.crit) {
    if (!(i in s))
      throw new nr(`Extension Header Parameter "${i}" is not recognized`);
    if (!Object.hasOwn(a, i) || a[i] === void 0)
      throw new t(`Extension Header Parameter "${i}" is missing`);
    if (s[i] && (!Object.hasOwn(n, i) || n[i] === void 0))
      throw new t(`Extension Header Parameter "${i}" MUST be integrity protected`);
  }
  return n.crit;
}
function mg(t, e) {
  if (e.includes("b64")) {
    const r = t.b64;
    if (typeof r != "boolean")
      throw new dt('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
    return r;
  }
  return !0;
}
function vg(t, e) {
  let r, n;
  try {
    r = JSON.stringify(e), n = JSON.parse(r);
  } catch (a) {
    throw new t("JOSE Header is not valid JSON", { cause: a });
  }
  if (!si(n))
    throw new t("JOSE Header is not a JSON object");
  return [n, r];
}
async function gg(t, e, r) {
  return e instanceof Uint8Array ? crypto.subtle.importKey("raw", e, t.subtle, !1, [
    r
  ]) : (Jv(e, t.subtle, r), t.minRsaBits && Wv(t.alg, e), e);
}
async function _g(t, e, r) {
  const n = await gg(t, e, "sign"), a = await crypto.subtle.sign(t.signing, n, r);
  return new Uint8Array(a);
}
const Pt = [["verify"], ["sign"]];
function za(t) {
  const e = { name: "HMAC", hash: `SHA-${t}` };
  return { kty: ["oct"], secret: !0, subtle: e, signing: e, usages: Pt };
}
function nt(t, e) {
  const n = { name: e ? "RSA-PSS" : "RSASSA-PKCS1-v1_5", hash: `SHA-${t}` };
  return {
    kty: ["RSA"],
    subtle: n,
    signing: e ? { ...n, saltLength: e } : n,
    usages: Pt,
    minRsaBits: 2048
  };
}
function Qa(t, e) {
  return {
    kty: ["EC"],
    crv: t,
    subtle: { name: "ECDSA", namedCurve: t },
    signing: { name: "ECDSA", hash: `SHA-${e}` },
    usages: Pt
  };
}
function ec() {
  const t = { name: "Ed25519" };
  return {
    kty: ["OKP"],
    crv: "Ed25519",
    subtle: t,
    signing: t,
    usages: Pt
  };
}
function Ya(t) {
  const r = { name: `ML-DSA-${t}` };
  return {
    kty: ["AKP"],
    subtle: r,
    signing: r,
    usages: Pt
  };
}
const bg = fg({
  HS256: za(256),
  HS384: za(384),
  HS512: za(512),
  RS256: nt(256),
  RS384: nt(384),
  RS512: nt(512),
  PS256: nt(256, 32),
  PS384: nt(384, 48),
  PS512: nt(512, 64),
  ES256: Qa("P-256", 256),
  ES384: Qa("P-384", 384),
  ES512: Qa("P-521", 512),
  EdDSA: ec(),
  Ed25519: ec(),
  "ML-DSA-44": Ya(44),
  "ML-DSA-65": Ya(65),
  "ML-DSA-87": Ya(87)
});
function Tg(t) {
  const e = typeof t == "string" ? bg[t] : void 0;
  if (!e)
    throw new nr(`alg ${t} is not supported either by JOSE or your javascript runtime`);
  return e;
}
const sr = (t) => Math.floor(t.getTime() / 1e3), Sg = {
  s: 1,
  m: 60,
  h: 3600,
  d: 86400,
  w: 604800,
  y: 31557600
}, Ag = /^(\+|\-)? ?(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)(?: (ago|from now))?$/i;
function Xa() {
  throw new TypeError("Invalid time period format");
}
function vd(t) {
  typeof t != "string" && Xa();
  const e = Ag.exec(t);
  (!e || e[4] && e[1]) && Xa();
  const r = parseFloat(e[2]), n = Math.round(r * Sg[e[3][0].toLowerCase()]);
  return Number.isFinite(n) || Xa(), e[1] === "-" || e[4] === "ago" ? -n : n;
}
function hs(t, e) {
  if (!Number.isFinite(e))
    throw new TypeError(`Invalid ${t} input`);
  return e;
}
function es(t, e) {
  if (typeof e != "string")
    throw new TypeError(`"${t}" claim must be a string`);
}
function Rg(t) {
  if (typeof t != "string" && (!Array.isArray(t) || Array.from(t).some((e) => typeof e != "string")))
    throw new TypeError('"aud" claim must be a string or an array of strings');
}
function ts(t, e) {
  return typeof t == "number" ? hs(e, t) : t instanceof Date ? hs(e, sr(t)) : sr(/* @__PURE__ */ new Date()) + vd(t);
}
let gd;
function we(t) {
  return gd.get(t);
}
function Eg(t) {
  const e = we(t);
  for (const r of ["iat", "nbf", "exp"]) {
    const n = e[r];
    if (typeof n == "number" && !Number.isFinite(n))
      throw new TypeError(`"${r}" claim must be a finite number`);
  }
  return dd.encode(JSON.stringify(e));
}
class wg {
  constructor(e = {}) {
    if (!si(e))
      throw new TypeError("JWT Claims Set MUST be an object");
    (gd ||= /* @__PURE__ */ new WeakMap()).set(this, structuredClone(e));
  }
  setIssuer(e) {
    return es("iss", e), we(this).iss = e, this;
  }
  setSubject(e) {
    return es("sub", e), we(this).sub = e, this;
  }
  setAudience(e) {
    return Rg(e), we(this).aud = e, this;
  }
  setJti(e) {
    return es("jti", e), we(this).jti = e, this;
  }
  setNotBefore(e) {
    return we(this).nbf = ts(e, "setNotBefore"), this;
  }
  setExpirationTime(e) {
    return we(this).exp = ts(e, "setExpirationTime"), this;
  }
  setIssuedAt(e) {
    const r = we(this);
    return e === void 0 ? r.iat = sr(/* @__PURE__ */ new Date()) : typeof e == "string" ? r.iat = hs("setIssuedAt", sr(/* @__PURE__ */ new Date()) + vd(e)) : r.iat = ts(e, "setIssuedAt"), this;
  }
}
function Cg(t) {
  if (t === void 0)
    return [void 0, ""];
  const e = vg(dt, t);
  return [e[0], ai(e[1])];
}
function Ig(t, e, r) {
  return pg(dt, t), mg(t, yg(dt, hg, r, t, e));
}
function kg(t) {
  const e = t.alg;
  if (typeof e != "string" || !e)
    throw new dt('JWS "alg" (Algorithm) Header Parameter missing or invalid');
  return Tg(e);
}
async function xg(t, e, r, n) {
  const a = Fv(fs(t), fs("."), e), s = await dg(r, n, "sign");
  return ai(await _g(r, s, a));
}
async function Og(t, e, r, n, a) {
  const [s, i] = Cg(e);
  if (!s)
    throw new dt("either setProtectedHeader or setUnprotectedHeader must be called before #sign()");
  Ig(s, s, r) || a();
  const l = kg(s), c = ai(t), h = await xg(i, fs(c), l, n);
  return `${i}.${c}.${h}`;
}
const qg = wg;
class Vg extends qg {
  #e;
  setProtectedHeader(e) {
    return ng(this.#e, "setProtectedHeader"), this.#e = e, this;
  }
  async sign(e, r) {
    return Og(Eg(this), this.#e, r?.crit, e, () => {
      throw new Qv("JWTs MUST NOT use unencoded payload");
    });
  }
}
async function t_(t) {
  const {
    algorithm: e,
    secret: r,
    privateKey: n,
    payload: a,
    jwtHeaders: s,
    isSecretBase64Encoded: i
  } = t;
  let o = {}, l = {};
  try {
    const c = a?.trim() || "{}";
    c === "" ? o = {} : o = JSON.parse(c);
  } catch (c) {
    return console.error("Failed to parse JWT payload JSON:", c), console.error("Payload value:", a), null;
  }
  try {
    const c = s?.trim() || "{}";
    c === "" ? l = {} : l = JSON.parse(c);
  } catch (c) {
    return console.error("Failed to parse JWT headers JSON:", c), console.error("Headers value:", s), null;
  }
  try {
    let c;
    if (e.startsWith("RS") || e.startsWith("ES") || e.startsWith("PS")) {
      if (!n)
        return console.error("Private key is required for RSA/ECDSA algorithms"), null;
      c = new TextEncoder().encode(n);
    } else {
      if (!r)
        return console.error("Secret is required for HMAC algorithms"), null;
      c = i ? Uint8Array.from(Buffer.from(r, "base64")) : new TextEncoder().encode(r);
    }
    return await new Vg(o).setProtectedHeader({
      alg: e,
      ...l
    }).sign(c);
  } catch (c) {
    return console.error("Error generating JWT token:", c), null;
  }
}
const r_ = f({
  name: u(),
  // Cookie name
  value: u(),
  // Cookie value
  domain: u(),
  // Domain the cookie belongs to
  path: u(),
  // Path scope of the cookie (default: "/")
  expires: u().optional(),
  // Expiration date in ISO format, null for session cookies
  maxAge: Se().optional(),
  // Maximum age in seconds, null if not set
  httpOnly: E(),
  // Whether cookie is HTTP-only (not accessible via JavaScript)
  secure: E(),
  // Whether cookie should only be sent over HTTPS
  sameSite: W(["None", "Lax", "Strict"]),
  // SameSite attribute for CSRF protection
  // RFC 6265 5.3 host-only-flag. True when the Set-Cookie carried no Domain
  // attribute, so the cookie applies only to the exact request host and never
  // to its subdomains. Optional and defaulted absent for backward compatibility
  // with jars persisted before the flag existed.
  hostOnly: E().optional()
});
export {
  xp as AuthCodeGrantTypeParams,
  Op as ClientCredentialsGrantTypeParams,
  ym as CollectionSchemaVersion,
  im as CollectionVariable,
  r_ as CookieSchema,
  Zg as Environment,
  zu as EnvironmentSchemaVersion,
  Jc as FormDataKeyValue,
  Dv as GLOBAL_ENV_LATEST_VERSION,
  Us as GQLHeader,
  Cl as GQL_REQ_SCHEMA_VERSION,
  Qg as GlobalEnvironment,
  Yg as GlobalEnvironmentSchemaVersion,
  od as HOPP_SUPPORTED_PREDEFINED_VARIABLES,
  K as HoppCollection,
  Bs as HoppGQLAuth,
  pt as HoppGQLAuthAPIKey,
  Er as HoppGQLAuthAWSSignature,
  Ne as HoppGQLAuthBasic,
  $e as HoppGQLAuthBearer,
  Me as HoppGQLAuthInherit,
  Pe as HoppGQLAuthNone,
  al as HoppGQLAuthOAuth2,
  Gs as HoppGQLRequest,
  Py as HoppGQLRequestResponse,
  Ny as HoppGQLRequestResponses,
  ky as HoppGQLResponseOriginalRequest,
  Ar as HoppRESTAuth,
  Ve as HoppRESTAuthAPIKey,
  Ze as HoppRESTAuthAWSSignature,
  Ms as HoppRESTAuthAkamaiEdgeGrid,
  pe as HoppRESTAuthBasic,
  ye as HoppRESTAuthBearer,
  wt as HoppRESTAuthDigest,
  $s as HoppRESTAuthHAWK,
  me as HoppRESTAuthInherit,
  tl as HoppRESTAuthJWT,
  he as HoppRESTAuthNone,
  al as HoppRESTAuthOAuth2,
  Tr as HoppRESTHeaders,
  Os as HoppRESTParams,
  Ns as HoppRESTReqBody,
  Rr as HoppRESTRequest,
  Gp as HoppRESTRequestResponse,
  sl as HoppRESTRequestResponses,
  xs as HoppRESTRequestVariables,
  Mp as HoppRESTResponseOriginalRequest,
  Vp as ImplicitOauthFlowParams,
  Oe as OAuth2AdvancedParam,
  nl as OAuth2AuthRequestParam,
  qp as PasswordGrantTypeParams,
  yl as RESTReqSchemaVersion,
  Ng as ValidContentTypesList,
  e_ as calculateAkamaiEdgeGridHeader,
  Xg as calculateHawkHeader,
  t_ as generateJWTToken,
  We as generateUniqueRefId,
  Hy as getDefaultGQLRequest,
  dy as getDefaultRESTRequest,
  $g as isEqualHoppRESTRequest,
  Ug as isGQLRequest,
  Dg as isHoppRESTRequest,
  Bg as isRESTRequest,
  uy as knownContentTypes,
  mm as makeCollection,
  Lg as makeGQLRequest,
  Hg as makeHoppGQLResponseOriginalRequest,
  Pg as makeHoppRESTResponseOriginalRequest,
  jg as makeRESTRequest,
  Wg as parseBodyEnvVariables,
  Ov as parseBodyEnvVariablesE,
  Fg as parseRawKeyValueEntries,
  Ev as parseRawKeyValueEntriesE,
  Jg as parseTemplateString,
  qv as parseTemplateStringE,
  Gg as rawKeyValueEntriesToString,
  Mg as safelyExtractRESTRequest,
  Kg as strictParseRawKeyValueEntriesE,
  Ly as translateToGQLRequest,
  vm as translateToNewCollection,
  zg as translateToNewEnvironment,
  Vv as translateToNewEnvironmentVariables,
  fy as translateToNewRequest
};
